import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /** A specific date, transmitted as an [ISO-8061 Date](https://en.wikipedia.org/wiki/ISO_8601#Dates) string. */
  ISODate: string;
  /**
   * A specific date and time (including UTC offset), transmitted as an
   * [ISO-8061 combined date and time representation](https://en.wikipedia.org/wiki/ISO_8601#Combined_date_and_time_representations)
   * string.
   */
  ISODatetime: string;
  /** A specific duration of time, transmitted as an [ISO-8061 Duration](https://en.wikipedia.org/wiki/ISO_8601#Durations) string */
  ISODuration: string;
};

export type AccountSetupAddPhoneNumberInput = {
  /** User's phone number to add */
  phoneNumber: Scalars['String'];
};

export type AccountSetupDeletePhoneNumberInput = {
  /** User's phone number to delete */
  phoneNumber: Scalars['String'];
};

/** Mutations for common account setup functions */
export type AccountSetupOp = {
  __typename?: 'AccountSetupOp';
  /** Adds a phone number to the currently logged in account if it does not yet exist */
  addPhoneNumber: PhoneNumberResult;
  /**
   * Removes the specified phone number from the user's account, returns a failure if it
   * doesn't exist
   */
  deletePhoneNumber: PhoneNumberResult;
  /** Delete the account for the authenticated user as determined by the token used to access the API. */
  deleteUserAccount: Scalars['Boolean'];
  /** Sends verification code to the user's email */
  sendEmailVerificationCode: EmailVerificationResult;
  /** Sends verification code to the specified phone number */
  sendVerificationCode: PhoneVerificationResult;
  /** Accepts verification code to verify the current user's phone number */
  verifyCode: PhoneVerificationResult;
  /** Accepts verification code to verify the current user's email */
  verifyEmailCode: EmailVerificationResult;
};


/** Mutations for common account setup functions */
export type AccountSetupOpAddPhoneNumberArgs = {
  input: AccountSetupAddPhoneNumberInput;
};


/** Mutations for common account setup functions */
export type AccountSetupOpDeletePhoneNumberArgs = {
  input: AccountSetupDeletePhoneNumberInput;
};


/** Mutations for common account setup functions */
export type AccountSetupOpSendVerificationCodeArgs = {
  input: AccountSetupSendVerificationCodeInput;
};


/** Mutations for common account setup functions */
export type AccountSetupOpVerifyCodeArgs = {
  input: AccountSetupVerifyCodeInput;
};


/** Mutations for common account setup functions */
export type AccountSetupOpVerifyEmailCodeArgs = {
  input: AccountSetupVerifyCodeInput;
};

export type AccountSetupSendVerificationCodeInput = {
  /** User's phone number to verify. Must have previously been added to the user via addPhoneNumber() */
  phoneNumber: Scalars['String'];
};

/** These states describe whether or not a user's account is set up */
export enum AccountSetupStatus {
  /** The user's account is fully set up */
  Complete = 'COMPLETE',
  /** The user has begun setting up their account, but has not completed all the required steps */
  InProgress = 'IN_PROGRESS',
  /**
   * The user has not started setting up their account
   *
   * > ⚠️ Note that this condition is generally uncommon, as the creation of a user account inherently starts the account setup process
   */
  NotStarted = 'NOT_STARTED'
}

export type AccountSetupVerifyCodeInput = {
  /** Verification code sent to the user */
  code: Scalars['String'];
};

export type ActionResult = {
  message: Scalars['String'];
  status: Scalars['Int'];
};

/** A represention of an appliance which a user could potentially have in their inventory */
export type ApplianceInventoryApplianceDefinition = {
  __typename?: 'ApplianceInventoryApplianceDefinition';
  /** The set of questions associated with this appliance definition */
  applianceQuestions: Array<ApplianceInventoryApplianceQuestion>;
  /** The category associated with this appliance definition */
  category: ApplianceInventoryCategory;
  /** The name of the appliance definition to be displayed in the UI */
  displayName?: Maybe<Scalars['String']>;
  /** Corresponding category for displaying the user's energy use chart */
  energyUseCategory?: Maybe<Scalars['String']>;
  /** Value in kWh of the average energy consumption for the given appliance */
  energyUseValueKwh?: Maybe<Scalars['Int']>;
  /** Whether or not the appliance definition is considered to have a large energy impact */
  hasLargeEnergyImpact: Scalars['Boolean'];
  /** The unique identifier of the appliance definition */
  id: Scalars['ID'];
  /**
   * A value used to stack rank appliance order in the recommendation screen where 1 represents the highest priority
   * (NULL represents appliances that are not ranked and/or are not high-energy appliances)
   */
  recommendationRank?: Maybe<Scalars['Int']>;
  /** Whether or not the appliance definition should be included in the special appliance inventory displayed during signup flow */
  showInSignup: Scalars['Boolean'];
  /** The non-user-facing slug/name for this appliance definition */
  slug: Scalars['String'];
  /** The list of the user's instances of this appliance */
  userAppliances: Array<ApplianceInventoryUserAppliance>;
  /**
   * The timestamp representing the last time the user updated their set of user appliances for this definition
   * (NULL represents that the user has never updated or asserted their set of user appliances)
   */
  userAppliancesUpdated?: Maybe<Scalars['ISODatetime']>;
};

/** A generic question with choices which is associated with an appliance definition */
export type ApplianceInventoryApplianceQuestion = {
  __typename?: 'ApplianceInventoryApplianceQuestion';
  /** The appliance definition associated with this appliance question */
  applianceDefinition: ApplianceInventoryApplianceDefinition;
  /** The list of possible question response choices */
  choices: Array<Scalars['String']>;
  /** Optional descriptive text to display about the question */
  description?: Maybe<Scalars['String']>;
  /** The unique identifier of the appliance question */
  id: Scalars['ID'];
  /** The detail question to present to the user */
  question: Scalars['String'];
};

/** A category for organizing appliance definitions */
export type ApplianceInventoryCategory = {
  __typename?: 'ApplianceInventoryCategory';
  /** The set of the appliance definitions associated with this category */
  applianceDefinitions: Array<ApplianceInventoryApplianceDefinition>;
  /** The user-facing description for the category */
  description?: Maybe<Scalars['String']>;
  /** The name of the appliance category to be displayed in the UI */
  displayName?: Maybe<Scalars['String']>;
  /** The unique identifier of the appliance category */
  id: Scalars['ID'];
  /** The non-user-facing slug/name for this appliance category */
  slug: Scalars['String'];
};

/** Mutations for Appliance Inventory */
export type ApplianceInventoryOp = {
  __typename?: 'ApplianceInventoryOp';
  /** Updates the quantity of appliances as user has for a given set of appliance definitions by id */
  applianceInventoryUpdateCurrentUserApplianceQuantityForApplianceDefinitions: ApplianceInventoryOpResult;
  /** Updates the user answer for the current user for the given user appliance question/answer by id */
  applianceInventoryUpdateCurrentUserApplianceQuestionAnswer: ApplianceInventoryOpResult;
};


/** Mutations for Appliance Inventory */
export type ApplianceInventoryOpApplianceInventoryUpdateCurrentUserApplianceQuantityForApplianceDefinitionsArgs = {
  input: Array<ApplianceInventoryUserApplianceQuantityForApplianceDefinitionInput>;
};


/** Mutations for Appliance Inventory */
export type ApplianceInventoryOpApplianceInventoryUpdateCurrentUserApplianceQuestionAnswerArgs = {
  userAnswer?: InputMaybe<Scalars['String']>;
  userApplianceQuestionAnswerId: Scalars['ID'];
};

export type ApplianceInventoryOpResult = FailureResult | UserApplianceInventory;

/** A user's individual instance of an appliance */
export type ApplianceInventoryUserAppliance = {
  __typename?: 'ApplianceInventoryUserAppliance';
  /** The appliance definition associated with this user appliance item */
  applianceDefinition: ApplianceInventoryApplianceDefinition;
  /** The unique identifier of the user appliance item */
  id: Scalars['ID'];
  /** The user associated with this instance of the appliance */
  user: User;
  /** The set of appliance question/answers about this user appliance item */
  userApplianceQuestionAnswers: Array<ApplianceInventoryUserApplianceQuestionAnswer>;
};

export type ApplianceInventoryUserApplianceQuantityForApplianceDefinitionInput = {
  applianceDefinitionId: Scalars['ID'];
  quantity: Scalars['Int'];
};

/** A user's question/answer pairing for a specific userAppliance */
export type ApplianceInventoryUserApplianceQuestionAnswer = {
  __typename?: 'ApplianceInventoryUserApplianceQuestionAnswer';
  /** The appliance question to ask the user */
  applianceQuestion: ApplianceInventoryApplianceQuestion;
  /** The unique identifier of the user appliance question/answer item */
  id: Scalars['ID'];
  /** The user associated with this question/answer */
  user: User;
  /** The user's answer to the appliance question asked, or null if unanswered */
  userAnswer?: Maybe<Scalars['String']>;
  /** The user appliance instance associated with this question/answer */
  userAppliance: ApplianceInventoryUserAppliance;
};

export type Attribute = BooleanAttribute | DateAttribute | DatetimeAttribute | NumericAttribute | StringEnumAttribute | TextAttribute;

export type AttributeBase = {
  active?: Maybe<Scalars['Boolean']>;
  comparatorAliases?: Maybe<Array<Maybe<ComparatorAlias>>>;
  comparators: Array<AttributeComparator>;
  dataType: AttributeDataType;
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  memberQuery?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  readOnly?: Maybe<Scalars['Boolean']>;
  synchronous?: Maybe<Scalars['Boolean']>;
  triggeringEvents?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type AttributeComparator = BaseComparator & {
  __typename?: 'AttributeComparator';
  attributeFilter: AttributeFilterType;
  id: Scalars['ID'];
  name: Scalars['String'];
  nameShort: Scalars['String'];
};

export enum AttributeDataType {
  Boolean = 'BOOLEAN',
  Date = 'DATE',
  Datetime = 'DATETIME',
  Enum = 'ENUM',
  Numeric = 'NUMERIC',
  Text = 'TEXT'
}

export type AttributeFilter = BooleanAttributeFilter | DateRangeAttributeFilter | DateSimpleAttributeFilter | DatetimeRangeAttributeFilter | DatetimeSimpleAttributeFilter | EnumAttributeFilter | NumericRangeAttributeFilter | NumericSimpleAttributeFilter | TextAttributeFilter;

export type AttributeFilterInput = {
  /** The specification for a new/updated boolean attribute filter. */
  booleanAttributeFilter?: InputMaybe<BooleanAttributeFilterInput>;
  /** The specification for a new/updated date range attribute filter. */
  dateRangeAttributeFilter?: InputMaybe<DateRangeAttributeFilterInput>;
  /** The specification for a new/updated date attribute filter. */
  dateSimpleAttributeFilter?: InputMaybe<DateSimpleAttributeFilterInput>;
  /** The specification for a new/updated datetime range attribute filter. */
  datetimeRangeAttributeFilter?: InputMaybe<DatetimeRangeAttributeFilterInput>;
  /** The specification for a new/updated datetime attribute filter. */
  datetimeSimpleAttributeFilter?: InputMaybe<DatetimeSimpleAttributeFilterInput>;
  /** The specification for a new/updated enum attribute filter. */
  enumAttributeFilter?: InputMaybe<EnumAttributeFilterInput>;
  /** The specification for a new/updated numeric range attribute filter. */
  numericRangeAttributeFilter?: InputMaybe<NumericRangeAttributeFilterInput>;
  /** The specification for a new/updated numeric attribute filter. */
  numericSimpleAttributeFilter?: InputMaybe<NumericSimpleAttributeFilterInput>;
  /** The specification for a new/updated text attribute filter. */
  textAttributeFilter?: InputMaybe<TextAttributeFilterInput>;
  /** The type of attribute filter to be created/updated. This must match the specification type that is provided. */
  type: AttributeFilterType;
};

export type AttributeFilterSegment = SegmentBase & {
  __typename?: 'AttributeFilterSegment';
  /** Whether this simple segment is actively being used. */
  active: Scalars['Boolean'];
  /** Whether users will be auto-enrolled in this simple segment. */
  activelyEnrolling: Scalars['Boolean'];
  /** The attribute upon which this simple segment is created. */
  attribute: Attribute;
  /** The description of the simple segment. */
  description: Scalars['String'];
  /** The filter definition that describes how this simple segment was constructed. */
  filter: AttributeFilter;
  /** The unique identifier of the simple segment. */
  id: Scalars['ID'];
  /** The name of the simple segment. */
  name: Scalars['String'];
};

export type AttributeFilterSegmentResult = AttributeFilterSegment | FailureResult;

export enum AttributeFilterType {
  BooleanAttributeFilter = 'BooleanAttributeFilter',
  DateRangeAttributeFilter = 'DateRangeAttributeFilter',
  DateSimpleAttributeFilter = 'DateSimpleAttributeFilter',
  DatetimeRangeAttributeFilter = 'DatetimeRangeAttributeFilter',
  DatetimeSimpleAttributeFilter = 'DatetimeSimpleAttributeFilter',
  EnumAttributeFilter = 'EnumAttributeFilter',
  NumericRangeAttributeFilter = 'NumericRangeAttributeFilter',
  NumericSimpleAttributeFilter = 'NumericSimpleAttributeFilter',
  TextAttributeFilter = 'TextAttributeFilter'
}

export type AttributeResult = BooleanAttribute | DateAttribute | DatetimeAttribute | FailureResult | NumericAttribute | StringEnumAttribute | TextAttribute;

export enum AttributeType {
  BooleanAttribute = 'BooleanAttribute',
  DateAttribute = 'DateAttribute',
  DatetimeAttribute = 'DatetimeAttribute',
  NumericAttribute = 'NumericAttribute',
  StringEnumAttribute = 'StringEnumAttribute',
  TextAttribute = 'TextAttribute'
}

export type AuthenticationCodeResult = FailureResult | Session;

/** Specific Authentication types */
export enum AuthorizationType {
  /**
   * must be an administrative user
   *
   * functional equivalent of the flask @api_admin_login_required decorator
   */
  Admin = 'ADMIN',
  /** allow any caller to access the field */
  Any = 'ANY',
  /**
   * must be a valid, authenticated user
   *
   * functional equivalent of the flask @api_login_required decorator
   */
  User = 'USER'
}

export type BaseComparator = {
  id: Scalars['ID'];
  name: Scalars['String'];
  nameShort: Scalars['String'];
};

export type BillingAddress = {
  __typename?: 'BillingAddress';
  /** Billing Address Line 1 */
  address1: Scalars['String'];
  /** Billing Unit or Apartment */
  address2?: Maybe<Scalars['String']>;
  /** Billing City */
  city: Scalars['String'];
  /** Billing State */
  state: Scalars['String'];
  /** Billing Zip Code */
  zip: Scalars['String'];
};

export type BooleanAttribute = AttributeBase & {
  __typename?: 'BooleanAttribute';
  /** Whether this string enum attribute is actively in use. */
  active?: Maybe<Scalars['Boolean']>;
  /** The collection of comparator alias overrides for this string enum attribute. */
  comparatorAliases?: Maybe<Array<Maybe<ComparatorAlias>>>;
  /** The array of possible comparators that this string boolean attribute supports. */
  comparators: Array<AttributeComparator>;
  /** The data type of the boolean attribute. */
  dataType: AttributeDataType;
  /** The description of the string enum attribute */
  description?: Maybe<Scalars['String']>;
  /** The unique identifier for the boolean attribute. */
  id: Scalars['ID'];
  /** The query that defines membership for this string enum attribute. */
  memberQuery?: Maybe<Scalars['String']>;
  /** The name of the boolean attribute. */
  name: Scalars['String'];
  /**
   * Whether this attribute is read-only or editable. Code-defined attributes, for example, would be
   * read-only.
   */
  readOnly?: Maybe<Scalars['Boolean']>;
  /**
   * Whether recalculation of the attribute's membership requires the listed triggering events to
   * be fired synchronously.
   */
  synchronous?: Maybe<Scalars['Boolean']>;
  /**
   * The collection of events that would recalculate membership for segments that utilize this
   * string enum attribute.
   */
  triggeringEvents?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type BooleanAttributeFilter = {
  __typename?: 'BooleanAttributeFilter';
  /** The selected value of the boolean attribute filter. */
  booleanValue: Scalars['Boolean'];
  /** The comparator for the boolean attribute filter. */
  comparator: FilterComparator;
  /** The unique identifier for the boolean attribute filter. */
  id: Scalars['ID'];
};

export type BooleanAttributeFilterInput = {
  /** The value for the new boolean attribute filter. */
  booleanValue: Scalars['Boolean'];
  /** The ID corresponding to the chosen comparator for the new boolean attribute filter. */
  comparatorId: Scalars['ID'];
};

/** These are options for the currency of the user's cash balance. */
export enum CashCurrency {
  /** United States cents. */
  Usc = 'USC'
}

/** Primarily used as an argument when requesting fields which require sort order. */
export enum ChronologicalOrder {
  /** Return the newest items first. */
  NewestFirst = 'NEWEST_FIRST',
  /** Return the oldest items first. */
  OldestFirst = 'OLDEST_FIRST'
}

export type CodeDefinedSegment = SegmentBase & {
  __typename?: 'CodeDefinedSegment';
  /** Whether this simple segment is actively being used. */
  active: Scalars['Boolean'];
  /** Whether users will be auto-enrolled in this simple segment. */
  activelyEnrolling: Scalars['Boolean'];
  /** The description of the simple segment. */
  description: Scalars['String'];
  /** The unique identifier of the simple segment. */
  id: Scalars['ID'];
  /** The name of the simple segment. */
  name: Scalars['String'];
};

export type ComparatorAlias = {
  __typename?: 'ComparatorAlias';
  comparatorId: Scalars['ID'];
  id: Scalars['ID'];
  name: Scalars['String'];
  nameShort: Scalars['String'];
};

export type ComparatorAliasInput = {
  comparatorId: Scalars['ID'];
  name: Scalars['String'];
  nameShort: Scalars['String'];
};

export type CompoundSegment = SegmentBase & {
  __typename?: 'CompoundSegment';
  /** Whether this simple segment is actively being used. */
  active: Scalars['Boolean'];
  /** Whether users will be auto-enrolled in this simple segment. */
  activelyEnrolling: Scalars['Boolean'];
  /** The array of segment groups from which this compound segment is composed. */
  composition: Array<SegmentGroup>;
  /** The description of the simple segment. */
  description: Scalars['String'];
  /** The unique identifier of the simple segment. */
  id: Scalars['ID'];
  /** The name of the simple segment. */
  name: Scalars['String'];
};

export type CompoundSegmentResult = CompoundSegment | FailureResult;

export type CreateSimulationInput = {
  historicEndDttm: Scalars['ISODatetime'];
  historicStartDttm: Scalars['ISODatetime'];
  simulationBusinessUnit: SimulationBusinessUnit;
  simulationStartDttm?: InputMaybe<Scalars['ISODatetime']>;
};

export enum CreditCheckErrorCode {
  CreditReportBadContactInfo = 'CREDIT_REPORT_BAD_CONTACT_INFO',
  CreditReportBadInputData = 'CREDIT_REPORT_BAD_INPUT_DATA',
  CreditReportFrozen = 'CREDIT_REPORT_FROZEN',
  CreditReportInvalidSsn = 'CREDIT_REPORT_INVALID_SSN',
  CreditReportLocked = 'CREDIT_REPORT_LOCKED',
  CreditReportLoginError = 'CREDIT_REPORT_LOGIN_ERROR',
  CreditReportNotFound = 'CREDIT_REPORT_NOT_FOUND',
  CreditReportOtherError = 'CREDIT_REPORT_OTHER_ERROR',
  CreditReportSsnUnverified = 'CREDIT_REPORT_SSN_UNVERIFIED',
  CreditReportTechnicalIssue = 'CREDIT_REPORT_TECHNICAL_ISSUE'
}

export enum CreditCheckResult {
  Error = 'ERROR',
  OverThreshold = 'OVER_THRESHOLD',
  Skipped = 'SKIPPED',
  UnderThreshold = 'UNDER_THRESHOLD'
}

export type CtaDisplay = {
  __typename?: 'CtaDisplay';
  /** The CTA label */
  label: Scalars['String'];
  /** The CTA level */
  level: CtaLevel;
  /** The CTA URL */
  url?: Maybe<Scalars['String']>;
};

export enum CtaLevel {
  Inline = 'INLINE',
  Primary = 'PRIMARY',
  Secondary = 'SECONDARY',
  Tertiary = 'TERTIARY'
}

/** A SmartGrid attribute and the possible values of that attribute */
export type DataList = {
  __typename?: 'DataList';
  /** Uppercase name of the list - called 'listType' in the SmartGrid API */
  listName: Scalars['String'];
  /** List of DataListValue objects representing the possible values in this list */
  values: Array<Maybe<DataListValue>>;
};

export type DataListValue = {
  __typename?: 'DataListValue';
  /** Usually the user-facing text or description of the option */
  name: Scalars['String'];
  /** Should be the unique option number for this option within the DataList */
  value: Scalars['String'];
};

export type DateAttribute = AttributeBase & {
  __typename?: 'DateAttribute';
  /** Whether this date attribute is actively in use. */
  active?: Maybe<Scalars['Boolean']>;
  /** The collection of comparator alias overrides for this date attribute. */
  comparatorAliases?: Maybe<Array<Maybe<ComparatorAlias>>>;
  /** The array of possible comparators that this date attribute supports. */
  comparators: Array<AttributeComparator>;
  /** The data type of the date attribute. */
  dataType: AttributeDataType;
  /** The description of the date attribute */
  description?: Maybe<Scalars['String']>;
  /** The unique identifier for the date attribute. */
  id: Scalars['ID'];
  /** The maximum allowable value for filtering on this attribute. */
  maximumAllowableDate?: Maybe<Scalars['ISODate']>;
  /** The query that defines membership for this date attribute. */
  memberQuery?: Maybe<Scalars['String']>;
  /** The minimum allowable value for filtering on this attribute. */
  minimumAllowableDate?: Maybe<Scalars['ISODate']>;
  /** The name of the date attribute. */
  name: Scalars['String'];
  /**
   * Whether this attribute is read-only or editable. Code-defined attributes, for example, would be
   * read-only.
   */
  readOnly?: Maybe<Scalars['Boolean']>;
  /**
   * Whether recalculation of the attribute's membership requires the listed triggering events to
   * be fired synchronously.
   */
  synchronous?: Maybe<Scalars['Boolean']>;
  /**
   * The collection of events that would recalculate membership for segments that utilize this
   * date attribute.
   */
  triggeringEvents?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type DateRangeAttributeFilter = {
  __typename?: 'DateRangeAttributeFilter';
  /** The comparator for the date range attribute filter. */
  comparator: FilterComparator;
  /** The unique identifier for the date range attribute filter. */
  id: Scalars['ID'];
  /** The selected maximum value of the date range attribute filter. */
  maxDate: Scalars['ISODate'];
  /** The selected minimum value of the date range attribute filter. */
  minDate: Scalars['ISODate'];
};

export type DateRangeAttributeFilterInput = {
  /** The ID corresponding to the chosen comparator for the new date range attribute filter. */
  comparatorId: Scalars['ID'];
  /** The selected maximum value of the new date range attribute filter. */
  maxDate: Scalars['ISODate'];
  /** The selected minimum value of the new date range attribute filter. */
  minDate: Scalars['ISODate'];
};

export type DateSimpleAttributeFilter = {
  __typename?: 'DateSimpleAttributeFilter';
  /** The comparator for the date attribute filter. */
  comparator: FilterComparator;
  /** The selected value of the date attribute filter. */
  dateValue: Scalars['ISODate'];
  /** The unique identifier for the date attribute filter. */
  id: Scalars['ID'];
};

export type DateSimpleAttributeFilterInput = {
  /** The ID corresponding to the chosen comparator for the new date simple attribute filter. */
  comparatorId: Scalars['ID'];
  /** The selected value of the new date attribute filter. */
  dateValue: Scalars['ISODate'];
};

export type DatetimeAttribute = AttributeBase & {
  __typename?: 'DatetimeAttribute';
  /** Whether this datetime attribute is actively in use. */
  active?: Maybe<Scalars['Boolean']>;
  /** The collection of comparator alias overrides for this datetime attribute. */
  comparatorAliases?: Maybe<Array<Maybe<ComparatorAlias>>>;
  /** The array of possible comparators that this datetime attribute supports. */
  comparators: Array<AttributeComparator>;
  /** The data type of the datetime attribute. */
  dataType: AttributeDataType;
  /** The description of the datetime attribute */
  description?: Maybe<Scalars['String']>;
  /** The unique identifier for the datetime attribute. */
  id: Scalars['ID'];
  /** The maximum allowable value for filtering on this datetime attribute. */
  maximumAllowableDttm?: Maybe<Scalars['ISODatetime']>;
  /** The query that defines membership for this datetime attribute. */
  memberQuery?: Maybe<Scalars['String']>;
  /** The minimum allowable value for filtering on this datetime attribute. */
  minimumAllowableDttm?: Maybe<Scalars['ISODatetime']>;
  /** The name of the datetime attribute. */
  name: Scalars['String'];
  /**
   * Whether this attribute is read-only or editable. Code-defined attributes, for example, would be
   * read-only.
   */
  readOnly?: Maybe<Scalars['Boolean']>;
  /**
   * Whether recalculation of the attribute's membership requires the listed triggering events to
   * be fired synchronously.
   */
  synchronous?: Maybe<Scalars['Boolean']>;
  /**
   * The collection of events that would recalculate membership for segments that utilize this
   * datetime attribute.
   */
  triggeringEvents?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type DatetimeRangeAttributeFilter = {
  __typename?: 'DatetimeRangeAttributeFilter';
  /** The comparator for the datetime range attribute filter. */
  comparator: FilterComparator;
  /** The unique identifier for the datetime range attribute filter. */
  id: Scalars['ID'];
  /** The selected maximum value of the datetime range attribute filter. */
  maxDatetime: Scalars['ISODate'];
  /** The selected minimum value of the datetime range attribute filter. */
  minDatetime: Scalars['ISODatetime'];
};

export type DatetimeRangeAttributeFilterInput = {
  /** The ID corresponding to the chosen comparator for the new datetime range attribute filter. */
  comparatorId: Scalars['ID'];
  /** The selected maximum value of the new datetime range attribute filter. */
  maxDatetime: Scalars['ISODatetime'];
  /** The selected minimum value of the new datetime range attribute filter. */
  minDatetime: Scalars['ISODatetime'];
};

export type DatetimeSimpleAttributeFilter = {
  __typename?: 'DatetimeSimpleAttributeFilter';
  /** The comparator for the datetime attribute filter. */
  comparator: FilterComparator;
  /** The selected value of the datetime attribute filter. */
  datetimeValue: Scalars['ISODatetime'];
  /** The unique identifier for the datetime attribute filter. */
  id: Scalars['ID'];
};

export type DatetimeSimpleAttributeFilterInput = {
  /** The ID corresponding to the chosen comparator for the new datetime simple attribute filter. */
  comparatorId: Scalars['ID'];
  /** The selected value of the new datetime attribute filter. */
  datetimeValue: Scalars['ISODatetime'];
};

/** Data related to the demand response eligibility for a provided zip code */
export type DemandResponseEligibility = {
  __typename?: 'DemandResponseEligibility';
  /** A unique identifier for this demand response eligibility */
  id: Scalars['ID'];
  /** If applicable, the signup url for a prospective new user in the provided zip */
  signupUrl?: Maybe<Scalars['String']>;
  /** The eligibility status for the provided zip */
  status: DemandResponseEligibilityStatus;
  /**
   * An integer code representing the eligibility status for the provided zip
   * 0 = ineligible
   * 1 = eligible
   * 2 = unknown eligibility
   */
  statusCode: Scalars['Int'];
  /** A list of all supported utility acronyms for the provided zip */
  supportedUtilityAcronyms: Array<Scalars['String']>;
  /** The zip code associated with the status */
  zip: Scalars['String'];
};

/** An eligibility status for a zip code */
export enum DemandResponseEligibilityStatus {
  Eligible = 'Eligible',
  Ineligible = 'Ineligible',
  Unknown = 'Unknown'
}

export enum DepositWaiverOptions {
  FamilyViolence = 'FAMILY_VIOLENCE',
  LetterOfCredit = 'LETTER_OF_CREDIT',
  Senior = 'SENIOR'
}

export type Device = {
  __typename?: 'Device';
  /** The list of logs associated with Device */
  deviceEventLogs: Array<DeviceEventLog>;
  /** The list of */
  devicePowerConsumptionHourly?: Maybe<Array<DevicePowerConsumptionHourly>>;
  /** Returns the device power consumption records of the previous month according to User TimeZone */
  devicePowerConsumptionMonthly?: Maybe<Array<DevicePowerConsumptionHourly>>;
  /** Retuns the device power consumption records of the previous week according to User TimeZone. The previous week is defined as Sunday to Saturday */
  devicePowerConsumptionPreviousWeek?: Maybe<Array<DevicePowerConsumptionHourly>>;
  /** Returns the device power consumption records previous day’s load readings from 12:00 AM to 11:59 PM according to User TimeZone */
  devicePowerConsumptionYesterday?: Maybe<Array<DevicePowerConsumptionHourly>>;
  /** Device display name */
  displayName?: Maybe<Scalars['String']>;
  /** The Primary ID for Device. */
  id: Scalars['ID'];
  /** Device name */
  name?: Maybe<Scalars['String']>;
  /** The user who owns the Device. */
  user?: Maybe<User>;
};


export type DeviceDeviceEventLogsArgs = {
  order?: InputMaybe<ChronologicalOrder>;
  page?: InputMaybe<Scalars['Int']>;
  perPage?: InputMaybe<Scalars['Int']>;
};


export type DeviceDevicePowerConsumptionHourlyArgs = {
  endDttm?: InputMaybe<Scalars['ISODatetime']>;
  order?: InputMaybe<ChronologicalOrder>;
  page?: InputMaybe<Scalars['Int']>;
  perPage?: InputMaybe<Scalars['Int']>;
  startDttm?: InputMaybe<Scalars['ISODatetime']>;
};

/** Represents a user's connection to an outside partner which provides a device integration to the OhmConnect platform. */
export type DeviceAccountConnection = {
  __typename?: 'DeviceAccountConnection';
  /** The devices provided by this account connection */
  devices: Array<Device>;
  id: Scalars['ID'];
  /** The owner of this connection */
  owner: User;
  /** Information about this specific connection type, including UI-safe display content */
  type: DeviceAccountConnectionType;
};

/** Information about one type of DeviceAccountConnection, i.e. Google Nest or TP-Link Kasa */
export type DeviceAccountConnectionType = {
  __typename?: 'DeviceAccountConnectionType';
  /** A display-safe name for the connection type */
  displayTitle: Scalars['String'];
  id: Scalars['ID'];
  /** An internal identifier string for the connection type, should not ever be displayed. */
  key: Scalars['ID'];
};

/** Associates a UserDeviceLoadReport with with a Device, and aggregates the total weekly consumption */
export type DeviceEnergyUsageReport = {
  __typename?: 'DeviceEnergyUsageReport';
  /** Total power consumption of the device in KWh, linked to the time interval of the report */
  consumptionKWh: Scalars['Float'];
  /** Device */
  device: Device;
  id: Scalars['ID'];
};

export type DeviceEventLog = {
  __typename?: 'DeviceEventLog';
  /** The Primary ID for DeviceEventLog. */
  id: Scalars['ID'];
  /** Prior state */
  priorState?: Maybe<Scalars['String']>;
  /** When the device is *scheduled* to turn off, ie before start of an event */
  turnOffDttm?: Maybe<Scalars['ISODatetime']>;
  /** Status of attempts to turn off this device */
  turnOffState?: Maybe<DeviceTurnOffState>;
  /** When the device is scheduled to turn back on, ie at end of an event */
  turnOnDttm?: Maybe<Scalars['ISODatetime']>;
  /** Status of attempts to turn on this device */
  turnOnState?: Maybe<DeviceTurnOnState>;
  /** An individual users participation in the event. */
  userEnergyEvent?: Maybe<UserEnergyEvent>;
};

export type DevicePowerConsumptionHourly = {
  __typename?: 'DevicePowerConsumptionHourly';
  /** The number of watt hours consumed. */
  consumptionWattHours: Scalars['Float'];
  /** The device code that relates to a Device */
  deviceCode: Scalars['String'];
  /** The Hour start date time */
  hourStartDttm: Scalars['ISODatetime'];
  /** The Primary ID for DevicePowerConsumptionHourly */
  id: Scalars['ID'];
  /** Number of observations in this time period */
  numObservations?: Maybe<Scalars['Int']>;
  /** Scaling Factor */
  scalingFactor?: Maybe<Scalars['Float']>;
  /** Represents the device vendor */
  vendor?: Maybe<Scalars['String']>;
};

export enum DeviceTurnOffState {
  /** The device was already off, so no need to turn it off */
  AlreadyOff = 'ALREADY_OFF',
  AuthError = 'AUTH_ERROR',
  AuthErrorGivenUp = 'AUTH_ERROR_GIVEN_UP',
  /** Device was disconnected at the time of the OhmHour -- probably going away in favor of re-trying disconnected devices */
  Disconnected = 'DISCONNECTED',
  /** Temporary case for new SPA devices that aren't fully implemented yet */
  Done = 'DONE',
  /** We successfully created a demand response event */
  DrEvent = 'DR_EVENT',
  /**
   * Device had a prior OhmHour that was extended,
   * so does not need to be turned off again (whatever state it is in at the end of that OhmHour should reign)
   */
  Extension = 'EXTENSION',
  /** We could not turn off this device and will continue trying */
  Failed = 'FAILED',
  /** We could not turn off this device and have given up */
  FailedGivenUp = 'FAILED_GIVEN_UP',
  /** Device offline and we will continue trying */
  NotConnected = 'NOT_CONNECTED',
  /** Device offline and we will stop trying */
  NotConnectedGivenUp = 'NOT_CONNECTED_GIVEN_UP',
  /** Temporary case for new SPA devices that aren't fully implemented yet */
  NotImplemented = 'NOT_IMPLEMENTED',
  /** We successfully scheduled a turn off *and* on */
  Off = 'OFF',
  /** Device offline and we will continue trying */
  Offline = 'OFFLINE',
  /** Device offline and we will stop trying */
  OfflineGivenUp = 'OFFLINE_GIVEN_UP',
  /** User opted out of ohmhour */
  OptOut = 'OPT_OUT',
  /** We successfully scheduled a turn off *and* on */
  Scheduled = 'SCHEDULED',
  /** We could not turn off this device due to scrape failure and will continue trying */
  ScrapeFailed = 'SCRAPE_FAILED',
  /** We could not even talk to this device and have given up */
  ScrapeFailedGivenUp = 'SCRAPE_FAILED_GIVEN_UP'
}

export enum DeviceTurnOnState {
  /** The device was already on, so no need to turn back on */
  AlreadyOn = 'ALREADY_ON',
  AuthError = 'AUTH_ERROR',
  AuthErrorGivenUp = 'AUTH_ERROR_GIVEN_UP',
  /** Device was disconnected at the time of the OhmHour -- probably going away in favor of re-trying disconnected devices */
  Disconnected = 'DISCONNECTED',
  /** Device was successfully turned back on, */
  Done = 'DONE',
  /** This OhmHour was extended, so does not need to be turned on at the end (it will be turned on at the end of the next #OhmHour if it's not already on) */
  Extension = 'EXTENSION',
  /** We could not turn on this device and will continue trying */
  Failed = 'FAILED',
  /** We could not turn on this device and have given up */
  FailedGivenUp = 'FAILED_GIVEN_UP',
  ManagedByExternalDrp = 'MANAGED_BY_EXTERNAL_DRP',
  /** Device offline and we will continue trying */
  NotConnected = 'NOT_CONNECTED',
  /** Device offline and we will stop trying */
  NotConnectedGivenUp = 'NOT_CONNECTED_GIVEN_UP',
  /** Temporary case for legacy devices that can't handle a turn_on event if they weren't turned off, */
  NotImplemented = 'NOT_IMPLEMENTED',
  /** No change was done when turning off */
  NotToggled = 'NOT_TOGGLED',
  NoParticipationForUnknownReason = 'NO_PARTICIPATION_FOR_UNKNOWN_REASON',
  /** OK, likely circuit breaker off */
  Offline = 'OFFLINE',
  /** Problem if we toggled this at the beginning and can't get back to it */
  OfflineGivenUp = 'OFFLINE_GIVEN_UP',
  /** User opted out of ohmhour */
  OptOut = 'OPT_OUT',
  /** We could not turn on this device due to scrape failure and will continue trying */
  ScrapeFailed = 'SCRAPE_FAILED',
  /** We could not even talk to this device and have given up */
  ScrapeFailedGivenUp = 'SCRAPE_FAILED_GIVEN_UP'
}

/** Mutations for Dispatch Simulator */
export type DispatchSimulatorOp = {
  __typename?: 'DispatchSimulatorOp';
  /** Create a new simulation, optionally start it */
  createSimulation: DispatchSimulatorResult;
  /** Starts a simulation run */
  startSimulation: DispatchSimulatorResult;
};


/** Mutations for Dispatch Simulator */
export type DispatchSimulatorOpCreateSimulationArgs = {
  input: CreateSimulationInput;
};


/** Mutations for Dispatch Simulator */
export type DispatchSimulatorOpStartSimulationArgs = {
  input: StartSimulationInput;
};

export type DispatchSimulatorQuery = {
  __typename?: 'DispatchSimulatorQuery';
  /** List of all the past, current and upcoming simulations */
  simulations: Array<Simulation>;
};

export type DispatchSimulatorResult = FailureResult | Simulation;

/**
 * Represents an ERCOT-serviceable address. Used for displaying addresses in the
 * address confirmation step
 */
export type DistributionPoint = {
  __typename?: 'DistributionPoint';
  /** House number and street name and unit number for the location */
  address: Scalars['String'];
  /** City name for location */
  city: Scalars['String'];
  /** Identifies the customer as Residential, Commercial, etc.. */
  customerClass?: Maybe<Scalars['String']>;
  /** ID of the Distribution Service Provider */
  dspId?: Maybe<Scalars['ID']>;
  /** Primary identifier for this address */
  esiid: Scalars['String'];
  /** Boolean indicator of whether the Distribution Point is with another REP and under a Switch Hold */
  isSwitchHold: Scalars['Boolean'];
  /** Two letter state code for the location */
  state: Scalars['String'];
  /** Location's zip code */
  zipcode: Scalars['String'];
};

/** Response object for querying ERCOT locations */
export type DistributionPointsResponse = {
  __typename?: 'DistributionPointsResponse';
  /** Numerical status code - positive value being a successful response, negative value an error */
  code: Scalars['ID'];
  /** List of matching DistributionPoint addresses */
  distributionPoints: Array<DistributionPoint>;
  /** Status message - tells more info, particularly in error cases */
  message?: Maybe<Scalars['String']>;
};

/** Can be one or more for a given zip code, also called TDU. */
export type DistributionServiceProvider = {
  __typename?: 'DistributionServiceProvider';
  /** Pulls from the 'description' field on SmartGrid - shows a longer name for the TDU. */
  displayName: Scalars['String'];
  /** Holidays on which the TDU does not allow service starts. Currently hard-coded, but will eventually be pulled from SmartGrid */
  holidays: Array<Maybe<Scalars['ISODate']>>;
  /** The Primary ID from SmartGrid for the Distribution Service Provider. */
  id: Scalars['ID'];
  /**
   * Resolves the list of RetailPlans available for this TDU, for the specified language ID
   * and optional marketing campaign and channel.
   */
  plans: Array<RetailPlan>;
  /** Pulls from the 'name' field on SmartGrid - shows a shorter name or acronym TDU. */
  shortName?: Maybe<Scalars['String']>;
};


/** Can be one or more for a given zip code, also called TDU. */
export type DistributionServiceProviderPlansArgs = {
  campaign?: InputMaybe<Scalars['String']>;
  channel?: InputMaybe<Scalars['String']>;
  languageId: SmartgridLanguage;
};

export enum DwellingType {
  Apartment = 'APARTMENT',
  House = 'HOUSE',
  Trailer = 'TRAILER'
}

/** An object containing electricity usage estimate data */
export type ElectricityUsageEstimate = {
  __typename?: 'ElectricityUsageEstimate';
  /** The average cost of electricity per kilowatt-hour (kWh) for the address */
  averageCost: Scalars['Float'];
  /** An object containing the estimated monthly electricity bill amount for the home */
  estimatedBillAmount: ElectricityUsageEstimatedBillAmount;
  /** The estimated total electricity usage for the home for the year in kilowatt-hours (kWh) */
  estimatedUsage: Scalars['Float'];
  /** An array of objects representing the estimated electricity usage for the home for each month of the year */
  estimatesForMonth: Array<ElectricityUsageEstimateForMonth>;
  /** The unique identifier of the electricity usage estimate */
  id: Scalars['ID'];
  /** The name of the state where the address is located */
  stateName: Scalars['String'];
};

/** An object representing the estimated electricity usage for the home for a month of the year. */
export type ElectricityUsageEstimateForMonth = {
  __typename?: 'ElectricityUsageEstimateForMonth';
  /** The estimated electricity usage for the month in kilowatt-hours (kWh) */
  estimatedUsage: Scalars['Float'];
  id: Scalars['ID'];
  /** The name of the month */
  month: Scalars['String'];
};

export type ElectricityUsageEstimateInput = {
  /** The street address you want to find electricity information for */
  address?: InputMaybe<Scalars['String']>;
  /** The number of bathrooms in the home */
  bathrooms?: InputMaybe<Scalars['Float']>;
  /** The number of bedrooms in the home */
  bedrooms?: InputMaybe<Scalars['Int']>;
  /** The city of the address you want to find electricity information for */
  city?: InputMaybe<Scalars['String']>;
  /** The house type. Either house or apartment */
  houseType?: InputMaybe<Scalars['String']>;
  /** The square footage of the home */
  sqFt?: InputMaybe<Scalars['Float']>;
  /** The state of the address you want to find electricity information for */
  state?: InputMaybe<Scalars['String']>;
  /** The number of stories in the home */
  stories?: InputMaybe<Scalars['Int']>;
  /** The year the home was built. Should be four digits */
  yearBuilt?: InputMaybe<Scalars['Int']>;
  /** The zip code of the address you want to find electricity information for. Should be five numeric digits. */
  zip: Scalars['String'];
};

export type ElectricityUsageEstimateQuery = {
  __typename?: 'ElectricityUsageEstimateQuery';
  getElectricityUsageEstimate: ElectricityUsageEstimateResult;
};


export type ElectricityUsageEstimateQueryGetElectricityUsageEstimateArgs = {
  input: ElectricityUsageEstimateInput;
};

export type ElectricityUsageEstimateResult = ElectricityUsageEstimate | FailureResult;

/** An object containing the estimated monthly electricity bill amount for the home */
export type ElectricityUsageEstimatedBillAmount = {
  __typename?: 'ElectricityUsageEstimatedBillAmount';
  id: Scalars['ID'];
  /** The estimated maximum monthly bill amount in USD */
  max: Scalars['Float'];
  /** The estimated minimum monthly bill amount in USD */
  min: Scalars['Float'];
};

export type EmailVerificationResponse = {
  __typename?: 'EmailVerificationResponse';
  verificationStatus: VerificationStatus;
};

export type EmailVerificationResult = EmailVerificationResponse | FailureResult;

/** This type represents the non-user-specific data about an energy event, such as the start and end datetimes of the event. */
export type EnergyEvent = {
  __typename?: 'EnergyEvent';
  /** The datetime of the end of the energy event. For real-time events, the end may be undefined, or may change due to market conditions. */
  end?: Maybe<Scalars['ISODatetime']>;
  id: Scalars['ID'];
  /**
   * True if this event is part of the simulation definition, false if this event
   * is part of the simulation run
   */
  isDraftEvent?: Maybe<Scalars['Boolean']>;
  /**
   * Whether or not the event is being planned and updated in real-time, versus an event which has been fully
   * planned in advance. This affects whether the end of the event is fixed, as well as what types of notifications
   * the user may be sent.
   */
  isRealTimeEvent: Scalars['Boolean'];
  numOfDevices?: Maybe<Scalars['Int']>;
  /** Additional data required for dispatch simulator UI */
  numOfUsers?: Maybe<Scalars['Int']>;
  regions?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** The datetime of the start of the energy event. */
  start: Scalars['ISODatetime'];
};

export type EnrollmentStep = {
  __typename?: 'EnrollmentStep';
  /** Current step that the member needs to fill out to proceed */
  current: RetailEnrollmentStep;
  /** Next step in the enrollment flow. */
  next?: Maybe<RetailEnrollmentStep>;
  /** Previous step, used to populate the back button on the flow */
  previous: RetailEnrollmentStep;
};

export type EnumAttributeFilter = {
  __typename?: 'EnumAttributeFilter';
  /** The comparator for the enum attribute filter. */
  comparator: FilterComparator;
  /** The selected value(s) for the enum attribute filter. */
  enumValues: Array<Maybe<Scalars['String']>>;
  /** The unique identifier for the enum attribute filter. */
  id: Scalars['ID'];
};

export type EnumAttributeFilterInput = {
  /** The ID corresponding to the chosen comparator for the new enum attribute filter. */
  comparatorId: Scalars['ID'];
  /** The selected value(s) for the new enum attribute filter. */
  enumValues: Array<InputMaybe<Scalars['String']>>;
};

export type FailureResult = {
  __typename?: 'FailureResult';
  /** If an error occurred, an error code will be returned */
  errorCode?: Maybe<Scalars['ID']>;
  /** If an error occurred, a user-safe error message will be returned */
  errorMessage?: Maybe<Scalars['String']>;
  /** If an error occurred for a specific field, the field may be specified here */
  fieldName?: Maybe<Scalars['String']>;
};

/** A single feature of the Helios platform. */
export type Feature = {
  __typename?: 'Feature';
  /** A unique identifier of a feature for a user, primarily for caching. Is NOT the feature key value, for that use `key` */
  _id: Scalars['ID'];
  /** A technical description of the feature. */
  description?: Maybe<Scalars['String']>;
  /** Whether or not this feature is currently enabled for the user. */
  isEnabled: Scalars['Boolean'];
  /** The primary identifier of this feature. */
  key: Scalars['String'];
  /** Whether or not this feature has been overridden specifically for this user. */
  userOverrideState?: Maybe<OverrideState>;
};

export type FilterComparator = BaseComparator & {
  __typename?: 'FilterComparator';
  id: Scalars['ID'];
  name: Scalars['String'];
  nameShort: Scalars['String'];
};

export enum FraudCheckResult {
  FraudCheckBadInputData = 'FRAUD_CHECK_BAD_INPUT_DATA',
  FraudCheckLoginError = 'FRAUD_CHECK_LOGIN_ERROR',
  FraudCheckPassed = 'FRAUD_CHECK_PASSED',
  FraudCheckRejected = 'FRAUD_CHECK_REJECTED',
  FraudCheckTechnicalIssue = 'FRAUD_CHECK_TECHNICAL_ISSUE'
}

/** Mutations relating to Google Rush Hour Rewards */
export type GoogleRhrOp = {
  __typename?: 'GoogleRhrOp';
  markDidEnrollmentAlready: OhmResult;
  /** Mark the current user as having completed sendoff to the RHR enrollment flow. */
  markSendOffComplete: OhmResult;
};


/** Mutations relating to Google Rush Hour Rewards */
export type GoogleRhrOpMarkSendOffCompleteArgs = {
  programId: Scalars['ID'];
};

/** A leaderboard */
export type Leaderboard = {
  __typename?: 'Leaderboard';
  /** The unique identifier of the leaderboard */
  id: Scalars['ID'];
  /** The list of leaderboard entries that comprise this leaderboard. */
  leaders: Array<Maybe<LeaderboardEntry>>;
  /** The name of the leaderboard. This should be display-ready. */
  name: Scalars['String'];
  /** The segment this leaderboard pertains to. */
  segment: Segment;
  /** The name of the stat being calculated in this particular leaderboard. This should be display-ready. */
  statName: Scalars['String'];
  /** The type of leaderboard this is. (Currently only referrals supported) */
  type: LeaderboardType;
};

/** A leaderboard entry corresponds to an individual user's leaderboard status and rank. */
export type LeaderboardEntry = {
  __typename?: 'LeaderboardEntry';
  /** The unique identifier for the leaderboard entry. */
  id: Scalars['ID'];
  /** The user's identifier (usually an email address). */
  name: Scalars['String'];
  /** The rank of the entry. */
  rank: Scalars['Int'];
  /** The value of the statistic being used to calculate rank in this particular leaderboard. */
  statValue: Scalars['Int'];
};

/** The list of all types of leaderboards supported. */
export enum LeaderboardType {
  Referrals = 'REFERRALS'
}

export type MaybePartnerOrFailure = FailureResult | Partner;

export type MaybePartnerUserOrFailureResult = FailureResult | PartnerUser;

export type MaybeUserOrFailureResult = FailureResult | User;

export type MiniHomeSurveyInput = {
  /** Whether the lead's home has central air conditioning. */
  hasCentralAir: Scalars['Boolean'];
  /** Whether the lead's home has central heating. */
  hasCentralHeating: Scalars['Boolean'];
  /** The count of household members in the lead's home. */
  householdMembers: Scalars['Int'];
  /** The monthly electricity costs of the lead's home. */
  monthlyElectricityCosts: Scalars['Float'];
  /** The square footage of the lead's home. */
  squareFeet: Scalars['Int'];
  /** The lead's zip code. */
  zipCode: Scalars['String'];
};

/** Mutations for the mini home survey */
export type MiniHomeSurveyOp = {
  __typename?: 'MiniHomeSurveyOp';
  /** Submits a lead's responses to the mini home survey. */
  miniHomeSurveyUpdateResponses: MiniHomeSurveySavingsCalculatorResult;
};


/** Mutations for the mini home survey */
export type MiniHomeSurveyOpMiniHomeSurveyUpdateResponsesArgs = {
  input: MiniHomeSurveyInput;
};

export type MiniHomeSurveySavingsCalculatorResult = FailureResult | Session;

export type MultiFailureResult = {
  __typename?: 'MultiFailureResult';
  /** If multiple errors can occur all will be returned at once */
  errors: Array<FailureResult>;
};

export type Mutation = {
  __typename?: 'Mutation';
  /** Mutations for common account setup functions */
  AccountSetup: AccountSetupOp;
  /** Mutations relating to the Appliance Inventory */
  ApplianceInventory: ApplianceInventoryOp;
  /** Mutations relating to the dispatch simulator */
  DispatchSimulator: DispatchSimulatorOp;
  /** A grouping of all the Google RHR related mutations */
  GoogleRhr: GoogleRhrOp;
  /** Mutations relating to the mini home survey */
  MiniHomeSurvey: MiniHomeSurveyOp;
  /** Mutations relating to OAuth flows */
  OAuth: OAuthOp;
  /** Mutations specifically for Partners to interact with specific features of a member */
  Partner: PartnerOp;
  /** Mutations relating to partnerships and partnered users */
  Partnership: PartnershipOp;
  /** Mutations relating to the prioritized content engine */
  PrioritizedContentEngine: PceOp;
  /** Mutations relating to the rate plan optimizer */
  RatePlanOptimizerFeedbackSurvey: RatePlanOptimizerFeedbackSurveyOp;
  /** Mutations for Retail Energy Enrollment */
  RetailEnergy: RetailEnergyOp;
  /** Mutations pertaining to the Segmentation Engine */
  SegmentationEngine: SegmentationEngineOp;
  /** Mutations for authenticating the current session */
  SessionAuthentication: SessionAuthenticationOp;
  /** Grouping of all the Users First Device related mutations (see ON-8211) */
  UsersFirstDevice: UsersFirstDeviceOp;
  clearAllFeatureOverrides: Array<Feature>;
  noop?: Maybe<Scalars['Boolean']>;
  /**
   * Allows for overriding the feature exposure of the user.
   * Passing true or false for the `state` parameter will set an override of that value;
   * omit the `state` parameter to clear the feature override.
   */
  setFeatureOverride: Array<Feature>;
  /** Sign up for a new member account using email address */
  signUpWithEmail: SignUpResult;
  /** Update the UI Attributes for the current user */
  updateCurrentUserInterfaceAttributes: UserInterfaceAttributes;
};


export type MutationClearAllFeatureOverridesArgs = {
  userId?: InputMaybe<Scalars['ID']>;
};


export type MutationSetFeatureOverrideArgs = {
  featureKeys: Array<Scalars['ID']>;
  state?: InputMaybe<Scalars['Boolean']>;
  userId: Scalars['ID'];
};


export type MutationSignUpWithEmailArgs = {
  email: Scalars['String'];
  firstName?: InputMaybe<Scalars['String']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  zipCode: Scalars['String'];
};


export type MutationUpdateCurrentUserInterfaceAttributesArgs = {
  attributes: UserInterfaceAttributesInput;
};

export type NewAttributeFilterSegmentInput = {
  /** Whether this simple segment is actively being used. */
  active: Scalars['Boolean'];
  /** Whether users will be auto-enrolled in this simple segment. */
  activelyEnrolling: Scalars['Boolean'];
  /** The name of the attribute upon which this simple segment is created. */
  attributeName: Scalars['String'];
  /** The description of the new simple segment to be created */
  description: Scalars['String'];
  /** The filter definition that describes how to create this simple segment. */
  filter: AttributeFilterInput;
  /** The name of the new simple segment to be created */
  name: Scalars['String'];
};

export type NewAttributeInput = {
  /** The specification for a new boolean attribute. */
  booleanAttribute?: InputMaybe<NewBooleanAttributeInput>;
  /** The specification for a new date attribute. */
  dateAttribute?: InputMaybe<NewDateAttributeInput>;
  /** The specification for a new datetime attribute. */
  datetimeAttribute?: InputMaybe<NewDatetimeAttributeInput>;
  /** The specification for a new numeric attribute. */
  numericAttribute?: InputMaybe<NewNumericAttributeInput>;
  /** The specification for a new string enum attribute. */
  stringEnumAttribute?: InputMaybe<NewStringEnumAttributeInput>;
  /** The specification for a new text attribute. */
  textAttribute?: InputMaybe<NewTextAttributeInput>;
  /** The type of attribute to be created. This must match the specification type that is provided. */
  type: AttributeType;
};

export type NewBooleanAttributeInput = {
  /** Whether this boolean attribute is actively in use. */
  active: Scalars['Boolean'];
  /** The collection of comparator alias overrides for this boolean attribute. */
  comparatorAliases?: InputMaybe<Array<InputMaybe<ComparatorAliasInput>>>;
  /** The description of the boolean attribute */
  description: Scalars['String'];
  /** The query that defines membership for this boolean attribute. */
  memberQuery: Scalars['String'];
  /** The name of the boolean attribute. */
  name: Scalars['String'];
  /**
   * Whether recalculation of the attribute's membership requires the listed triggering events to
   * be fired synchronously.
   */
  synchronous: Scalars['Boolean'];
  /**
   * The collection of events that would recalculate membership for segments that utilize this
   * boolean attribute.
   */
  triggeringEvents: Array<InputMaybe<Scalars['String']>>;
};

export type NewCompoundSegmentInput = {
  /** Whether this compound segment is actively being used. */
  active: Scalars['Boolean'];
  /** Whether users will be auto-enrolled in this compound segment. */
  activelyEnrolling: Scalars['Boolean'];
  /** The array of segment IDs from which to compose this compound segment. */
  composition: Array<SegmentGroupInput>;
  /** The description of the new compound segment to be created */
  description: Scalars['String'];
  /** The name of the new compound segment to be created */
  name: Scalars['String'];
};

export type NewDateAttributeInput = {
  /** Whether this date attribute is actively in use. */
  active: Scalars['Boolean'];
  /** The collection of comparator alias overrides for this date attribute. */
  comparatorAliases?: InputMaybe<Array<InputMaybe<ComparatorAliasInput>>>;
  /** The description of the date attribute */
  description: Scalars['String'];
  /** The maximum allowable value for filtering on this attribute. */
  maximumAllowableDate?: InputMaybe<Scalars['ISODate']>;
  /** The query that defines membership for this date attribute. */
  memberQuery: Scalars['String'];
  /** The minimum allowable value for filtering on this attribute. */
  minimumAllowableDate?: InputMaybe<Scalars['ISODate']>;
  /** The name of the date attribute. */
  name: Scalars['String'];
  /**
   * Whether recalculation of the attribute's membership requires the listed triggering events to
   * be fired synchronously.
   */
  synchronous: Scalars['Boolean'];
  /**
   * The collection of events that would recalculate membership for segments that utilize this
   * date attribute.
   */
  triggeringEvents: Array<InputMaybe<Scalars['String']>>;
};

export type NewDatetimeAttributeInput = {
  /** Whether this datetime attribute is actively in use. */
  active: Scalars['Boolean'];
  /** The collection of comparator alias overrides for this datetime attribute. */
  comparatorAliases?: InputMaybe<Array<InputMaybe<ComparatorAliasInput>>>;
  /** The description of the datetime attribute */
  description: Scalars['String'];
  /** The maximum allowable value for filtering on this datetime attribute. */
  maximumAllowableDttm?: InputMaybe<Scalars['ISODatetime']>;
  /** The query that defines membership for this datetime attribute. */
  memberQuery: Scalars['String'];
  /** The minimum allowable value for filtering on this datetime attribute. */
  minimumAllowableDttm?: InputMaybe<Scalars['ISODatetime']>;
  /** The name of the datetime attribute. */
  name: Scalars['String'];
  /**
   * Whether recalculation of the attribute's membership requires the listed triggering events to
   * be fired synchronously.
   */
  synchronous: Scalars['Boolean'];
  /**
   * The collection of events that would recalculate membership for segments that utilize this
   * datetime attribute.
   */
  triggeringEvents: Array<InputMaybe<Scalars['String']>>;
};

export type NewNumericAttributeInput = {
  /** Whether this numeric attribute is actively in use. */
  active: Scalars['Boolean'];
  /** The collection of comparator alias overrides for this numeric attribute. */
  comparatorAliases?: InputMaybe<Array<InputMaybe<ComparatorAliasInput>>>;
  /** The description of the numeric attribute */
  description: Scalars['String'];
  /** The maximum allowable value for filtering on this attribute. */
  maximumAllowableValue?: InputMaybe<Scalars['Float']>;
  /** The query that defines membership for this numeric attribute. */
  memberQuery: Scalars['String'];
  /** The minimum allowable value for filtering on this attribute. */
  minimumAllowableValue?: InputMaybe<Scalars['Float']>;
  /** The name of the numeric attribute. */
  name: Scalars['String'];
  /**
   * Whether recalculation of the attribute's membership requires the listed triggering events to
   * be fired synchronously.
   */
  synchronous: Scalars['Boolean'];
  /**
   * The collection of events that would recalculate membership for segments that utilize this
   * numeric attribute.
   */
  triggeringEvents: Array<InputMaybe<Scalars['String']>>;
};

export type NewStringEnumAttributeInput = {
  /** Whether this string enum attribute is actively in use. */
  active: Scalars['Boolean'];
  /** The collection of comparator alias overrides for this string enum attribute. */
  comparatorAliases?: InputMaybe<Array<InputMaybe<ComparatorAliasInput>>>;
  /** The description of the string enum attribute */
  description: Scalars['String'];
  /** The array of possible values that this string enum attribute supports. */
  enumeratedValues: Array<Scalars['String']>;
  /** The query that defines membership for this string enum attribute. */
  memberQuery: Scalars['String'];
  /** The name of the string enum attribute. */
  name: Scalars['String'];
  /**
   * Whether recalculation of the attribute's membership requires the listed triggering events to
   * be fired synchronously.
   */
  synchronous: Scalars['Boolean'];
  /**
   * The collection of events that would recalculate membership for segments that utilize this
   * string enum attribute.
   */
  triggeringEvents: Array<InputMaybe<Scalars['String']>>;
};

export type NewTextAttributeInput = {
  /** Whether this text attribute is actively in use. */
  active: Scalars['Boolean'];
  /** The collection of comparator alias overrides for this text attribute. */
  comparatorAliases?: InputMaybe<Array<InputMaybe<ComparatorAliasInput>>>;
  /** The description of the text attribute */
  description: Scalars['String'];
  /** The query that defines membership for this text attribute. */
  memberQuery: Scalars['String'];
  /** The name of the text attribute. */
  name: Scalars['String'];
  /**
   * Whether recalculation of the attribute's membership requires the listed triggering events to
   * be fired synchronously.
   */
  synchronous: Scalars['Boolean'];
  /**
   * The collection of events that would recalculate membership for segments that utilize this
   * text attribute.
   */
  triggeringEvents: Array<InputMaybe<Scalars['String']>>;
};

export type NumericAttribute = AttributeBase & {
  __typename?: 'NumericAttribute';
  /** Whether this string enum attribute is actively in use. */
  active?: Maybe<Scalars['Boolean']>;
  /** The collection of comparator alias overrides for this string enum attribute. */
  comparatorAliases?: Maybe<Array<Maybe<ComparatorAlias>>>;
  /** The array of possible comparators that this numeric attribute supports. */
  comparators: Array<AttributeComparator>;
  /** The data type of the numeric attribute. */
  dataType: AttributeDataType;
  /** The description of the string enum attribute */
  description?: Maybe<Scalars['String']>;
  /** The unique identifier for the numeric attribute. */
  id: Scalars['ID'];
  /** The maximum allowable value for filtering on this attribute. */
  maximumAllowableValue?: Maybe<Scalars['Float']>;
  /** The query that defines membership for this string enum attribute. */
  memberQuery?: Maybe<Scalars['String']>;
  /** The minimum allowable value for filtering on this attribute. */
  minimumAllowableValue?: Maybe<Scalars['Float']>;
  /** The name of the numeric attribute. */
  name: Scalars['String'];
  /**
   * Whether this attribute is read-only or editable. Code-defined attributes, for example, would be
   * read-only.
   */
  readOnly?: Maybe<Scalars['Boolean']>;
  /**
   * Whether recalculation of the attribute's membership requires the listed triggering events to
   * be fired synchronously.
   */
  synchronous?: Maybe<Scalars['Boolean']>;
  /**
   * The collection of events that would recalculate membership for segments that utilize this
   * string enum attribute.
   */
  triggeringEvents?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type NumericRangeAttributeFilter = {
  __typename?: 'NumericRangeAttributeFilter';
  /** The comparator for the numeric range attribute filter. */
  comparator: FilterComparator;
  /** The unique identifier for the numeric range attribute filter. */
  id: Scalars['ID'];
  /** The selected maximum value of the numeric attribute filter. */
  maxValue: Scalars['Float'];
  /** The selected minimum value of the numeric attribute filter. */
  minValue: Scalars['Float'];
};

export type NumericRangeAttributeFilterInput = {
  /** The ID corresponding to the chosen comparator for the new numeric range attribute filter. */
  comparatorId: Scalars['ID'];
  /** The selected maximum value of the new numeric attribute filter. */
  maxValue: Scalars['Float'];
  /** The selected minimum value of the new numeric attribute filter. */
  minValue: Scalars['Float'];
};

export type NumericSimpleAttributeFilter = {
  __typename?: 'NumericSimpleAttributeFilter';
  /** The comparator for the numeric  attribute filter. */
  comparator: FilterComparator;
  /** The unique identifier for the numeric attribute filter. */
  id: Scalars['ID'];
  /** The selected value of the numeric attribute filter. */
  numericValue: Scalars['Float'];
};

export type NumericSimpleAttributeFilterInput = {
  /** The ID corresponding to the chosen comparator for the new numeric simple attribute filter. */
  comparatorId: Scalars['ID'];
  /** The selected value of the new numeric attribute filter. */
  numericValue: Scalars['Float'];
};

/**
 * An OAuth client represents an external product or service which has been
 * granted the ability to request access to a user's data through our APIs.
 */
export type OAuthClient = {
  __typename?: 'OAuthClient';
  id: Scalars['ID'];
  /** URI for a logo for the product or service */
  logoUri?: Maybe<Scalars['String']>;
  /** A user-facing name for the product or service */
  name: Scalars['String'];
  /**
   * If this client is associated with an OhmInside partner, this field
   * gives access to OhmInside partner-specific data
   */
  partner?: Maybe<Partner>;
  /** The list of valid redirect URIs which have been registered for this OAuthClient */
  redirectUris: Array<Scalars['String']>;
};

export enum OAuthCompletionChoice {
  Approve = 'APPROVE',
  Reject = 'REJECT'
}

/** Mutations which pertain to the Auth API */
export type OAuthOp = {
  __typename?: 'OAuthOp';
  /**
   * Add a new redirect URI for the specified client, only available to admins.
   *
   * If the specified redirect URI is already registered for the client, no change is made.
   */
  addRedirectUrisToClient: OAuthClient;
  /**
   * Approves or rejects the request of the OAuth session;
   * after completion of this mutation, the browser should
   * be redirected to the session's `redirectUri` if present
   */
  completeOAuthSessionGrant: OAuthOpResult;
  /**
   * Remove a redirect URI for the specified client, only available to admins.
   *
   * If the specified redirect URI is not registered on the client, no change is made.
   */
  removeRedirectUrisFromClient: OAuthClient;
  /** Rotate the OAuth2 client secret for a client, only available to admins. */
  rotateClientSecret: OAuthClient;
};


/** Mutations which pertain to the Auth API */
export type OAuthOpAddRedirectUrisToClientArgs = {
  clientId: Scalars['ID'];
  redirectUris: Array<Scalars['String']>;
};


/** Mutations which pertain to the Auth API */
export type OAuthOpCompleteOAuthSessionGrantArgs = {
  choice: OAuthCompletionChoice;
};


/** Mutations which pertain to the Auth API */
export type OAuthOpRemoveRedirectUrisFromClientArgs = {
  clientId: Scalars['ID'];
  redirectUris: Array<Scalars['String']>;
};


/** Mutations which pertain to the Auth API */
export type OAuthOpRotateClientSecretArgs = {
  clientId: Scalars['ID'];
};

export type OAuthOpResult = FailureResult | OAuthSession;

export type OAuthPrefillSignupData = {
  __typename?: 'OAuthPrefillSignupData';
  email?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  zipCode?: Maybe<Scalars['String']>;
};

/** A limited set of data or interactions to which an OAuth client may be allowed access */
export type OAuthScope = {
  __typename?: 'OAuthScope';
  /** A user-facing description of the scope in question. */
  description: Scalars['String'];
  id: Scalars['ID'];
};

/**
 * An ongoing OAuth Session;
 * A browser may only have one ongoing session, and it
 * is stored server-side based on the session cookie
 */
export type OAuthSession = {
  __typename?: 'OAuthSession';
  /** The Ohm API client which is requesting the OAuth authorization */
  client: OAuthClient;
  /**
   * If the user has already selected whether to approve or reject
   * the OAuth grant request, this value will contain that choice.
   *
   * A null value here means the user has not made a selection
   */
  grantState?: Maybe<OAuthCompletionChoice>;
  id: Scalars['ID'];
  /** If populated, the user-agent should redirect to this url */
  redirectUri?: Maybe<Scalars['String']>;
  /** List of scopes requested by the client for this authorization */
  scopes: Array<OAuthScope>;
  /**
   * If the user has been directed into the OAuth flow by a partner,
   * they may need to create an account, and the partner may furnish
   * a set of pre-fill data to aid in completing the form
   */
  userDataPreFill?: Maybe<OAuthPrefillSignupData>;
};

/**
 * ## 🚫 Deprecated
 *
 * Try and avoid OhmResult if possible; it's a crutch and a sign that the mutation isn't returning anything useful.
 *
 * Prefer a union of useful success data and the FailureResult type instead
 */
export type OhmResult = ActionResult & {
  __typename?: 'OhmResult';
  message: Scalars['String'];
  status: Scalars['Int'];
};

export type OneTimeCodeAuthenticationMethod = {
  __typename?: 'OneTimeCodeAuthenticationMethod';
  /**
   * The UI-displayable label for this authentication method which masks the
   * phone number or email address.
   */
  displayLabel: Scalars['String'];
  id: Scalars['ID'];
  type: OneTimeCodeChannelType;
};

export enum OneTimeCodeChannelType {
  Email = 'EMAIL',
  Sms = 'SMS'
}

export type OverallPerformanceStats = {
  __typename?: 'OverallPerformanceStats';
  id: Scalars['ID'];
  /** Total Kwh reduced by the user. */
  totalKwhReduced?: Maybe<Scalars['Float']>;
};

export enum OverrideState {
  /** This feature has been disabled by an override. */
  Blocked = 'BLOCKED',
  /** This feature has been enabled by an override. */
  Granted = 'GRANTED',
  /** This feature is not overridden. */
  None = 'NONE'
}

/** An OhmInside partner */
export type Partner = {
  __typename?: 'Partner';
  /** The co-branded name of the program */
  cobrandProgramName?: Maybe<Scalars['String']>;
  /** A URI for an image to co-brand the app header */
  cobrandingHeaderUri?: Maybe<Scalars['String']>;
  /** the device connection type created when a user links to this partner */
  deviceAccountConnectionType?: Maybe<DeviceAccountConnectionType>;
  id: Scalars['ID'];
  /**
   * An internal description of the partner, so we can say things like 'This is the old version, use XYZ instead'
   * and see it in the DB
   */
  internalDescription?: Maybe<Scalars['String']>;
  key: Scalars['ID'];
  /** the OAuth Client linked to the partner */
  oauthClient?: Maybe<OAuthClient>;
};

/** Mutation Operations specifically for OhmInside partners */
export type PartnerOp = {
  __typename?: 'PartnerOp';
  /**
   * This mutation allows a partner to provide the OAuth Authorization Code which would normally be returned as a query
   * parameter on the final redirect as part of an OAuth 2 Authorization Code Flow. The result of doing this is that
   * the member should have a newly created [DeviceAccountConnection]({{Types.DeviceAccountConnection}})
   *
   * > ⚠️ This mutation requires that OhmConnect's engineers have built a custom device connection to your platform.
   * **Do not use this mutation unless you have explicitly discussed it with us first**
   *
   * The intention here is that _if_ a user has been taken through the Partner Account Linking Flow 1, you can provide
   * the authorization code via this channel to prevent the user from being required to complete a _second_ OAuth flow
   * in the reverse direction just to set up their device connection in the OhmConnect platform. Our system will take this
   * authorization code and use it to complete a token exchange on your authorization server (providing the same `redirect_uri`
   * parameter we would have passed if the user went through OAuth starting from our side)
   *
   * By submitting a user's authorization via this mutation, you are responsible for ensuring that your app has already
   * provided the user with the appropriate notice that you will be sharing their data with us. This notice should be
   * equivalent to whatever notice they would receive in your standard OAuth 2 Authorization Code Flow.
   */
  optimisticallyProvideOAuthAuthCodeForCurrentUser: MaybeUserOrFailureResult;
  /**
   * This mutation provides the partner the ability to tell OhmConnect that that the user has terminated the partner
   * relationship for themselves, resulting in the PartnerUser being end dated.
   */
  terminatePartnerRelationshipForCurrentUser: MaybePartnerUserOrFailureResult;
};


/** Mutation Operations specifically for OhmInside partners */
export type PartnerOpOptimisticallyProvideOAuthAuthCodeForCurrentUserArgs = {
  authCode: Scalars['ID'];
};


/** Mutation Operations specifically for OhmInside partners */
export type PartnerOpTerminatePartnerRelationshipForCurrentUserArgs = {
  reason: Scalars['String'];
};

/** The relationship of a user to a partner */
export type PartnerUser = {
  __typename?: 'PartnerUser';
  /** Device account connection associated with this partner user. */
  deviceAccountConnection?: Maybe<DeviceAccountConnection>;
  /** Date in which the partner user relationship was terminated. */
  endDttm?: Maybe<Scalars['ISODatetime']>;
  /** Users ID in the Partner system */
  externalUserId?: Maybe<Scalars['ID']>;
  id: Scalars['ID'];
  /** Whether or not the partner user relationship has been terminated. */
  isActive: Scalars['Boolean'];
  /** Has the user enabled device control for devices provided by this partner */
  isDeviceControlAllowed: Scalars['Boolean'];
  /** Whether or not this user signed up via this partner */
  isOrigination: Scalars['Boolean'];
  /** The partner linked to this user */
  partner: Partner;
  /** The user linked to this partner */
  user: User;
};

/** Mutations for partnerships and partnered users */
export type PartnershipOp = {
  __typename?: 'PartnershipOp';
  /** Create a new OhmInside partner, as well as associated OAuth clients */
  createOhmInsidePartner: Array<MaybePartnerOrFailure>;
  /** Set whether or not to allow device control for devices provided by this partner to the current user */
  setDeviceControlAllowedForPartner: PartnerUser;
  /** Mutations for admins to update editable fields on Partner */
  updateOhmInsidePartner: MaybePartnerOrFailure;
};


/** Mutations for partnerships and partnered users */
export type PartnershipOpCreateOhmInsidePartnerArgs = {
  cobrandedProgramName?: InputMaybe<Scalars['String']>;
  createQAVersions?: InputMaybe<Scalars['Boolean']>;
  internalDescription: Scalars['String'];
  oAuthClientName?: InputMaybe<Scalars['String']>;
  partnerKey: Scalars['ID'];
  redirectUris?: InputMaybe<Array<Scalars['String']>>;
};


/** Mutations for partnerships and partnered users */
export type PartnershipOpSetDeviceControlAllowedForPartnerArgs = {
  allowDeviceControl: Scalars['Boolean'];
  partnerKey: Scalars['ID'];
};


/** Mutations for partnerships and partnered users */
export type PartnershipOpUpdateOhmInsidePartnerArgs = {
  cobrandProgramName?: InputMaybe<Scalars['String']>;
  cobrandingHeaderUri?: InputMaybe<Scalars['String']>;
  deviceAccountConnectionTypeId?: InputMaybe<Scalars['ID']>;
  internalDescription?: InputMaybe<Scalars['String']>;
  partnerKey: Scalars['ID'];
};

export type PartnershipQuery = {
  __typename?: 'PartnershipQuery';
  /** List all the available partners */
  partners: Array<Partner>;
};

export type PceContentInstance = {
  __typename?: 'PceContentInstance';
  /** The content of the content instance. */
  displayContent: PceDisplayContent;
  /** The unique identifier for the content instance */
  id: Scalars['ID'];
  /** Whether or not the instance is active */
  isActive: Scalars['Boolean'];
  /** The content prototype associated with the content instance */
  prototype: PceContentPrototype;
  /**
   * The global priority rank of the prioritized content instance, relative to other prioritized content instances
   * TODO: Retaining this for compatability, remove in ON-12725 cleanup
   */
  rank?: Maybe<Scalars['Int']>;
  /**
   * The subrank of the prioritized content instance, used to determine tiebreakers when items have the same rank
   * TODO: Retaining this for compatability, remove in ON-12725 cleanup
   */
  subRank?: Maybe<Scalars['Int']>;
  /** The user ID associated with the content instance */
  userId: Scalars['String'];
};

export type PceContentPlacement = {
  __typename?: 'PceContentPlacement';
  /** A description */
  description?: Maybe<Scalars['String']>;
  /** The unique identifier for the content placement */
  id: PcePlacement;
  /** An identifying name */
  name?: Maybe<Scalars['String']>;
  /** The presentation context for this placement */
  presentationContext: PcePresentationContext;
  /** The presentation formats supported by this placement */
  presentationFormats: Array<PcePresentationFormat>;
  /** The prototypes for this placement */
  prototypePlacementRanks: Array<PcePrototypePlacementRank>;
  /** User instances */
  userInstances: Array<PceContentInstance>;
};

export type PceContentPrototype = {
  __typename?: 'PceContentPrototype';
  /** A list of content tags for categorization */
  contentTags: Array<Scalars['String']>;
  /** A description for the content prototype */
  description?: Maybe<Scalars['String']>;
  /** A complete set of display content to serve as an example of how this protype would present real content */
  exampleDisplayContent: PceDisplayContent;
  /** The global priority rank of the content prototype relative to all other prototypes */
  globalRank: Scalars['Int'];
  /** The unique identifier for the content prototype */
  id: Scalars['ID'];
  /** Whether the content prototype is enabled */
  isEnabled: Scalars['Boolean'];
  /** A name for the content prototype */
  name?: Maybe<Scalars['String']>;
  /** A list of selected placements for this content prototype */
  prototypePlacementRanks: Array<PcePrototypePlacementRank>;
  /** A list of supported placement ids for this content prototype */
  supportedPlacementIds: Array<PcePlacement>;
};

/** A type containing all PCE display content types, keyed by presentation format */
export type PceDisplayContent = {
  __typename?: 'PceDisplayContent';
  promoOfferWithPriceAndValue?: Maybe<PcePromoOfferWithPriceAndValueAndCtaDisplay>;
  textWithCta?: Maybe<PceTextWithCtaDisplay>;
};

export type PceOp = {
  __typename?: 'PceOp';
  /** Admin: create a new static segmented content item */
  createStaticSegmentedContent: PceOpStaticSegmentedContentResult;
  /** Increment the instance view count */
  incrementInstanceViewCount: PceOpInstancesResult;
  /** Resolve the instance */
  markInstanceResolved: PceOpInstancesResult;
  /** Unresolve the instance */
  markInstanceUnresolved: PceOpInstancesResult;
  /** Admin: Make all new fresh prototypes globally */
  refreshContentPrototypes: PceOpPrototypesResult;
  /** Admin: remove an existing static segmented content item */
  removeStaticSegmentedContent: PceOpStaticSegmentedContentResult;
  /** Reset the instance view count to zero */
  resetInstanceViewCount: PceOpInstancesResult;
  /** Admin: update prototype basic details */
  updatePrototype: PceOpPrototypesResult;
  /** Admin: update prototype's placement assignments */
  updatePrototypePlacementRanks: PceOpPrototypesResult;
  /** Admin: update and existing static segmented content item */
  updateStaticSegmentedContent: PceOpStaticSegmentedContentResult;
};


export type PceOpCreateStaticSegmentedContentArgs = {
  input: PceOpStaticSegmentedContentInput;
};


export type PceOpIncrementInstanceViewCountArgs = {
  instanceId: Scalars['ID'];
  userId: Scalars['ID'];
};


export type PceOpMarkInstanceResolvedArgs = {
  input?: InputMaybe<ResolveInstanceInput>;
};


export type PceOpMarkInstanceUnresolvedArgs = {
  instanceId: Scalars['ID'];
  userId: Scalars['ID'];
};


export type PceOpRefreshContentPrototypesArgs = {
  moduleIds?: InputMaybe<Array<Scalars['String']>>;
};


export type PceOpRemoveStaticSegmentedContentArgs = {
  id: Scalars['ID'];
};


export type PceOpResetInstanceViewCountArgs = {
  instanceId: Scalars['ID'];
  userId: Scalars['ID'];
};


export type PceOpUpdatePrototypeArgs = {
  id: Scalars['ID'];
  input: PceOpPrototypeBasicInput;
};


export type PceOpUpdatePrototypePlacementRanksArgs = {
  id: Scalars['ID'];
  removePlacements?: InputMaybe<Array<PcePlacement>>;
  updatePlacements?: InputMaybe<Array<PceOpPlacementWithRankInput>>;
};


export type PceOpUpdateStaticSegmentedContentArgs = {
  id: Scalars['ID'];
  input: PceOpStaticSegmentedContentInput;
};

export type PceOpInstancesResult = FailureResult | PceOpSuccessWithInstances;

export type PceOpPlacementWithRankInput = {
  placementId: PcePlacement;
  placementRank?: InputMaybe<Scalars['Int']>;
};

export type PceOpPrototypeBasicInput = {
  contentTags?: InputMaybe<Array<Scalars['String']>>;
  description?: InputMaybe<Scalars['String']>;
  globalRank?: InputMaybe<Scalars['Int']>;
  isEnabled?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
};

export type PceOpPrototypesResult = FailureResult | PceOpSuccessWithPrototypes;

export type PceOpStaticSegmentedContentInput = {
  /** The end dttm this content is valid to, if applicable */
  activeEndDttm?: InputMaybe<Scalars['ISODatetime']>;
  /** The start dttm this content is valid from, if applicable */
  activeStartDttm?: InputMaybe<Scalars['ISODatetime']>;
  /** The content of the content item, if applicable */
  content?: InputMaybe<Scalars['String']>;
  /** The CTA label for the content item */
  ctaLabel?: InputMaybe<Scalars['String']>;
  /** The CTA url for the content item */
  ctaUrl?: InputMaybe<Scalars['String']>;
  /** The icon URL of the content item, if applicable */
  icon?: InputMaybe<Scalars['String']>;
  /** The image url for the content item, if applicable */
  imageUrl?: InputMaybe<Scalars['String']>;
  /** The ID of the segment to target this content to */
  segmentId?: InputMaybe<Scalars['String']>;
  /** The subtext content for the content item, if applicable */
  subtext?: InputMaybe<Scalars['String']>;
  /** The subtitle of the content item, if applicable */
  subtitle?: InputMaybe<Scalars['String']>;
  /** The title of the content item, if applicable */
  title?: InputMaybe<Scalars['String']>;
};

export type PceOpStaticSegmentedContentResult = FailureResult | PceStaticSegmentedContent;

export type PceOpSuccessWithInstances = {
  __typename?: 'PceOpSuccessWithInstances';
  instances: Array<PceContentInstance>;
};

export type PceOpSuccessWithPrototypes = {
  __typename?: 'PceOpSuccessWithPrototypes';
  prototypes: Array<PceContentPrototype>;
};

/** PCE placements */
export enum PcePlacement {
  DashboardAnnouncementBanner = 'DashboardAnnouncementBanner',
  DashboardForYouCard = 'DashboardForYouCard',
  DashboardHero = 'DashboardHero',
  DashboardPromo = 'DashboardPromo',
  DashboardSavingsGoalPromo = 'DashboardSavingsGoalPromo',
  DashboardTakeAction = 'DashboardTakeAction',
  DashboardWaysToSave = 'DashboardWaysToSave',
  EnergyEventDetailsActions = 'EnergyEventDetailsActions',
  EnergyEventDetailsPromo = 'EnergyEventDetailsPromo',
  OfferDetailsPromo = 'OfferDetailsPromo',
  ReferralsAnnouncementBanner = 'ReferralsAnnouncementBanner',
  RewardsAnnouncementBanner = 'RewardsAnnouncementBanner'
}

/** PCE presentational contexts */
export enum PcePresentationContext {
  DashboardPage = 'DashboardPage',
  DevicesPage = 'DevicesPage',
  EnergyEventDetails = 'EnergyEventDetails',
  EventsPage = 'EventsPage',
  OfferDetailsPage = 'OfferDetailsPage',
  ReferralsPage = 'ReferralsPage',
  RewardsPage = 'RewardsPage'
}

/** PCE presentational formats */
export enum PcePresentationFormat {
  PromoOfferWithPriceAndValue = 'PromoOfferWithPriceAndValue',
  TextWithCta = 'TextWithCta'
}

export type PcePromoOfferWithPriceAndValueAndCtaDisplay = {
  __typename?: 'PcePromoOfferWithPriceAndValueAndCtaDisplay';
  /** The content of the promo offer item, if applicable */
  content?: Maybe<Scalars['String']>;
  /** The CTA for the promo offer item */
  ctas?: Maybe<Array<CtaDisplay>>;
  /** The icon URL of the promo offer item, if applicable */
  icon?: Maybe<Scalars['String']>;
  /** The unique identifier for the content text for promo offers */
  id: Scalars['ID'];
  /** The image url for the promo offer item, if applicable */
  imageUrl?: Maybe<Scalars['String']>;
  /** The price of the promo offer item */
  price?: Maybe<Scalars['Float']>;
  /** Whether the promo reward option requires a shipping address to fulfil */
  requiresShippingAddress?: Maybe<Scalars['Boolean']>;
  /** The subtext content for the promo offer item, if applicable */
  subtext?: Maybe<Scalars['String']>;
  /** The subtitle of the promo offer item, if applicable */
  subtitle?: Maybe<Scalars['String']>;
  /** The terms and conditions of the promo offer item */
  termsAndConditions?: Maybe<Scalars['String']>;
  /** The title of the promo offer instance if applicable */
  title?: Maybe<Scalars['String']>;
  /** The value of the promo offer item */
  value?: Maybe<Scalars['Float']>;
};

export type PcePrototypePlacementRank = {
  __typename?: 'PcePrototypePlacementRank';
  /** The unique identifier for the content prototype placement rank */
  id: Scalars['ID'];
  /** The unique identifier for the placement */
  placementId: PcePlacement;
  /** The rank of this content prototype within this placement */
  placementRank?: Maybe<Scalars['Int']>;
  /** The ID of the prototype this placement rank corresponds to */
  prototypeId: Scalars['ID'];
};

export type PceQuery = {
  __typename?: 'PceQuery';
  /** All PCE placements */
  placements: Array<PceContentPlacement>;
  /** All PCE content prototypes */
  prototypes: Array<PceContentPrototype>;
};


export type PceQueryPrototypesArgs = {
  placements?: InputMaybe<Array<PcePlacement>>;
};

export enum PceResolutionRequester {
  System = 'System',
  User = 'User'
}

export type PceStaticSegmentedContent = {
  __typename?: 'PceStaticSegmentedContent';
  /** The timestamp when this content item is no longer active. */
  activeEndDttm?: Maybe<Scalars['ISODatetime']>;
  /** The timestamp when this content item begins being active. */
  activeStartDttm?: Maybe<Scalars['ISODatetime']>;
  /** The content of the content item, if applicable */
  content?: Maybe<Scalars['String']>;
  /** The CTA label for the content item */
  ctaLabel?: Maybe<Scalars['String']>;
  /** The CTA URL for the content item */
  ctaUrl?: Maybe<Scalars['String']>;
  /** The icon URL of the content item, if applicable */
  icon?: Maybe<Scalars['String']>;
  /** The unique identifier for the content item */
  id: Scalars['ID'];
  /** The image url for the content item, if applicable */
  imageUrl?: Maybe<Scalars['String']>;
  /** The ID of the segment this content item will be targeted to. */
  segmentId?: Maybe<Scalars['ID']>;
  /** The subtext content for the content item, if applicable */
  subtext?: Maybe<Scalars['String']>;
  /** The subtitle of the content item, if applicable */
  subtitle?: Maybe<Scalars['String']>;
  /** The title of the content item, if applicable */
  title?: Maybe<Scalars['String']>;
};

export type PceTextWithCtaDisplay = {
  __typename?: 'PceTextWithCtaDisplay';
  /** The content of the content item, if applicable */
  content?: Maybe<Scalars['String']>;
  /** The CTA for the content item */
  ctas?: Maybe<Array<CtaDisplay>>;
  /** The icon URL of the content item, if applicable */
  icon?: Maybe<Scalars['String']>;
  /** The unique identifier for the content text with CTA display */
  id: Scalars['ID'];
  /** The image url for the content item, if applicable */
  imageUrl?: Maybe<Scalars['String']>;
  /** The subtext content for the content item, if applicable */
  subtext?: Maybe<Scalars['String']>;
  /** The subtitle of the content item, if applicable */
  subtitle?: Maybe<Scalars['String']>;
  /** The title of the content instance if applicable */
  title?: Maybe<Scalars['String']>;
};

export type PhoneNumberResult = FailureResult | User;

/** Used for phone number verification on contact info screen. */
export type PhoneVerificationProgress = {
  __typename?: 'PhoneVerificationProgress';
  phoneNumber: Scalars['String'];
  verificationStatus: VerificationStatus;
};

export type PhoneVerificationResult = FailureResult | PhoneVerificationProgress;

export enum PlanType {
  ElectricVehicle = 'ELECTRIC_VEHICLE',
  Pool = 'POOL',
  Prepaid = 'PREPAID',
  RenewableEnergy = 'RENEWABLE_ENERGY',
  SolarBuyback = 'SOLAR_BUYBACK',
  Standard = 'STANDARD',
  TimeOfUse = 'TIME_OF_USE'
}

/** These are options for the currency of the user's point balance (non-cash, variable value). */
export enum PointsCurrency {
  LegacyPoints = 'LEGACY_POINTS',
  /** Points which have a flexible value based on [Tier]({{Types.UserTier}}). */
  Watts = 'WATTS'
}

export type Query = {
  __typename?: 'Query';
  /**
   * The current session, which includes information about authentication state,
   * access to the current user, and more!
   */
  currentSession: Session;
  /** Whether or not a provided zip code is in a region eligible for Ohm DR */
  demandResponseEligibility: DemandResponseEligibility;
  /** Dispatch Simulator internal panel queries */
  dispatchSimulator: DispatchSimulatorQuery;
  /** An estimate of electricity usage for a given set of localized input criteria */
  electricityUsageEstimate: ElectricityUsageEstimateQuery;
  /** OhmInside administrative queries */
  partnerships: PartnershipQuery;
  /** Prioritized content engine */
  prioritizedContentEngine: PceQuery;
  /** Requests for retail enrollment UI */
  retailEnrollment: RetailEnrollmentQuery;
  /** Requests pertaining to the Segmentation Engine */
  segmentationEngine: SegmentationEngineQuery;
  /** Retrieves a single user by id, returns null if the user does not exist. */
  user?: Maybe<User>;
  /** The authenticated user, as determined by the token used to access the API. */
  viewer: User;
};


export type QueryDemandResponseEligibilityArgs = {
  zipCode: Scalars['String'];
};


export type QueryUserArgs = {
  userId: Scalars['ID'];
};

export type RatePlanOptimizerFeedbackSurvey = {
  __typename?: 'RatePlanOptimizerFeedbackSurvey';
  /** The survey response unique identifier. */
  id: Scalars['ID'];
  /**
   * Indicates whether the user clicked through to view the utility rate plans via
   * the 'See rate plans' button prior to submitting this survey.
   */
  passedToUtility: Scalars['Boolean'];
  /**
   * The list of possible survey options that the user was presented with when they filled out
   * the rate plan optimizer feedback survey.
   */
  prompts: Array<Scalars['String']>;
  /** The list of reasons that the user selected for either switching or not switching rate plans. */
  responses: Array<Scalars['String']>;
  /** The type of survey response that was submitted. */
  surveyType: RatePlanOptimizerFeedbackSurveyType;
};

export type RatePlanOptimizerFeedbackSurveyInput = {
  /**
   * Indicates whether the user clicked through to view the utility rate plans via
   * the 'See rate plans' button prior to submitting this survey.
   */
  passedToUtility: Scalars['Boolean'];
  /**
   * The list of possible survey options that the user was presented with when they filled out
   * the rate plan optimizer feedback survey.
   */
  prompts: Array<Scalars['String']>;
  /** The list of reasons that the user selected for either switching or not switching rate plans. */
  responses: Array<Scalars['String']>;
  /** The type of survey response being submitted. */
  surveyType: RatePlanOptimizerFeedbackSurveyType;
};

/**
 * Mutations for the rate plan optimizer feedback survey. This is the survey we present to users who have interacted
 * with the rate plan optimizer, and it collects information on whether or not they decided to change their rate plans
 * as a result of seeing our estimated savings.
 */
export type RatePlanOptimizerFeedbackSurveyOp = {
  __typename?: 'RatePlanOptimizerFeedbackSurveyOp';
  /**
   * Submits a user's survey responses for their reasons for switching/not switching rate plans when presented
   * with the rate plan optimizer.
   */
  submitRatePlanOptimizerFeedbackSurvey: RatePlanOptimizerFeedbackSurveyResult;
};


/**
 * Mutations for the rate plan optimizer feedback survey. This is the survey we present to users who have interacted
 * with the rate plan optimizer, and it collects information on whether or not they decided to change their rate plans
 * as a result of seeing our estimated savings.
 */
export type RatePlanOptimizerFeedbackSurveyOpSubmitRatePlanOptimizerFeedbackSurveyArgs = {
  input: RatePlanOptimizerFeedbackSurveyInput;
};

export type RatePlanOptimizerFeedbackSurveyResult = FailureResult | RatePlanOptimizerFeedbackSurvey;

export enum RatePlanOptimizerFeedbackSurveyType {
  ReasonsForNotSwitching = 'REASONS_FOR_NOT_SWITCHING',
  ReasonsForSwitching = 'REASONS_FOR_SWITCHING'
}

export type RatePlanOptimizerResult = {
  __typename?: 'RatePlanOptimizerResult';
  /** The rate plan estimated to save the user the most money. */
  cheapestRatePlanCode: Scalars['String'];
  /** The user's current rate plan. */
  currentRatePlanCode: Scalars['String'];
  /**
   * The estimated annual savings a user might expect if they switched from their current
   * rate plan to the cheapest available rate plan. This is simply:
   * currentEstimatedRatePlanAnnualCost - cheapestEstimatedRatePlanAnnualCost
   */
  estimatedAnnualRatePlanSavings: Scalars['Int'];
  /** The estimated annual cost of the user's cheapest available rate plan. */
  estimatedCheapestRatePlanAnnualCost: Scalars['Int'];
  /** The estimated annual cost of the user's current rate plan. */
  estimatedCurrentRatePlanAnnualCost: Scalars['Int'];
};

export type ResolveInstanceInput = {
  instanceId: Scalars['ID'];
  reason: Scalars['String'];
  requester: PceResolutionRequester;
  userId: Scalars['ID'];
};

/** Mutations for Retail Energy Enrollment */
export type RetailEnergyOp = {
  __typename?: 'RetailEnergyOp';
  /** Updates the user's address information, returns a list of distribution points for the user to verify */
  retailEnrollmentConfirmAddress: RetailEnrollmentStepResult;
  /** Confirms that the user reviewed their information on the review screen and update enrollment progress */
  retailEnrollmentConfirmReview: RetailEnrollmentStepResult;
  /** Store the user's verification and comm preferences in the backend */
  retailEnrollmentConfirmVerification: RetailEnrollmentStepResult;
  /** Begins an OCE enrollment for an existing user */
  retailEnrollmentCreate: RetailEnrollmentStepResult;
  /** Creates the user's account in SmartGrid and sets their password on the OhmConnect & SmartGrid accounts */
  retailEnrollmentCreateSGCISAccount: RetailEnrollmentStepResult;
  /** Create an OhmConnect user once being provided zip, selected plan, and email */
  retailEnrollmentCreateUser: RetailEnrollmentCreateUserResult;
  /** Runs a credit check for the currently logged in user */
  retailEnrollmentRunCreditCheck: RetailEnrollmentStepResult;
  /** Saves information on whether the user is moving addresses or switching providers and the datetime */
  retailEnrollmentServiceStart: RetailEnrollmentStepResult;
  /** Saves user billing preferences, including billing address and paperless billing setting */
  retailEnrollmentSetBillingPreferences: RetailEnrollmentStepResult;
  /** Subscribe or unsubscribe from automated texts from OhmConnect */
  retailEnrollmentSetSmsSubscriptions: RetailEnrollmentStepResult;
  /** Skips credit check for current user's enrollment */
  retailEnrollmentSkipCreditCheck: RetailEnrollmentStepResult;
  /** Updates the user's contact information */
  retailEnrollmentUpdateContactInfo: RetailEnrollmentStepResult;
  /** Updates selectedPlanId and zipCode on user retailEnrollmentProgress */
  retailEnrollmentUpdatePlanSelection: RetailEnrollmentStepResult;
  /** Store the credit check waiver response in the backend */
  retailEnrollmentWaiveDeposit: RetailEnrollmentStepResult;
};


/** Mutations for Retail Energy Enrollment */
export type RetailEnergyOpRetailEnrollmentConfirmAddressArgs = {
  input: RetailEnrollmentConfirmAddressInput;
};


/** Mutations for Retail Energy Enrollment */
export type RetailEnergyOpRetailEnrollmentConfirmReviewArgs = {
  input: RetailEnrollmentConfirmReviewInput;
};


/** Mutations for Retail Energy Enrollment */
export type RetailEnergyOpRetailEnrollmentConfirmVerificationArgs = {
  input: RetailEnrollmentVerificationInput;
};


/** Mutations for Retail Energy Enrollment */
export type RetailEnergyOpRetailEnrollmentCreateArgs = {
  input: RetailEnrollmentCreateInput;
};


/** Mutations for Retail Energy Enrollment */
export type RetailEnergyOpRetailEnrollmentCreateSgcisAccountArgs = {
  input: RetailEnrollmentCreateSgcisAccountInput;
};


/** Mutations for Retail Energy Enrollment */
export type RetailEnergyOpRetailEnrollmentCreateUserArgs = {
  input: RetailEnrollmentCreateUserInput;
};


/** Mutations for Retail Energy Enrollment */
export type RetailEnergyOpRetailEnrollmentRunCreditCheckArgs = {
  input: RetailEnrollmentRunCreditCheckInput;
};


/** Mutations for Retail Energy Enrollment */
export type RetailEnergyOpRetailEnrollmentServiceStartArgs = {
  input?: InputMaybe<RetailEnrollmentServiceStartInput>;
};


/** Mutations for Retail Energy Enrollment */
export type RetailEnergyOpRetailEnrollmentSetBillingPreferencesArgs = {
  input: RetailEnrollmentSetBillingPreferencesInput;
};


/** Mutations for Retail Energy Enrollment */
export type RetailEnergyOpRetailEnrollmentSetSmsSubscriptionsArgs = {
  input: RetailEnrollmentSetSmsSubscriptionsInput;
};


/** Mutations for Retail Energy Enrollment */
export type RetailEnergyOpRetailEnrollmentUpdateContactInfoArgs = {
  input: RetailEnrollmentUpdateContactInfoInput;
};


/** Mutations for Retail Energy Enrollment */
export type RetailEnergyOpRetailEnrollmentUpdatePlanSelectionArgs = {
  input?: InputMaybe<RetailEnrollmentUpdatePlanSelectionInput>;
};


/** Mutations for Retail Energy Enrollment */
export type RetailEnergyOpRetailEnrollmentWaiveDepositArgs = {
  input: RetailEnrollmentWaiveDepositInput;
};

export enum RetailEnrollmentCodes {
  ApiError = 'API_ERROR',
  CreditReportOtherError = 'CREDIT_REPORT_OTHER_ERROR',
  CurrentSessionHasUser = 'CURRENT_SESSION_HAS_USER',
  CurrentUserNotEnrolling = 'CURRENT_USER_NOT_ENROLLING',
  DistributionPointIsNonResidential = 'DISTRIBUTION_POINT_IS_NON_RESIDENTIAL',
  DistributionPointUnderSwitchHold = 'DISTRIBUTION_POINT_UNDER_SWITCH_HOLD',
  DistributionPointZipMismatch = 'DISTRIBUTION_POINT_ZIP_MISMATCH',
  IncompleteBillingAddress = 'INCOMPLETE_BILLING_ADDRESS',
  InvalidDwellingType = 'INVALID_DWELLING_TYPE',
  InvalidEsiid = 'INVALID_ESIID',
  InvalidSubscriptionValue = 'INVALID_SUBSCRIPTION_VALUE',
  MissingDriversLicenseInfo = 'MISSING_DRIVERS_LICENSE_INFO',
  NoPhone = 'NO_PHONE',
  PhoneNotVerified = 'PHONE_NOT_VERIFIED',
  SecurityQuestionAnswerMissing = 'SECURITY_QUESTION_ANSWER_MISSING',
  SecurityQuestionIdMissing = 'SECURITY_QUESTION_ID_MISSING',
  ServiceStartInvalid = 'SERVICE_START_INVALID',
  ServiceStartOnHoliday = 'SERVICE_START_ON_HOLIDAY',
  ServiceStartOnSunday = 'SERVICE_START_ON_SUNDAY',
  ServiceStartOnWeekend = 'SERVICE_START_ON_WEEKEND',
  ServiceStartRangeInvalid = 'SERVICE_START_RANGE_INVALID',
  ServiceStartToday = 'SERVICE_START_TODAY',
  SkipCreditCheckError = 'SKIP_CREDIT_CHECK_ERROR'
}

export type RetailEnrollmentConfirmAddressInput = {
  /** Type of residence -- either house, apartment or trailer. See DwellingType enum. */
  dwellingType: DwellingType;
  /** The ESIID for the user's power meter. This may be specified *instead* of the above fields. */
  esiid: Scalars['String'];
};

export type RetailEnrollmentConfirmReviewInput = {
  /** Boolean to indicate if the the customer reviewed the information */
  reviewed: Scalars['Boolean'];
};

export type RetailEnrollmentCreateInput = {
  /** Selected language of the user, either ENGLISH or SPANISH (optional) */
  language?: InputMaybe<SmartgridLanguage>;
  /** The plan ID that was selected */
  selectedPlanId: Scalars['ID'];
};

export type RetailEnrollmentCreateSgcisAccountInput = {
  /** Password to use for account (should be the same for both SmartGrid and OhmConnect accounts) */
  password: Scalars['String'];
  /** Answer to the SmartGrid security question */
  securityQuestionAnswer: Scalars['String'];
  /** ID of the SmartGrid security question answered */
  securityQuestionId: Scalars['ID'];
};

export type RetailEnrollmentCreateUserInput = {
  /** Agent ID for attribution (optional) */
  agentId?: InputMaybe<Scalars['ID']>;
  /** The email address to associate with the user */
  email: Scalars['String'];
  /** The first name of the user (optional) */
  firstName?: InputMaybe<Scalars['String']>;
  /** Selected language of the user, either ENGLISH or SPANISH (optional) */
  language?: InputMaybe<SmartgridLanguage>;
  /** Lead source ID for attribution (optional) */
  leadSourceId?: InputMaybe<Scalars['ID']>;
  /** Promo code to apply to enrollment (optional) */
  promoCode?: InputMaybe<Scalars['String']>;
  /** The plan ID that was selected */
  selectedPlanId: Scalars['ID'];
  /** The zip code for the user */
  zipCode: Scalars['String'];
};

export type RetailEnrollmentCreateUserResult = FailureResult | Session;

export type RetailEnrollmentOpResult = FailureResult | UserRetailEnrollmentProgress;

export type RetailEnrollmentQuery = {
  __typename?: 'RetailEnrollmentQuery';
  /** Lookup distribution points (serviceable addresses in ERCOT) by address or ESI-ID */
  distributionPoints: DistributionPointsResponse;
  /** Get the current list of security question options for the specified language */
  securityQuestions: SecurityQuestionsResponse;
  /** Requests Distribution Service Providers via SmartGridCIS for a given zip code. */
  tdusByZip: TdusByZipLookupResponse;
};


export type RetailEnrollmentQueryDistributionPointsArgs = {
  address?: InputMaybe<Scalars['String']>;
  apartment?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  esiid?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  zipcode?: InputMaybe<Scalars['String']>;
};


export type RetailEnrollmentQuerySecurityQuestionsArgs = {
  languageId: SmartgridLanguage;
};


export type RetailEnrollmentQueryTdusByZipArgs = {
  zipCode: Scalars['String'];
};

export type RetailEnrollmentRunCreditCheckInput = {
  /**
   * User's driver's license number. This data is only used to run a credit check and is not logged or
   * stored anywhere on Ohm servers. Required with DL state if SSN is not passed.
   */
  driversLicenseNumber?: InputMaybe<Scalars['String']>;
  /** User's driver's license state. Two code state abbreviation required with DL number if SSN is not passed. */
  driversLicenseState?: InputMaybe<Scalars['String']>;
  /**
   * User's social security number. This data is only used to run a credit check and is not logged or
   * stored anywhere on Ohm servers. Required if DL number and DL state are not passed.
   */
  socialSecurityNumber?: InputMaybe<Scalars['String']>;
};

export type RetailEnrollmentServiceStartInput = {
  /** Is the user moving address or switching providers */
  serviceEnrollmentOption: ServiceEnrollmentOption;
  /** Datetime When the user's service will start with OCE */
  startDt?: InputMaybe<Scalars['ISODate']>;
};

export type RetailEnrollmentSetBillingPreferencesInput = {
  /** Billing Address Line 1 */
  billingAddress1: Scalars['String'];
  /** Billing Unit or Apartment */
  billingAddress2?: InputMaybe<Scalars['String']>;
  /** Billing City */
  billingCity: Scalars['String'];
  /** Billing State */
  billingState: Scalars['String'];
  /** Billing Zip Code */
  billingZip: Scalars['String'];
  paperlessBilling?: InputMaybe<Scalars['Boolean']>;
};

export type RetailEnrollmentSetSmsSubscriptionsInput = {
  /** Boolean value to subscribe to SMS subscriptions (true) or to unsubscribe (false) */
  subscribed?: InputMaybe<Scalars['Boolean']>;
};

/** Identifiers for each screen / step in the enrollment flow */
export enum RetailEnrollmentStep {
  AddressInfo = 'ADDRESS_INFO',
  BillingAddress = 'BILLING_ADDRESS',
  Complete = 'COMPLETE',
  ContactInfo = 'CONTACT_INFO',
  CreditCheck = 'CREDIT_CHECK',
  Deposit = 'DEPOSIT',
  Email = 'EMAIL',
  Password = 'PASSWORD',
  Review = 'REVIEW',
  ServiceStartInfo = 'SERVICE_START_INFO',
  Verification = 'VERIFICATION'
}

export type RetailEnrollmentStepResult = FailureResult | MultiFailureResult | User;

export type RetailEnrollmentUpdateContactInfoInput = {
  /** The user's date of birth */
  birthdate: Scalars['ISODate'];
  /** The first name of the user */
  firstName: Scalars['String'];
  /** The last name of the user */
  lastName: Scalars['String'];
};

export type RetailEnrollmentUpdatePlanSelectionInput = {
  selectedPlanId: Scalars['ID'];
  zipCode: Scalars['String'];
};

export type RetailEnrollmentVerificationInput = {
  /** Boolean value to indicate whether the applicant is the enrolling user or an authorized agent */
  authorizedAgent: Scalars['Boolean'];
  /** First name of the authorized agent authorizedAgent is true (the applicant is the agent) */
  authorizedAgentFirstName?: InputMaybe<Scalars['String']>;
  /** Last name of the authorized agent authorizedAgent is true (the applicant is the agent) */
  authorizedAgentLastName?: InputMaybe<Scalars['String']>;
  /** Boolean value to indicate whether the user accepted the terms for automated SMS messages */
  automatedTextAgreement: Scalars['Boolean'];
  /** Language to use in future communications */
  communicationLanguage: SmartgridLanguage;
  /** Secondary account representative's first name in SmartGrid */
  secondaryRepresentativeFirstName?: InputMaybe<Scalars['String']>;
  /** Secondary account representative's last name in SmartGrid */
  secondaryRepresentativeLastName?: InputMaybe<Scalars['String']>;
  /** Secondary account representative's phone number in SmartGrid */
  secondaryRepresentativePhoneNumber?: InputMaybe<Scalars['String']>;
};

export type RetailEnrollmentWaiveDepositInput = {
  /** What option the member selects to waive the deposit */
  option?: InputMaybe<DepositWaiverOptions>;
};

export type RetailPlan = {
  __typename?: 'RetailPlan';
  /** Average price per kilowatt hour */
  averagePricePerKwh: Scalars['Float'];
  /** Contract length description in months */
  contractLength: Scalars['String'];
  /** Plan description */
  description: Scalars['String'];
  /** Plan title, safe to show in the UI */
  displayName: Scalars['String'];
  /** Contracts and documents associated with this plan */
  documents: Array<Maybe<RetailPlanDocument>>;
  /** Dollar amount of fee for terminating the contract early */
  earlyTerminationFee: Scalars['Float'];
  /** Detailed text about the plan's highlight, shown on "learn more" modal */
  highlightDescription?: Maybe<Scalars['String']>;
  /** Plan highlight to show on "learn more" modal */
  highlightTitle?: Maybe<Scalars['String']>;
  /** The primary identifier for the plan. Composite of the TDU ID and the product_id */
  id: Scalars['ID'];
  /** Highlight this plan in the UI */
  isFeatured: Scalars['Boolean'];
  /** Long description. Used for supplementary text in the UI */
  longDescription: Scalars['String'];
  /**
   * Identifier for plan type, eg. Solar Buyback, EV, Renewable, etc.
   * Note we accept any string here rather than restricting to the PlanType enum,
   * in order to gracefully handle unknown or misspelled values. The frontend
   * checks against the generated enum values and falls back to a default for unknowns.
   */
  planType?: Maybe<Scalars['String']>;
  /** The product ID for the plan */
  product_id: Scalars['ID'];
  /** Plan rate description text (example: "Fixed rate") */
  rateText?: Maybe<Scalars['String']>;
  /** Short description. Used for supplementary text in the UI */
  shortDescription: Scalars['String'];
  /** Special rate description text (example: "Half-price rate 9pm - 6am") */
  specialRateText?: Maybe<Scalars['String']>;
  /** The primary ID from SmartGrid for the Distribution Service Provider for this plan. */
  tdu_id: Scalars['ID'];
};

export type RetailPlanDocument = {
  __typename?: 'RetailPlanDocument';
  /** Description of the document */
  description: Scalars['String'];
  /** Name of the document. Safe to show in the UI */
  name: Scalars['String'];
  /** URL to download the document */
  url: Scalars['String'];
};

/**
 * A Reward is anything which can be given to a member, or which they can exchange points to receive.
 *
 * Rewards are **not** necessarily part of the reward marketplace
 */
export type Reward = {
  __typename?: 'Reward';
  /** The initial, non-discounted price of this reward if exchanged for points (non cash currency, i.e. Watts) */
  basePricePoints: Scalars['Int'];
  displayDescription: Scalars['String'];
  displayImageUrl: Scalars['String'];
  /** The subtitle to display for this reward in the UI */
  displaySubtitle: Scalars['String'];
  /** The title to display for this reward in the UI */
  displayTitle: Scalars['String'];
  /** A contextualized title, to fit into the sentence "and are now qualified to win ____" e.g. "a new car" */
  displayTitleContextualized: Scalars['String'];
  /**
   * Pluralized contextualized title, to fit into the sentence
   * "You redeemed 100 Watts for two ____" e.g. "TP-Link Smart Plugs with energy monitoring!"
   */
  displayTitlePlural: Scalars['String'];
  /** The cash currency value of the reward, most often used for display purposes */
  dollarValue: Scalars['Float'];
  id: Scalars['ID'];
  /** The internal name of the reward */
  name: Scalars['ID'];
};

export type SavingsCalculatorResult = {
  __typename?: 'SavingsCalculatorResult';
  /** The predicted annual savings attributable to automated load control, if applicable. */
  automatedLoadControlAnnualSavings?: Maybe<Scalars['Float']>;
  /** The predicted annual savings attributable to switching to a cheaper rate plan, if applicable. */
  cheaperRatePlanAnnualSavings?: Maybe<Scalars['Float']>;
  /** The predicted annual savings attributable to demand response events, if applicable. */
  drEventsAnnualSavings?: Maybe<Scalars['Float']>;
  /** The predicted annual savings attributable to energy reduction education of household members, if applicable. */
  energyEducationReductionAnnualSavings?: Maybe<Scalars['Float']>;
  /** The unique identifier for the savings calculator result set. */
  id: Scalars['ID'];
};

export enum SavingsGoalLevel {
  High = 'High',
  Light = 'Light',
  Medium = 'Medium'
}

/** Response object for querying current security questions */
export type SecurityQuestionsResponse = {
  __typename?: 'SecurityQuestionsResponse';
  /** Numerical status code - positive value being a successful response, negative value an error */
  code: Scalars['ID'];
  /** Status message - tells more info, particularly in error cases */
  message?: Maybe<Scalars['String']>;
  /** List of options for the SECURITY_QUESTION Data List */
  values: Array<Maybe<DataListValue>>;
};

export type Segment = AttributeFilterSegment | CodeDefinedSegment | CompoundSegment;

export type SegmentBase = {
  active: Scalars['Boolean'];
  activelyEnrolling: Scalars['Boolean'];
  description: Scalars['String'];
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type SegmentGroup = {
  __typename?: 'SegmentGroup';
  /** Unique identifier for the segment group */
  id: Scalars['ID'];
  /** The name of the segment group (optional) */
  name?: Maybe<Scalars['String']>;
  /** The array of segments that make up a compound segment. */
  segmentSpecs: Array<SegmentSpec>;
};

export type SegmentGroupInput = {
  /** The name of the segment group (optional) */
  name?: InputMaybe<Scalars['String']>;
  /** The array of segment IDs the compound segment is composed of. */
  segments: Array<Scalars['Int']>;
};

export type SegmentSpec = {
  __typename?: 'SegmentSpec';
  /** Unique identifier for the segment specification */
  id: Scalars['ID'];
  /** The designation of whether membership in the segment is inverted. */
  invert: Scalars['Boolean'];
  /** The segment in question */
  segment: Segment;
};

export enum SegmentType {
  AttributeFilter = 'ATTRIBUTE_FILTER',
  CodeDefined = 'CODE_DEFINED',
  Compound = 'COMPOUND'
}

export type SegmentationEngineOp = {
  __typename?: 'SegmentationEngineOp';
  /** Create new attribute. */
  createAttribute: AttributeResult;
  /** Create new simple segment. */
  createAttributeFilterSegment: AttributeFilterSegmentResult;
  /** Create new compound segment. */
  createCompoundSegment: CompoundSegmentResult;
  /** Update existing attribute. */
  updateAttribute: AttributeResult;
  /** Update existing simple segment. */
  updateAttributeFilterSegment: AttributeFilterSegmentResult;
  /** Update existing compound segment. */
  updateCompoundSegment: CompoundSegmentResult;
};


export type SegmentationEngineOpCreateAttributeArgs = {
  input: NewAttributeInput;
};


export type SegmentationEngineOpCreateAttributeFilterSegmentArgs = {
  input: NewAttributeFilterSegmentInput;
};


export type SegmentationEngineOpCreateCompoundSegmentArgs = {
  input: NewCompoundSegmentInput;
};


export type SegmentationEngineOpUpdateAttributeArgs = {
  id: Scalars['ID'];
  input: UpdateAttributeInput;
};


export type SegmentationEngineOpUpdateAttributeFilterSegmentArgs = {
  id: Scalars['ID'];
  input: UpdateAttributeFilterSegmentInput;
};


export type SegmentationEngineOpUpdateCompoundSegmentArgs = {
  id: Scalars['ID'];
  input: UpdateCompoundSegmentInput;
};

export type SegmentationEngineOpResult = FailureResult | SegmentationEngineOp;

export type SegmentationEngineQuery = {
  __typename?: 'SegmentationEngineQuery';
  /** Retrieve available attributes to generate simple segments with. */
  attributes: Array<Attribute>;
  /** Retrieve segments. */
  segments: Array<Segment>;
};


export type SegmentationEngineQueryAttributesArgs = {
  name?: InputMaybe<Scalars['String']>;
};


export type SegmentationEngineQuerySegmentsArgs = {
  attributeName?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<SegmentType>;
};

export enum ServiceEnrollmentOption {
  MoveAddresses = 'MOVE_ADDRESSES',
  SwitchProviders = 'SWITCH_PROVIDERS'
}

/** The current session, as managed by the backend based on the connection to the API */
export type Session = {
  __typename?: 'Session';
  /** Describes whether or not the current session is authenticated */
  authenticationState: SessionAuthenticationState;
  /** The current OAuth session, if it exists */
  currentOAuthSession?: Maybe<OAuthSession>;
  /** Whether or not a partner account linking redirect is present. */
  hasPartnerAccountLinkingRedirect: Scalars['Boolean'];
  /** A unique identifier for the session, mostly for cache identity in GQL clients */
  id: Scalars['ID'];
  /** The predicted annual savings results calculated from a lead's submitted mini home survey responses. */
  savingsCalculatorResult?: Maybe<SavingsCalculatorResult>;
  /**
   * A list of all the possible methods by which a user could provide a
   * second factor of authentication when one is required. If no second factor is required,
   * the list will be null
   */
  secondFactorAuthenticationOptions?: Maybe<Array<OneTimeCodeAuthenticationMethod>>;
  /** Contains all of the data necessary for specific UI customizations relevant to this session. */
  uiCustomization: UiCustomization;
  /** If the session is authenticated, this provides the user who is authenticated */
  user?: Maybe<User>;
};

export type SessionAuthenticationOp = {
  __typename?: 'SessionAuthenticationOp';
  /** Login request. Send an authentication code */
  requestAuthenticationCode: OhmResult;
  /**
   * Send a second factor authentication code to the method provided.
   * Possible methods may be retrieved from [`User.secondFactorAuthenticationOptions`]({{User.secondFactorAuthenticationOptions}})
   *
   * If you receive status of `-2` (which is session expired) then you should refetch the `currentSession` query, as
   * the authentication state is likely now logged out. Log in again to trigger a new second factor auth session.
   */
  requestSecondFactorCode: OhmResult;
  /** Submit a previously sent authentication code. The result of which is a logged in session. */
  submitAuthenticationCode: AuthenticationCodeResult;
  /**
   * Submit a previously sent multi factor code.
   *
   * If you receive an errorCode of `SESSION_EXPIRED` then you should refetch the `currentSession` query, as
   * the authentication state is likely now logged out. Log in again to trigger a new second factor auth session.
   */
  submitSecondFactorCode: SubmitSecondFactorCodeResult;
  /** Authenticate the current session with email/password combination */
  withEmailPassword: Session;
};


export type SessionAuthenticationOpRequestAuthenticationCodeArgs = {
  email: Scalars['String'];
};


export type SessionAuthenticationOpRequestSecondFactorCodeArgs = {
  authenticationMethodId: Scalars['ID'];
};


export type SessionAuthenticationOpSubmitAuthenticationCodeArgs = {
  code: Scalars['String'];
};


export type SessionAuthenticationOpSubmitSecondFactorCodeArgs = {
  code: Scalars['String'];
};


export type SessionAuthenticationOpWithEmailPasswordArgs = {
  email: Scalars['String'];
  password: Scalars['String'];
  requireHardLogin?: InputMaybe<Scalars['Boolean']>;
};

export enum SessionAuthenticationState {
  /** the session is authenticated fully, and is within the time range for sensitive operations */
  Hard = 'HARD',
  /** the session requires a second factor of authentication */
  NeedsSecondFactor = 'NEEDS_SECOND_FACTOR',
  /** the session is not authenticated at all */
  NotLoggedIn = 'NOT_LOGGED_IN',
  /** the session is authenticated, but needs hard login for sensitive operations */
  Soft = 'SOFT'
}

export type SignUpResult = MultiFailureResult | User;

export type Simulation = {
  __typename?: 'Simulation';
  events: Array<Maybe<EnergyEvent>>;
  historicEndDttm: Scalars['ISODatetime'];
  historicStartDttm: Scalars['ISODatetime'];
  id: Scalars['ID'];
  numOfDeviceEvents: Scalars['Int'];
  numOfEvents: Scalars['Int'];
  simulationBusinessUnit: SimulationBusinessUnit;
  simulationEndDttm?: Maybe<Scalars['ISODatetime']>;
  simulationStartDttm?: Maybe<Scalars['ISODatetime']>;
  simulationStatus: SimulationStatus;
};

export enum SimulationBusinessUnit {
  Ca = 'CA',
  Tx = 'TX'
}

export enum SimulationStatus {
  Complete = 'COMPLETE',
  Drafted = 'DRAFTED',
  Error = 'ERROR',
  Scheduled = 'SCHEDULED',
  Started = 'STARTED'
}

export enum SmartgridLanguage {
  English = 'ENGLISH',
  Spanish = 'SPANISH'
}

/** used only for documentation generation */
export type SpectaQlOption = {
  key: Scalars['String'];
  value: Scalars['String'];
};

export type StartSimulationInput = {
  id: Scalars['ID'];
  simulationStartDttm: Scalars['ISODatetime'];
};

export type StringEnumAttribute = AttributeBase & {
  __typename?: 'StringEnumAttribute';
  /** Whether this string enum attribute is actively in use. */
  active?: Maybe<Scalars['Boolean']>;
  /** The collection of comparator alias overrides for this string enum attribute. */
  comparatorAliases?: Maybe<Array<Maybe<ComparatorAlias>>>;
  /** The array of possible comparators that this string enum attribute supports. */
  comparators: Array<AttributeComparator>;
  /** The data type of the string enum attribute. */
  dataType: AttributeDataType;
  /** The description of the string enum attribute */
  description?: Maybe<Scalars['String']>;
  /** The array of possible values that this string enum attribute supports. */
  enumeratedValues: Array<Scalars['String']>;
  /** The unique identifier for the string enum attribute. */
  id: Scalars['ID'];
  /** The query that defines membership for this string enum attribute. */
  memberQuery?: Maybe<Scalars['String']>;
  /** The name of the string enum attribute. */
  name: Scalars['String'];
  /**
   * Whether this attribute is read-only or editable. Code-defined attributes, for example, would be
   * read-only.
   */
  readOnly?: Maybe<Scalars['Boolean']>;
  /**
   * Whether recalculation of the attribute's membership requires the listed triggering events to
   * be fired synchronously.
   */
  synchronous?: Maybe<Scalars['Boolean']>;
  /**
   * The collection of events that would recalculate membership for segments that utilize this
   * string enum attribute.
   */
  triggeringEvents?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type SubmitSecondFactorCodeResult = FailureResult | Session;

/** Response object from tdusByZip query including any validation errors */
export type TdusByZipLookupResponse = {
  __typename?: 'TdusByZipLookupResponse';
  /** Numerical status code - positive value being a successful response, negative value an error */
  code: Scalars['ID'];
  /** Status message - tells more info, particularly in error cases */
  message?: Maybe<Scalars['String']>;
  /** List of matching DistributionServiceProvider objects */
  tdus: Array<DistributionServiceProvider>;
};

export type TextAttribute = AttributeBase & {
  __typename?: 'TextAttribute';
  /** Whether this string enum attribute is actively in use. */
  active?: Maybe<Scalars['Boolean']>;
  /** The collection of comparator alias overrides for this string enum attribute. */
  comparatorAliases?: Maybe<Array<Maybe<ComparatorAlias>>>;
  /** The array of possible comparators that this text attribute supports. */
  comparators: Array<AttributeComparator>;
  /** The data type of the text attribute. */
  dataType: AttributeDataType;
  /** The description of the string enum attribute */
  description?: Maybe<Scalars['String']>;
  /** The unique identifier for the text attribute. */
  id: Scalars['ID'];
  /** The query that defines membership for this string enum attribute. */
  memberQuery?: Maybe<Scalars['String']>;
  /** The name of the text attribute. */
  name: Scalars['String'];
  /**
   * Whether this attribute is read-only or editable. Code-defined attributes, for example, would be
   * read-only.
   */
  readOnly?: Maybe<Scalars['Boolean']>;
  /**
   * Whether recalculation of the attribute's membership requires the listed triggering events to
   * be fired synchronously.
   */
  synchronous?: Maybe<Scalars['Boolean']>;
  /**
   * The collection of events that would recalculate membership for segments that utilize this
   * string enum attribute.
   */
  triggeringEvents?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type TextAttributeFilter = {
  __typename?: 'TextAttributeFilter';
  /** The comparator for the text attribute filter. */
  comparator: FilterComparator;
  /** The unique identifier for the text attribute filter. */
  id: Scalars['ID'];
  /** The selected value for the text attribute filter. */
  textValue: Scalars['String'];
};

export type TextAttributeFilterInput = {
  /** The ID corresponding to the chosen comparator for the new text attribute filter. */
  comparatorId: Scalars['ID'];
  /** The selected value for the new text attribute filter. */
  textValue: Scalars['String'];
};

export enum Timezone {
  /** America/Anchorage */
  AmericaAnchorage = 'AMERICA__ANCHORAGE',
  /** America/Boise */
  AmericaBoise = 'AMERICA__BOISE',
  /** America/Chicago */
  AmericaChicago = 'AMERICA__CHICAGO',
  /** America/Denver */
  AmericaDenver = 'AMERICA__DENVER',
  /** America/Detroit */
  AmericaDetroit = 'AMERICA__DETROIT',
  /** America/Indiana/Indianapolis */
  AmericaIndianaIndianapolis = 'AMERICA__INDIANA__INDIANAPOLIS',
  /** America/Indiana/Knox */
  AmericaIndianaKnox = 'AMERICA__INDIANA__KNOX',
  /** America/Indiana/Marengo */
  AmericaIndianaMarengo = 'AMERICA__INDIANA__MARENGO',
  /** America/Indiana/Petersburg */
  AmericaIndianaPetersburg = 'AMERICA__INDIANA__PETERSBURG',
  /** America/Indiana/Tell_City */
  AmericaIndianaTellCity = 'AMERICA__INDIANA__TELL_CITY',
  /** America/Indiana/Vevay */
  AmericaIndianaVevay = 'AMERICA__INDIANA__VEVAY',
  /** America/Indiana/Vincennes */
  AmericaIndianaVincennes = 'AMERICA__INDIANA__VINCENNES',
  /** America/Indiana/Winamac */
  AmericaIndianaWinamac = 'AMERICA__INDIANA__WINAMAC',
  /** America/Juneau */
  AmericaJuneau = 'AMERICA__JUNEAU',
  /** America/Kentucky/Louisville */
  AmericaKentuckyLouisville = 'AMERICA__KENTUCKY__LOUISVILLE',
  /** America/Kentucky/Monticello */
  AmericaKentuckyMonticello = 'AMERICA__KENTUCKY__MONTICELLO',
  /** America/Los_Angeles */
  AmericaLosAngeles = 'AMERICA__LOS_ANGELES',
  /** America/Menominee */
  AmericaMenominee = 'AMERICA__MENOMINEE',
  /** America/New_York */
  AmericaNewYork = 'AMERICA__NEW_YORK',
  /** America/Nome */
  AmericaNome = 'AMERICA__NOME',
  /** America/North_Dakota/Center */
  AmericaNorthDakotaCenter = 'AMERICA__NORTH_DAKOTA__CENTER',
  /** America/Phoenix */
  AmericaPhoenix = 'AMERICA__PHOENIX',
  /** America/Puerto_Rico */
  AmericaPuertoRico = 'AMERICA__PUERTO_RICO',
  /** America/Shiprock */
  AmericaShiprock = 'AMERICA__SHIPROCK',
  /** America/Yakutat */
  AmericaYakutat = 'AMERICA__YAKUTAT',
  /** Australia/ACT */
  AustraliaAct = 'AUSTRALIA__ACT',
  /** Australia/Adelaide */
  AustraliaAdelaide = 'AUSTRALIA__ADELAIDE',
  /** Australia/Brisbane */
  AustraliaBrisbane = 'AUSTRALIA__BRISBANE',
  /** Australia/Broken_Hill */
  AustraliaBrokenHill = 'AUSTRALIA__BROKEN_HILL',
  /** Australia/Darwin */
  AustraliaDarwin = 'AUSTRALIA__DARWIN',
  /** Australia/Hobart */
  AustraliaHobart = 'AUSTRALIA__HOBART',
  /** Australia/Lord_Howe */
  AustraliaLordHowe = 'AUSTRALIA__LORD_HOWE',
  /** Australia/Melbourne */
  AustraliaMelbourne = 'AUSTRALIA__MELBOURNE',
  /** Australia/North */
  AustraliaNorth = 'AUSTRALIA__NORTH',
  /** Australia/NSW */
  AustraliaNsw = 'AUSTRALIA__NSW',
  /** Australia/Perth */
  AustraliaPerth = 'AUSTRALIA__PERTH',
  /** Australia/Queensland */
  AustraliaQueensland = 'AUSTRALIA__QUEENSLAND',
  /** Australia/South */
  AustraliaSouth = 'AUSTRALIA__SOUTH',
  /** Australia/Sydney */
  AustraliaSydney = 'AUSTRALIA__SYDNEY',
  /** Australia/Tasmania */
  AustraliaTasmania = 'AUSTRALIA__TASMANIA',
  /** Australia/Victoria */
  AustraliaVictoria = 'AUSTRALIA__VICTORIA',
  /** Australia/West */
  AustraliaWest = 'AUSTRALIA__WEST',
  /** Canada/Atlantic */
  CanadaAtlantic = 'CANADA__ATLANTIC',
  /** Canada/Central */
  CanadaCentral = 'CANADA__CENTRAL',
  /** Canada/Eastern */
  CanadaEastern = 'CANADA__EASTERN',
  /** Canada/Mountain */
  CanadaMountain = 'CANADA__MOUNTAIN',
  /** Canada/Newfoundland */
  CanadaNewfoundland = 'CANADA__NEWFOUNDLAND',
  /** Canada/Pacific */
  CanadaPacific = 'CANADA__PACIFIC',
  /** Canada/Saskatchewan */
  CanadaSaskatchewan = 'CANADA__SASKATCHEWAN',
  /** Canada/Yukon */
  CanadaYukon = 'CANADA__YUKON',
  /** Pacific/Honolulu */
  PacificHonolulu = 'PACIFIC__HONOLULU'
}

export type UiCustomization = {
  __typename?: 'UiCustomization';
  /** Url for the partner brand the user was originated from */
  customBrandBarImageUrl?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
};

export type UpdateAttributeFilterSegmentInput = {
  /** The updated `active` value to give the simple segment. */
  active?: InputMaybe<Scalars['Boolean']>;
  /** The updated `activelyEnrolling` value to give the simple segment. */
  activelyEnrolling?: InputMaybe<Scalars['Boolean']>;
  /** The updated description to give the simple segment. */
  description?: InputMaybe<Scalars['String']>;
  /** The updated `filter` description to give the simple segment. */
  filter?: InputMaybe<AttributeFilterInput>;
  /** The updated name to give the simple segment. */
  name?: InputMaybe<Scalars['String']>;
};

export type UpdateAttributeInput = {
  /** The specification for an updated boolean attribute. */
  booleanAttribute?: InputMaybe<UpdateBooleanAttributeInput>;
  /** The specification for an updated date attribute. */
  dateAttribute?: InputMaybe<UpdateDateAttributeInput>;
  /** The specification for an updated datetime attribute. */
  datetimeAttribute?: InputMaybe<UpdateDatetimeAttributeInput>;
  /** The specification for an updated numeric attribute. */
  numericAttribute?: InputMaybe<UpdateNumericAttributeInput>;
  /** The specification for an updated string enum attribute. */
  stringEnumAttribute?: InputMaybe<UpdateStringEnumAttributeInput>;
  /** The specification for an updated text attribute. */
  textAttribute?: InputMaybe<UpdateTextAttributeInput>;
  /** The type of attribute to be updated. This must match the specification type that is provided. */
  type: AttributeType;
};

export type UpdateBooleanAttributeInput = {
  /** Whether this boolean attribute is actively in use. */
  active?: InputMaybe<Scalars['Boolean']>;
  /** The new collection of comparator alias overrides for this boolean attribute. */
  comparatorAliases?: InputMaybe<Array<InputMaybe<ComparatorAliasInput>>>;
  /** The new description of the boolean attribute */
  description?: InputMaybe<Scalars['String']>;
  /** The new query that defines membership for this boolean attribute. */
  memberQuery?: InputMaybe<Scalars['String']>;
  /** The new name of the boolean attribute. */
  name?: InputMaybe<Scalars['String']>;
  /**
   * Whether recalculation of the attribute's membership requires the listed triggering events to
   * be fired synchronously.
   */
  synchronous?: InputMaybe<Scalars['Boolean']>;
  /**
   * The new collection of events that would recalculate membership for segments that utilize this
   * boolean attribute.
   */
  triggeringEvents?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type UpdateCompoundSegmentInput = {
  /** The updated `active` value to give the compound segment. */
  active?: InputMaybe<Scalars['Boolean']>;
  /** The updated `activelyEnrolling` value to give the compound segment. */
  activelyEnrolling?: InputMaybe<Scalars['Boolean']>;
  /** The updated `composition` definition to give the compound segment. */
  composition: Array<SegmentGroupInput>;
  /** The updated description to give the compound segment. */
  description?: InputMaybe<Scalars['String']>;
  /** The updated name to give the compound segment. */
  name?: InputMaybe<Scalars['String']>;
};

export type UpdateDateAttributeInput = {
  /** Whether this date attribute is actively in use. */
  active?: InputMaybe<Scalars['Boolean']>;
  /** The new collection of comparator alias overrides for this date attribute. */
  comparatorAliases?: InputMaybe<Array<InputMaybe<ComparatorAliasInput>>>;
  /** The new description of the date attribute */
  description?: InputMaybe<Scalars['String']>;
  /** The new maximum allowable value for filtering on this attribute. */
  maximumAllowableDate?: InputMaybe<Scalars['ISODate']>;
  /** The new query that defines membership for this date attribute. */
  memberQuery?: InputMaybe<Scalars['String']>;
  /** The new minimum allowable value for filtering on this attribute. */
  minimumAllowableDate?: InputMaybe<Scalars['ISODate']>;
  /** The new name of the date attribute. */
  name?: InputMaybe<Scalars['String']>;
  /**
   * Whether recalculation of the attribute's membership requires the listed triggering events to
   * be fired synchronously.
   */
  synchronous?: InputMaybe<Scalars['Boolean']>;
  /**
   * The new collection of events that would recalculate membership for segments that utilize this
   * date attribute.
   */
  triggeringEvents?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type UpdateDatetimeAttributeInput = {
  /** Whether this datetime attribute is actively in use. */
  active?: InputMaybe<Scalars['Boolean']>;
  /** The collection of comparator alias overrides for this datetime attribute. */
  comparatorAliases?: InputMaybe<Array<InputMaybe<ComparatorAliasInput>>>;
  /** The description of the datetime attribute */
  description?: InputMaybe<Scalars['String']>;
  /** The maximum allowable value for filtering on this datetime attribute. */
  maximumAllowableDttm?: InputMaybe<Scalars['ISODatetime']>;
  /** The query that defines membership for this datetime attribute. */
  memberQuery?: InputMaybe<Scalars['String']>;
  /** The minimum allowable value for filtering on this datetime attribute. */
  minimumAllowableDttm?: InputMaybe<Scalars['ISODatetime']>;
  /** The name of the datetime attribute. */
  name?: InputMaybe<Scalars['String']>;
  /**
   * Whether recalculation of the attribute's membership requires the listed triggering events to
   * be fired synchronously.
   */
  synchronous?: InputMaybe<Scalars['Boolean']>;
  /**
   * The collection of events that would recalculate membership for segments that utilize this
   * datetime attribute.
   */
  triggeringEvents?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type UpdateNumericAttributeInput = {
  /** Whether this numeric attribute is actively in use. */
  active?: InputMaybe<Scalars['Boolean']>;
  /** The new collection of comparator alias overrides for this numeric attribute. */
  comparatorAliases?: InputMaybe<Array<InputMaybe<ComparatorAliasInput>>>;
  /** The new description of the numeric attribute */
  description?: InputMaybe<Scalars['String']>;
  /** The new maximum allowable value for filtering on this attribute. */
  maximumAllowableValue?: InputMaybe<Scalars['Float']>;
  /** The new query that defines membership for this numeric attribute. */
  memberQuery?: InputMaybe<Scalars['String']>;
  /** The new minimum allowable value for filtering on this attribute. */
  minimumAllowableValue?: InputMaybe<Scalars['Float']>;
  /** The new name of the numeric attribute. */
  name?: InputMaybe<Scalars['String']>;
  /**
   * Whether recalculation of the attribute's membership requires the listed triggering events to
   * be fired synchronously.
   */
  synchronous?: InputMaybe<Scalars['Boolean']>;
  /**
   * The new collection of events that would recalculate membership for segments that utilize this
   * numeric attribute.
   */
  triggeringEvents?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type UpdateStringEnumAttributeInput = {
  /** Whether this string enum attribute is actively in use. */
  active?: InputMaybe<Scalars['Boolean']>;
  /** The new collection of comparator alias overrides for this string enum attribute. */
  comparatorAliases?: InputMaybe<Array<InputMaybe<ComparatorAliasInput>>>;
  /** The new description of the string enum attribute */
  description?: InputMaybe<Scalars['String']>;
  /** The new array of possible values that this string enum attribute supports. */
  enumeratedValues?: InputMaybe<Array<Scalars['String']>>;
  /** The new query that defines membership for this string enum attribute. */
  memberQuery?: InputMaybe<Scalars['String']>;
  /** The new name of the string enum attribute. */
  name?: InputMaybe<Scalars['String']>;
  /**
   * Whether recalculation of the attribute's membership requires the listed triggering events to
   * be fired synchronously.
   */
  synchronous?: InputMaybe<Scalars['Boolean']>;
  /**
   * The new collection of events that would recalculate membership for segments that utilize this
   * string enum attribute.
   */
  triggeringEvents?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type UpdateTextAttributeInput = {
  /** Whether this text attribute is actively in use. */
  active?: InputMaybe<Scalars['Boolean']>;
  /** The new collection of comparator alias overrides for this text attribute. */
  comparatorAliases?: InputMaybe<Array<InputMaybe<ComparatorAliasInput>>>;
  /** The new description of the text attribute */
  description?: InputMaybe<Scalars['String']>;
  /** The new query that defines membership for this text attribute. */
  memberQuery?: InputMaybe<Scalars['String']>;
  /** The new name of the text attribute. */
  name?: InputMaybe<Scalars['String']>;
  /**
   * Whether recalculation of the attribute's membership requires the listed triggering events to
   * be fired synchronously.
   */
  synchronous?: InputMaybe<Scalars['Boolean']>;
  /**
   * The new collection of events that would recalculate membership for segments that utilize this
   * text attribute.
   */
  triggeringEvents?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

/** A single OhmConnect user account */
export type User = {
  __typename?: 'User';
  /**
   * This field describes whether or not the user's account requires additional action
   * in order for it to be fully ready to participate in the program
   */
  accountSetupStatus?: Maybe<AccountSetupStatus>;
  /** The inventory of a user's appliances */
  applianceInventory?: Maybe<UserApplianceInventory>;
  /** The user's avatar/profile picture url, if applicable, otherwise null. */
  avatarUrl?: Maybe<Scalars['String']>;
  birthDate?: Maybe<Scalars['ISODate']>;
  /** Attribution campaign from UserAddTracking */
  campaign?: Maybe<Scalars['String']>;
  /** Attribution channel from UserAddTracking */
  channel?: Maybe<Scalars['String']>;
  /** Retrieves PCE content for a given user, optionally for a given set of placements */
  content: Array<PceContentInstance>;
  /** This field is allowed to be null, as not all users will have the feature enabled */
  currentDeviceLoadReport?: Maybe<UserDeviceLoadReport>;
  /** A running count of the number of consecutive energy events the user has successfully participated in */
  currentEnergyEventStreakCount?: Maybe<Scalars['Int']>;
  /**
   * This field will only be populated with an event which is currently in progress,
   * otherwise it is null.
   */
  currentEvent?: Maybe<UserEnergyEvent>;
  /** Current energy usage for the month in kilowatt-hours. */
  currentKwh?: Maybe<Scalars['Float']>;
  /** The user's current utility service. */
  currentUtilityService?: Maybe<UserUtilityService>;
  /** Retrieves a single device by device id, returns null if device does not exist */
  device?: Maybe<Device>;
  /** The list of device account connnections which the user has configured */
  deviceAccountConnections: Array<DeviceAccountConnection>;
  /** The primary name by which the OhmConnect system refers to this user. */
  displayName: Scalars['String'];
  /** The primary email address used by the user to sign up and log in. */
  emailAddress: Scalars['String'];
  /**
   * List of the user's events.
   *
   * Optional arguments allow for changing the sort order as well as pagination and
   * optionally omitting upcoming events.
   */
  events: Array<UserEnergyEvent>;
  /** ID used to link frontend and backend Facebook pings */
  fbConversionId?: Maybe<Scalars['ID']>;
  /**
   * All the features the user has access to;
   * for administrators, this includes features they do not currently
   * have enabled, in order to populate a full list of possible features.
   */
  features: Array<Feature>;
  firstName?: Maybe<Scalars['String']>;
  /** User specific data regarding Google Rush Hour Rewards */
  googleRhr?: Maybe<UserGoogleRhrData>;
  /**
   * The user's meter data from their current utility connection.
   *
   * > ⚠️ There is currently an upper limit of 45 * 24 hour intervals retrievable via this API.
   * A pagination implementation is on our roadmap, and if you require this please let us know so that we may prioritize accordingly
   */
  hourlyMeterUsage: Array<Maybe<UserHourlyMeterUsage>>;
  id: Scalars['ID'];
  isAdmin?: Maybe<Scalars['Boolean']>;
  lastName?: Maybe<Scalars['String']>;
  /** Get leaderboards of various types for the user. Note: currently only referrals are supported. */
  leaderboard?: Maybe<Leaderboard>;
  /** Contains information about the user's overall performance stats for energy events. */
  overallPerformanceStats?: Maybe<OverallPerformanceStats>;
  /** Get a specific partner link for the user by supplying the  [`partnerKey`]({{Partner.key}}) */
  partnerUser?: Maybe<PartnerUser>;
  /** The list of all partners which the user is linked to */
  partnerUsers: Array<PartnerUser>;
  /** List of all user's phone numbers and their associated verification statuses */
  phoneNumbers?: Maybe<Array<Maybe<PhoneVerificationProgress>>>;
  /** Retrieves PCE placements with content for a given user, optionally for a given set of placements */
  placements: Array<PceContentPlacement>;
  /**
   * The collection of estimated rate plan costs for the user. This includes estimated yearly costs of
   * their current plan, as well as estimated yearly costs of alternative rate plans that might be available
   * for them to switch to.
   */
  ratePlanOptimizerResult?: Maybe<RatePlanOptimizerResult>;
  /** The user's custom URL for referring others to join; users earn rewards when their referrals join using this URL. */
  referralUrl: Scalars['String'];
  /** Status of enrollment in Texas retail energy */
  retailEnrollmentProgress?: Maybe<UserRetailEnrollmentProgress>;
  /** The predicted annual savings results calculated from a user's submitted mini home survey responses. */
  savingsCalculatorResult?: Maybe<SavingsCalculatorResult>;
  /** The user's telus bravo points balance. */
  telusBravoPoints?: Maybe<Scalars['Int']>;
  /**
   * The user's tier is determined by their performance in energy saving events,
   * and it grants specific discounts on rewards as well as bonus multipliers for
   * some types of point earnings.
   */
  tier?: Maybe<UserTier>;
  /**
   * The user's timezone, which is based on the zip-code provided by the user at signup,
   * and later from location data provided with the user's utility service authorization.
   */
  timezone?: Maybe<Timezone>;
  /** collection of attributes for UI state */
  uiAttributes: UserInterfaceAttributes;
  /** Contains all of the data necessary for specific UI customizations that the user has. */
  uiCustomization: UiCustomization;
  /** List of the user's upcoming events. */
  upcomingEvents: Array<UserEnergyEvent>;
  /** This user's state for the User's First Device free device. */
  usersFirstDeviceFreeDevice: UsersFirstDeviceFreeDeviceState;
  /** Information regarding the user's rewards from the OhmConnect system. */
  wallet: UserWallet;
};


/** A single OhmConnect user account */
export type UserContentArgs = {
  placements?: InputMaybe<Array<PcePlacement>>;
};


/** A single OhmConnect user account */
export type UserDeviceArgs = {
  deviceId: Scalars['ID'];
};


/** A single OhmConnect user account */
export type UserEventsArgs = {
  count?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<ChronologicalOrder>;
  skip?: InputMaybe<Scalars['Int']>;
};


/** A single OhmConnect user account */
export type UserHourlyMeterUsageArgs = {
  endDttm: Scalars['ISODatetime'];
  startDttm: Scalars['ISODatetime'];
};


/** A single OhmConnect user account */
export type UserLeaderboardArgs = {
  leaderboardKey: Scalars['ID'];
};


/** A single OhmConnect user account */
export type UserPartnerUserArgs = {
  partnerKey: Scalars['ID'];
};


/** A single OhmConnect user account */
export type UserPlacementsArgs = {
  placements?: InputMaybe<Array<PcePlacement>>;
};

/** A user's inventory of appliances */
export type UserApplianceInventory = {
  __typename?: 'UserApplianceInventory';
  /** All of the possible appliance definitions */
  applianceDefinitions: Array<ApplianceInventoryApplianceDefinition>;
  /** All of the possible categories which contain appliance definitions */
  categories: Array<ApplianceInventoryCategory>;
  /** The unique identifier of the user appliance inventory */
  id: Scalars['ID'];
  /** All of the appliances the user has */
  userAppliances: Array<ApplianceInventoryUserAppliance>;
  /** Whether or not the user has completed the appliance inventory all the way through */
  userHasCompletedInventory: Scalars['Boolean'];
  /** The award amount, if any, awarded to the user for completion */
  userWattsAwardedForCompletion?: Maybe<Scalars['Int']>;
};

/** A report to return how much load that load-monitoring devices are controlling. */
export type UserDeviceLoadReport = {
  __typename?: 'UserDeviceLoadReport';
  /**
   * The highest usage devices in the time period,
   * in descending order of load over the report period
   */
  highUsageDevices: Array<DeviceEnergyUsageReport>;
  id: Scalars['ID'];
  /**
   * The lowest usage devices in the time period,
   * in ascending order of load over the report period
   */
  lowUsageDevices: Array<DeviceEnergyUsageReport>;
  /**
   * The first date and time **not** included in the report
   * (exclusive end)
   */
  reportEnd: Scalars['ISODatetime'];
  /**
   * The earliest date and time included in the report
   * (inclusive start)
   */
  reportStart: Scalars['ISODatetime'];
};

/**
 * The UserEnergyEvent represents an individual user's participation in an energy event,
 * including their before-the-fact predicted performance and after-the-fact actual performance.
 */
export type UserEnergyEvent = {
  __typename?: 'UserEnergyEvent';
  /** A URL for the energy event in the OhmConnect application. */
  appUrl: Scalars['String'];
  /** The energy event which the user is participating in. */
  event: EnergyEvent;
  /**
   * The amount of energy the user has been forecast to use during the event time frame **if the event were not to happen**.
   * This is a counterfactual prediction which is used to assess the user's reductions during the event.
   * Null for users who do not have energy meter data.
   */
  forecast?: Maybe<UserEnergyEventForecast>;
  id: Scalars['ID'];
  /**
   * Indicates that the event has been "forgiven", meaning that any negative effects from the event have been reverted
   * (i.e. broken streaks or negative points awards).
   *
   * This may happen automatically if dispatch issues are detected, or may be manually triggered by customer support staff.
   */
  isForgiven: Scalars['Boolean'];
  /** Whether the user has manually opted out of the event. */
  isOptedOut: Scalars['Boolean'];
  /**
   * Whether the user is planned to participate in the event.
   * Will be false if the user has opted out, but may also be false for other reasons.
   */
  isParticipating: Scalars['Boolean'];
  /** The user's rewards from the event. */
  rewards?: Maybe<UserEnergyEventRewards>;
  /** The user's tier as of the event, which determines multipliers for the points rewarded. */
  tier: UserTier;
  /**
   * The amount of energy the user actually used during the event time frame.
   * Null for users who do not have energy meter data, or until energy meter data is available for the event timeframe.
   */
  usage?: Maybe<UserEnergyEventUsage>;
  /** The user who participated in the event. */
  user: User;
};

/**
 * The historical record of a user's energy usage for the same time window as an event on a previous day.
 * This is used to forecast a user's usage if the event were not to happen.
 */
export type UserEnergyEventBaselineRecord = {
  __typename?: 'UserEnergyEventBaselineRecord';
  /** The date of this baseline record; the time should be inferred from the time of the event to which this baseline applies. */
  date: Scalars['ISODate'];
  id: Scalars['ID'];
  /** The user's usage in kilowatt-hours. */
  usageKwh: Scalars['Float'];
};

/**
 * The user's forecast represents the prediction of their usage for the event timeframe *if the event were not happen*.
 *
 * This is a "counterfactual" prediction, used to gauge the user's actual reduction during the event.
 */
export type UserEnergyEventForecast = {
  __typename?: 'UserEnergyEventForecast';
  /**
   * An array of baseline records which describe the users prior energy meter data that was used to
   * calculate the forecast for this event.
   */
  baselineRecords: Array<UserEnergyEventBaselineRecord>;
  id: Scalars['ID'];
  /** The amount of energy the user is predicted to use during the event timeframe if they did not actively reduce. */
  kwh: Scalars['Float'];
  /** The datetime when this forecast was last updated. */
  lastUpdated: Scalars['ISODatetime'];
};

/**
 * The rewards earned by a user during an energy event. In advance of the event, this will represent *possible* rewards.
 *
 * ### 👷‍♀️ This type is still under development!
 */
export type UserEnergyEventRewards = {
  __typename?: 'UserEnergyEventRewards';
  devicePoints: Scalars['Int'];
  id: Scalars['ID'];
  /**
   * Whether or not the rewards listed are predictions for an upcoming event.
   *
   * If false, the values in this type may still be subject to change as energy meter data is resolved from the event.
   */
  isPredicted: Scalars['Boolean'];
  reductionPoints: Scalars['Int'];
};

/** The energy usage of the user during an event. */
export type UserEnergyEventUsage = {
  __typename?: 'UserEnergyEventUsage';
  id: Scalars['ID'];
  /** The percentage of the user's predicted baseline represented by this usage value. */
  percentageOfBaseline: Scalars['Float'];
  /** Energy usage, in kilowatt-hours. */
  usageKwh: Scalars['Float'];
};

/** User data relating to Google Rush Hour Rewards */
export type UserGoogleRhrData = {
  __typename?: 'UserGoogleRhrData';
  /**
   * The URI for OhmConnect to send the user to in order to enroll in RHR.
   * If empty, this user is not eligible to enroll in RHR
   *
   * This URI contains the Partner UUID, so it is unique per RHR partner/geography
   */
  enrollmentAppUri: Scalars['String'];
  /**
   * The partner API name (looks like a UUID) of the partner which we expect this user to be enrolled with
   * based on their current utility service zip code
   */
  expectedPartnerName: Scalars['ID'];
  /**
   * The terms and service URI for the partner which we expect this user to be enrolled with
   * based on their current utility service zip code
   */
  expectedTermsOfServiceUri: Scalars['String'];
  id: Scalars['ID'];
};

/** The UserHourlyMeterUsage represents an individual user's historical hourly kilowatt consumption. */
export type UserHourlyMeterUsage = {
  __typename?: 'UserHourlyMeterUsage';
  /** The start of the hour in which the associated quantity of kilowatts was consumed. */
  hourBeginning: Scalars['ISODatetime'];
  /** Total kilowatts used during the hour. */
  kw: Scalars['Float'];
};

export type UserInterfaceAttributes = {
  __typename?: 'UserInterfaceAttributes';
  /** the user's average bill amount */
  averageBill?: Maybe<Scalars['Int']>;
  /**
   * whether the user has seen the energy event explainer
   * 0 == has not been displayed
   * 1 == has been displayed and not dismissed
   * 2 == has been displayed and dismissed
   */
  energyEventExplainer?: Maybe<Scalars['Int']>;
  /** whether or not an event has been pushed to Google Tag Manger for Utility Connection conversion */
  gtmUtilityConnectionEventSent?: Maybe<Scalars['Int']>;
  /** a unique identifier of these user attributes for a user */
  id: Scalars['ID'];
  /** the index of the farthest screen the user has seen in the onboarding tutorial */
  spaNewUserOnboardingTutorial?: Maybe<Scalars['Int']>;
  /**
   * whether the user has seen in the onboarding welcome screen
   * 1 == the intro has been displayed and not dismissed
   * 2 == the intro has been dismissed
   */
  spaNewUserOnboardingWelcome?: Maybe<Scalars['Int']>;
  /** whether or not the user has seen the inventory completion award dialog */
  userHasSeenApplianceInventoryCompletionAwardDialog?: Maybe<Scalars['Int']>;
  /** the user's savings goal amount */
  userSavingsGoal?: Maybe<Scalars['String']>;
};

export type UserInterfaceAttributesInput = {
  /** the user's average bill amount */
  averageBill?: InputMaybe<Scalars['Int']>;
  /**
   * whether the user has seen the energy event explainer
   * 0 == has not been displayed
   * 1 == has been displayed and not dismissed
   * 2 == has been displayed and dismissed
   */
  energyEventExplainer?: InputMaybe<Scalars['Int']>;
  /** whether or not an event has been pushed to Google Tag Manger for Utility Connection conversion */
  gtmUtilityConnectionEventSent?: InputMaybe<Scalars['Int']>;
  /** the index of the farthest screen the user has seen in the onboarding tutorial */
  spaNewUserOnboardingTutorial?: InputMaybe<Scalars['Int']>;
  /**
   * whether the user has seen in the onboarding welcome screen
   * 1 == the intro has been displayed and not dismissed
   * 2 == the intro has been dismissed
   */
  spaNewUserOnboardingWelcome?: InputMaybe<Scalars['Int']>;
  /** whether or not the user has seen the inventory completion award dialog */
  userHasSeenApplianceInventoryCompletionAwardDialog?: InputMaybe<Scalars['Int']>;
  /** the user's savings goal amount */
  userSavingsGoal?: InputMaybe<Scalars['String']>;
};

export type UserRetailEnrollmentProgress = {
  __typename?: 'UserRetailEnrollmentProgress';
  agentId?: Maybe<Scalars['ID']>;
  /** Boolean value to indicate whether the applicant is the enrolling user or an authorized agent */
  authorizedAgent?: Maybe<Scalars['Boolean']>;
  /** Authorized Agent's first name */
  authorizedAgentFirstName?: Maybe<Scalars['String']>;
  /** Authorized Agent's last name: String */
  authorizedAgentLastName?: Maybe<Scalars['String']>;
  /** Boolean value to indicate whether the user accepted the terms for automated SMS messages */
  automatedTextAgreement?: Maybe<Scalars['Boolean']>;
  /** Billing address to use for payment - can be the same as service address */
  billingAddress?: Maybe<BillingAddress>;
  /** Selected language for communications */
  communicationLanguage?: Maybe<SmartgridLanguage>;
  /** If credit check returns an error, this will be set to the error code */
  creditCheckErrorCode?: Maybe<CreditCheckErrorCode>;
  /** Results of the user's credit check. Either above or below threshold, error or skipped */
  creditCheckResult?: Maybe<CreditCheckResult>;
  /** If the credit check has been skipped due to a waiver, this is the selected waiver reason */
  depositWaiverOption?: Maybe<DepositWaiverOptions>;
  /** True if the enrollment has been submitted to SGCIS / false otherwise */
  enrollmentCompleted: Scalars['Boolean'];
  /** Date that the enrollment was submitted to SGCIS */
  enrollmentCompletedDttm?: Maybe<Scalars['ISODatetime']>;
  /** Defines the current, previous, and next steps in the enrollment flow */
  enrollmentSteps?: Maybe<EnrollmentStep>;
  /** Results from the Experian Precise ID fraud check. */
  fraudCheckResult?: Maybe<FraudCheckResult>;
  /** Unique identifier for persisted enrollment progress */
  id: Scalars['ID'];
  /** Attribution variables */
  leadSourceId?: Maybe<Scalars['ID']>;
  /** Boolean to indicate whether the customer elects to have paperless billing */
  paperlessBilling?: Maybe<Scalars['Boolean']>;
  /** Passed-through promo code */
  promoCode?: Maybe<Scalars['String']>;
  /** Secondary account representative's first name in SmartGrid */
  secondaryRepresentativeFirstName?: Maybe<Scalars['String']>;
  /** Secondary account representative's last name in SmartGrid */
  secondaryRepresentativeLastName?: Maybe<Scalars['String']>;
  /** Secondary account representative's phone number in SmartGrid */
  secondaryRepresentativePhoneNumber?: Maybe<Scalars['String']>;
  /** The user's selected plan for enrollment, matches SGCIS product ID */
  selectedPlanId: Scalars['ID'];
  /** This is the selected service switch type (move addresses or switch providers) */
  serviceEnrollmentOption?: Maybe<ServiceEnrollmentOption>;
  /** Date that the service will be scheduled to start */
  serviceStartDt?: Maybe<Scalars['ISODate']>;
  /** User ID for the enrollment progress */
  userId: Scalars['ID'];
  /** The zipcode for the user */
  zipCode: Scalars['String'];
};

/**
 * A user's tier is determined by their performance in energy saving events
 * and is recalculated frequently.
 */
export enum UserTier {
  /** Second level user tier */
  Bronze = 'BRONZE',
  /** First level user tier */
  Carbon = 'CARBON',
  /** Sixth and highest level user tier */
  Diamond = 'DIAMOND',
  /** Fourth level user tier */
  Gold = 'GOLD',
  /** Fifth level user tier */
  Platinum = 'PLATINUM',
  /** Third level user tier */
  Silver = 'SILVER'
}

/**
 * The UserUtilityService represents information regarding a user's connected utility account
 * as well as their physical location.
 *
 * > ⚠️ It is important to note that even users who have not yet connected a Utility Account will
 * have this node available, but the `utility` field should be null.
 */
export type UserUtilityService = {
  __typename?: 'UserUtilityService';
  /** Utility service's first address line */
  address?: Maybe<Scalars['String']>;
  /** City the service address is located in */
  city?: Maybe<Scalars['String']>;
  /** For retail enrollments, this is the type of property (house, apartment or trailer) */
  dwellingType?: Maybe<DwellingType>;
  /** When this utility service ended with OhmConnect, if at all. */
  end?: Maybe<Scalars['ISODatetime']>;
  /** For retail enrollments, this is the numerical ID of the user's meter */
  esiid?: Maybe<Scalars['String']>;
  /** The first date that this utility service has data for. */
  firstData?: Maybe<Scalars['ISODate']>;
  id: Scalars['ID'];
  /** Is this utility service active. */
  isActive?: Maybe<Scalars['Boolean']>;
  /** The last date that this utility service has data for. */
  lastData?: Maybe<Scalars['ISODate']>;
  /** When this utility service became active with OhmConnect. */
  start?: Maybe<Scalars['ISODatetime']>;
  /** State the service address is located in */
  state?: Maybe<Scalars['String']>;
  /** The user who owns the utility service. */
  user: User;
  /**
   * The utility which the user pays for electricity.
   *
   * This *may not* be the company which actually owns the meter/lines,
   * such as is the case with a Community Choice Aggregator (CCA).
   */
  utility?: Maybe<Utility>;
  /** 5 digit zip code the address is located in */
  zipCode?: Maybe<Scalars['String']>;
};

/** Contains all of the user's rewards and cash-value which they have earned. */
export type UserWallet = {
  __typename?: 'UserWallet';
  /** The user's cash balance. */
  cash?: Maybe<Scalars['Int']>;
  /** The currency of the user's cash. */
  cashCurrency?: Maybe<CashCurrency>;
  /** Unique id of the user's wallet. */
  id: Scalars['ID'];
  /** The user's lifetime points. */
  lifetimePoints?: Maybe<Scalars['Int']>;
  /**
   * The user's points balance; points are an internal reward which have
   * a variable redemption value based on the user's tier.
   */
  points?: Maybe<Scalars['Int']>;
  /** The currency of the user's points. */
  pointsCurrency?: Maybe<PointsCurrency>;
};

export enum UsersFirstDeviceClaimFreeDeviceResult {
  AlreadyClaimed = 'ALREADY_CLAIMED',
  NotEligible = 'NOT_ELIGIBLE',
  Ok = 'OK',
  UnexpectedFailure = 'UNEXPECTED_FAILURE'
}

/** An offer for a free device */
export type UsersFirstDeviceFreeDeviceState = {
  __typename?: 'UsersFirstDeviceFreeDeviceState';
  id: Scalars['ID'];
  /**
   * The reward which is being offered to this user (or which they already claimed).
   * This will be null if the user is not eligible.
   */
  reward?: Maybe<Reward>;
  status: UsersFirstDeviceFreeDeviceStatus;
};

export enum UsersFirstDeviceFreeDeviceStatus {
  Claimed = 'CLAIMED',
  Connected = 'CONNECTED',
  Delivered = 'DELIVERED',
  Eligible = 'ELIGIBLE',
  NotEligible = 'NOT_ELIGIBLE',
  Shipped = 'SHIPPED'
}

/** Mutations relating to the User's Device Initiative (see ON-8211) */
export type UsersFirstDeviceOp = {
  __typename?: 'UsersFirstDeviceOp';
  /**
   * Tries to claim the user's free device as part of the User's First Device initiative (ON-8245)
   *
   * Automatically handles checking eligibility and preventing duplicate redemptions
   */
  claimFreeDevice: UsersFirstDeviceClaimFreeDeviceResult;
};

export type Utility = {
  __typename?: 'Utility';
  /** Acronym is used for quick identification and matching in some cases. */
  acronym?: Maybe<Scalars['ID']>;
  id: Scalars['ID'];
  /** The user-visible short name of the utility, often contains extra symbols like `&`. */
  shortName?: Maybe<Scalars['String']>;
  /** The user-visible name of the utility. */
  title: Scalars['String'];
};

export enum VerificationStatus {
  CodeSent = 'CODE_SENT',
  NotVerified = 'NOT_VERIFIED',
  Verified = 'VERIFIED'
}

export type DeviceEnergyUsageFragmentFragment = { __typename?: 'DevicePowerConsumptionHourly', id: string, hourStartDttm: string, consumptionWattHours: number };

export type GoogleRhrSendOffDataFragment = { __typename?: 'User', googleRhr?: { __typename?: 'UserGoogleRhrData', id: string, enrollmentAppUri: string, expectedPartnerName: string, expectedTermsOfServiceUri: string } | null };

export type ExperienceManagerFeatureFragmentFragment = { __typename?: 'Feature', _id: string, key: string, isEnabled: boolean, description?: string | null, userOverrideState?: OverrideState | null };

export type App_DrUi_PceContentInstanceFragmentFragment = { __typename?: 'PceContentInstance', id: string, displayContent: { __typename?: 'PceDisplayContent', textWithCta?: { __typename?: 'PceTextWithCtaDisplay', id: string, title?: string | null, subtitle?: string | null, icon?: string | null, content?: string | null, imageUrl?: string | null, subtext?: string | null, ctas?: Array<{ __typename?: 'CtaDisplay', label: string, url?: string | null, level: CtaLevel }> | null } | null } };

export type App_DrUi_PceContentPlacementFragmentFragment = { __typename?: 'PceContentPlacement', id: PcePlacement, userInstances: Array<{ __typename?: 'PceContentInstance', id: string, displayContent: { __typename?: 'PceDisplayContent', textWithCta?: { __typename?: 'PceTextWithCtaDisplay', id: string, title?: string | null, subtitle?: string | null, icon?: string | null, content?: string | null, imageUrl?: string | null, subtext?: string | null, ctas?: Array<{ __typename?: 'CtaDisplay', label: string, url?: string | null, level: CtaLevel }> | null } | null } }> };

export type App_DrUi_PceTextWithCtaDisplayContentFragmentFragment = { __typename?: 'PceTextWithCtaDisplay', id: string, title?: string | null, subtitle?: string | null, icon?: string | null, content?: string | null, imageUrl?: string | null, subtext?: string | null, ctas?: Array<{ __typename?: 'CtaDisplay', label: string, url?: string | null, level: CtaLevel }> | null };

export type App_DrUi_PceCtaDisplayFragmentFragment = { __typename?: 'CtaDisplay', label: string, url?: string | null, level: CtaLevel };

export type App_DrUi_PceDisplayContentFragmentFragment = { __typename?: 'PceDisplayContent', textWithCta?: { __typename?: 'PceTextWithCtaDisplay', id: string, title?: string | null, subtitle?: string | null, icon?: string | null, content?: string | null, imageUrl?: string | null, subtext?: string | null, ctas?: Array<{ __typename?: 'CtaDisplay', label: string, url?: string | null, level: CtaLevel }> | null } | null };

export type App_DrUi_PcePlacementsQueryVariables = Exact<{
  placements?: InputMaybe<Array<PcePlacement> | PcePlacement>;
}>;


export type App_DrUi_PcePlacementsQuery = { __typename?: 'Query', currentSession: { __typename?: 'Session', user?: { __typename?: 'User', placements: Array<{ __typename?: 'PceContentPlacement', id: PcePlacement, userInstances: Array<{ __typename?: 'PceContentInstance', id: string, displayContent: { __typename?: 'PceDisplayContent', textWithCta?: { __typename?: 'PceTextWithCtaDisplay', id: string, title?: string | null, subtitle?: string | null, icon?: string | null, content?: string | null, imageUrl?: string | null, subtext?: string | null, ctas?: Array<{ __typename?: 'CtaDisplay', label: string, url?: string | null, level: CtaLevel }> | null } | null } }> }> } | null } };

export type ReferralLeaderboardFragmentFragment = { __typename?: 'Leaderboard', id: string, name: string, type: LeaderboardType, statName: string, leaders: Array<{ __typename?: 'LeaderboardEntry', id: string, rank: number, name: string, statValue: number } | null> };

export type UserUfdFreeDeviceFragmentFragment = { __typename?: 'User', usersFirstDeviceFreeDevice: { __typename?: 'UsersFirstDeviceFreeDeviceState', id: string, reward?: { __typename?: 'Reward', id: string, displayTitle: string, displaySubtitle: string, displayDescription: string, basePricePoints: number, displayImageUrl: string } | null } };

export type AttributeComparatorFragmentFragment = { __typename?: 'AttributeComparator', id: string, name: string, nameShort: string, attributeFilter: AttributeFilterType };

export type FilterComparatorFragmentFragment = { __typename?: 'FilterComparator', id: string, name: string, nameShort: string };

type AttributeFragment_BooleanAttribute_Fragment = { __typename?: 'BooleanAttribute', id: string, name: string, dataType: AttributeDataType, comparators: Array<{ __typename?: 'AttributeComparator', id: string, name: string, nameShort: string, attributeFilter: AttributeFilterType }> };

type AttributeFragment_DateAttribute_Fragment = { __typename?: 'DateAttribute', id: string, name: string, dataType: AttributeDataType, minimumAllowableDate?: string | null, maximumAllowableDate?: string | null, comparators: Array<{ __typename?: 'AttributeComparator', id: string, name: string, nameShort: string, attributeFilter: AttributeFilterType }> };

type AttributeFragment_DatetimeAttribute_Fragment = { __typename?: 'DatetimeAttribute', id: string, name: string, dataType: AttributeDataType, minimumAllowableDttm?: string | null, maximumAllowableDttm?: string | null, comparators: Array<{ __typename?: 'AttributeComparator', id: string, name: string, nameShort: string, attributeFilter: AttributeFilterType }> };

type AttributeFragment_NumericAttribute_Fragment = { __typename?: 'NumericAttribute', id: string, name: string, dataType: AttributeDataType, minimumAllowableValue?: number | null, maximumAllowableValue?: number | null, comparators: Array<{ __typename?: 'AttributeComparator', id: string, name: string, nameShort: string, attributeFilter: AttributeFilterType }> };

type AttributeFragment_StringEnumAttribute_Fragment = { __typename?: 'StringEnumAttribute', id: string, name: string, dataType: AttributeDataType, enumeratedValues: Array<string>, comparators: Array<{ __typename?: 'AttributeComparator', id: string, name: string, nameShort: string, attributeFilter: AttributeFilterType }> };

type AttributeFragment_TextAttribute_Fragment = { __typename?: 'TextAttribute', id: string, name: string, dataType: AttributeDataType, comparators: Array<{ __typename?: 'AttributeComparator', id: string, name: string, nameShort: string, attributeFilter: AttributeFilterType }> };

export type AttributeFragmentFragment = AttributeFragment_BooleanAttribute_Fragment | AttributeFragment_DateAttribute_Fragment | AttributeFragment_DatetimeAttribute_Fragment | AttributeFragment_NumericAttribute_Fragment | AttributeFragment_StringEnumAttribute_Fragment | AttributeFragment_TextAttribute_Fragment;

export type AttributeFilterSegmentFragmentFragment = { __typename?: 'AttributeFilterSegment', id: string, name: string, description: string, active: boolean, activelyEnrolling: boolean, attribute: { __typename?: 'BooleanAttribute', id: string, name: string, dataType: AttributeDataType, comparators: Array<{ __typename?: 'AttributeComparator', id: string, name: string, nameShort: string, attributeFilter: AttributeFilterType }> } | { __typename?: 'DateAttribute', id: string, name: string, dataType: AttributeDataType, minimumAllowableDate?: string | null, maximumAllowableDate?: string | null, comparators: Array<{ __typename?: 'AttributeComparator', id: string, name: string, nameShort: string, attributeFilter: AttributeFilterType }> } | { __typename?: 'DatetimeAttribute', id: string, name: string, dataType: AttributeDataType, minimumAllowableDttm?: string | null, maximumAllowableDttm?: string | null, comparators: Array<{ __typename?: 'AttributeComparator', id: string, name: string, nameShort: string, attributeFilter: AttributeFilterType }> } | { __typename?: 'NumericAttribute', id: string, name: string, dataType: AttributeDataType, minimumAllowableValue?: number | null, maximumAllowableValue?: number | null, comparators: Array<{ __typename?: 'AttributeComparator', id: string, name: string, nameShort: string, attributeFilter: AttributeFilterType }> } | { __typename?: 'StringEnumAttribute', id: string, name: string, dataType: AttributeDataType, enumeratedValues: Array<string>, comparators: Array<{ __typename?: 'AttributeComparator', id: string, name: string, nameShort: string, attributeFilter: AttributeFilterType }> } | { __typename?: 'TextAttribute', id: string, name: string, dataType: AttributeDataType, comparators: Array<{ __typename?: 'AttributeComparator', id: string, name: string, nameShort: string, attributeFilter: AttributeFilterType }> }, filter: { __typename?: 'BooleanAttributeFilter', id: string, booleanValue: boolean, comparator: { __typename?: 'FilterComparator', id: string, name: string, nameShort: string } } | { __typename?: 'DateRangeAttributeFilter', id: string, minDate: string, maxDate: string, comparator: { __typename?: 'FilterComparator', id: string, name: string, nameShort: string } } | { __typename?: 'DateSimpleAttributeFilter', id: string, dateValue: string, comparator: { __typename?: 'FilterComparator', id: string, name: string, nameShort: string } } | { __typename?: 'DatetimeRangeAttributeFilter', id: string, minDatetime: string, maxDatetime: string, comparator: { __typename?: 'FilterComparator', id: string, name: string, nameShort: string } } | { __typename?: 'DatetimeSimpleAttributeFilter', id: string, datetimeValue: string, comparator: { __typename?: 'FilterComparator', id: string, name: string, nameShort: string } } | { __typename?: 'EnumAttributeFilter', id: string, enumValues: Array<string | null>, comparator: { __typename?: 'FilterComparator', id: string, name: string, nameShort: string } } | { __typename?: 'NumericRangeAttributeFilter', id: string, minValue: number, maxValue: number, comparator: { __typename?: 'FilterComparator', id: string, name: string, nameShort: string } } | { __typename?: 'NumericSimpleAttributeFilter', id: string, numericValue: number, comparator: { __typename?: 'FilterComparator', id: string, name: string, nameShort: string } } | { __typename?: 'TextAttributeFilter', id: string, textValue: string, comparator: { __typename?: 'FilterComparator', id: string, name: string, nameShort: string } } };

export type CodeDefinedSegmentFragmentFragment = { __typename?: 'CodeDefinedSegment', id: string, name: string, description: string, active: boolean, activelyEnrolling: boolean };

export type CompoundSegmentFragmentFragment = { __typename?: 'CompoundSegment', id: string, name: string, description: string, active: boolean, activelyEnrolling: boolean, composition: Array<{ __typename?: 'SegmentGroup', id: string, name?: string | null, segmentSpecs: Array<{ __typename?: 'SegmentSpec', id: string, invert: boolean, segment: { __typename?: 'AttributeFilterSegment', id: string, name: string, description: string, active: boolean, activelyEnrolling: boolean, attribute: { __typename?: 'BooleanAttribute', id: string, name: string, dataType: AttributeDataType, comparators: Array<{ __typename?: 'AttributeComparator', id: string, name: string, nameShort: string, attributeFilter: AttributeFilterType }> } | { __typename?: 'DateAttribute', id: string, name: string, dataType: AttributeDataType, minimumAllowableDate?: string | null, maximumAllowableDate?: string | null, comparators: Array<{ __typename?: 'AttributeComparator', id: string, name: string, nameShort: string, attributeFilter: AttributeFilterType }> } | { __typename?: 'DatetimeAttribute', id: string, name: string, dataType: AttributeDataType, minimumAllowableDttm?: string | null, maximumAllowableDttm?: string | null, comparators: Array<{ __typename?: 'AttributeComparator', id: string, name: string, nameShort: string, attributeFilter: AttributeFilterType }> } | { __typename?: 'NumericAttribute', id: string, name: string, dataType: AttributeDataType, minimumAllowableValue?: number | null, maximumAllowableValue?: number | null, comparators: Array<{ __typename?: 'AttributeComparator', id: string, name: string, nameShort: string, attributeFilter: AttributeFilterType }> } | { __typename?: 'StringEnumAttribute', id: string, name: string, dataType: AttributeDataType, enumeratedValues: Array<string>, comparators: Array<{ __typename?: 'AttributeComparator', id: string, name: string, nameShort: string, attributeFilter: AttributeFilterType }> } | { __typename?: 'TextAttribute', id: string, name: string, dataType: AttributeDataType, comparators: Array<{ __typename?: 'AttributeComparator', id: string, name: string, nameShort: string, attributeFilter: AttributeFilterType }> }, filter: { __typename?: 'BooleanAttributeFilter', id: string, booleanValue: boolean, comparator: { __typename?: 'FilterComparator', id: string, name: string, nameShort: string } } | { __typename?: 'DateRangeAttributeFilter', id: string, minDate: string, maxDate: string, comparator: { __typename?: 'FilterComparator', id: string, name: string, nameShort: string } } | { __typename?: 'DateSimpleAttributeFilter', id: string, dateValue: string, comparator: { __typename?: 'FilterComparator', id: string, name: string, nameShort: string } } | { __typename?: 'DatetimeRangeAttributeFilter', id: string, minDatetime: string, maxDatetime: string, comparator: { __typename?: 'FilterComparator', id: string, name: string, nameShort: string } } | { __typename?: 'DatetimeSimpleAttributeFilter', id: string, datetimeValue: string, comparator: { __typename?: 'FilterComparator', id: string, name: string, nameShort: string } } | { __typename?: 'EnumAttributeFilter', id: string, enumValues: Array<string | null>, comparator: { __typename?: 'FilterComparator', id: string, name: string, nameShort: string } } | { __typename?: 'NumericRangeAttributeFilter', id: string, minValue: number, maxValue: number, comparator: { __typename?: 'FilterComparator', id: string, name: string, nameShort: string } } | { __typename?: 'NumericSimpleAttributeFilter', id: string, numericValue: number, comparator: { __typename?: 'FilterComparator', id: string, name: string, nameShort: string } } | { __typename?: 'TextAttributeFilter', id: string, textValue: string, comparator: { __typename?: 'FilterComparator', id: string, name: string, nameShort: string } } } | { __typename?: 'CodeDefinedSegment', id: string, name: string, description: string, active: boolean, activelyEnrolling: boolean } | { __typename?: 'CompoundSegment', id: string, name: string, description: string, active: boolean, activelyEnrolling: boolean, composition: Array<{ __typename?: 'SegmentGroup', id: string, segmentSpecs: Array<{ __typename?: 'SegmentSpec', id: string, invert: boolean, segment: { __typename?: 'AttributeFilterSegment', id: string, name: string, description: string, active: boolean, activelyEnrolling: boolean, attribute: { __typename?: 'BooleanAttribute', id: string, name: string, dataType: AttributeDataType, comparators: Array<{ __typename?: 'AttributeComparator', id: string, name: string, nameShort: string, attributeFilter: AttributeFilterType }> } | { __typename?: 'DateAttribute', id: string, name: string, dataType: AttributeDataType, minimumAllowableDate?: string | null, maximumAllowableDate?: string | null, comparators: Array<{ __typename?: 'AttributeComparator', id: string, name: string, nameShort: string, attributeFilter: AttributeFilterType }> } | { __typename?: 'DatetimeAttribute', id: string, name: string, dataType: AttributeDataType, minimumAllowableDttm?: string | null, maximumAllowableDttm?: string | null, comparators: Array<{ __typename?: 'AttributeComparator', id: string, name: string, nameShort: string, attributeFilter: AttributeFilterType }> } | { __typename?: 'NumericAttribute', id: string, name: string, dataType: AttributeDataType, minimumAllowableValue?: number | null, maximumAllowableValue?: number | null, comparators: Array<{ __typename?: 'AttributeComparator', id: string, name: string, nameShort: string, attributeFilter: AttributeFilterType }> } | { __typename?: 'StringEnumAttribute', id: string, name: string, dataType: AttributeDataType, enumeratedValues: Array<string>, comparators: Array<{ __typename?: 'AttributeComparator', id: string, name: string, nameShort: string, attributeFilter: AttributeFilterType }> } | { __typename?: 'TextAttribute', id: string, name: string, dataType: AttributeDataType, comparators: Array<{ __typename?: 'AttributeComparator', id: string, name: string, nameShort: string, attributeFilter: AttributeFilterType }> }, filter: { __typename?: 'BooleanAttributeFilter', id: string, booleanValue: boolean, comparator: { __typename?: 'FilterComparator', id: string, name: string, nameShort: string } } | { __typename?: 'DateRangeAttributeFilter', id: string, minDate: string, maxDate: string, comparator: { __typename?: 'FilterComparator', id: string, name: string, nameShort: string } } | { __typename?: 'DateSimpleAttributeFilter', id: string, dateValue: string, comparator: { __typename?: 'FilterComparator', id: string, name: string, nameShort: string } } | { __typename?: 'DatetimeRangeAttributeFilter', id: string, minDatetime: string, maxDatetime: string, comparator: { __typename?: 'FilterComparator', id: string, name: string, nameShort: string } } | { __typename?: 'DatetimeSimpleAttributeFilter', id: string, datetimeValue: string, comparator: { __typename?: 'FilterComparator', id: string, name: string, nameShort: string } } | { __typename?: 'EnumAttributeFilter', id: string, enumValues: Array<string | null>, comparator: { __typename?: 'FilterComparator', id: string, name: string, nameShort: string } } | { __typename?: 'NumericRangeAttributeFilter', id: string, minValue: number, maxValue: number, comparator: { __typename?: 'FilterComparator', id: string, name: string, nameShort: string } } | { __typename?: 'NumericSimpleAttributeFilter', id: string, numericValue: number, comparator: { __typename?: 'FilterComparator', id: string, name: string, nameShort: string } } | { __typename?: 'TextAttributeFilter', id: string, textValue: string, comparator: { __typename?: 'FilterComparator', id: string, name: string, nameShort: string } } } | { __typename?: 'CodeDefinedSegment', id: string, name: string, description: string, active: boolean, activelyEnrolling: boolean } | { __typename?: 'CompoundSegment', id: string, name: string, description: string, active: boolean, activelyEnrolling: boolean } }> }> } }> }> };

export type SegmentEditAttributeComparatorFragmentFragment = { __typename?: 'AttributeComparator', id: string, name: string, nameShort: string, attributeFilter: AttributeFilterType };

type SegmentEditAttributeFragment_BooleanAttribute_Fragment = { __typename?: 'BooleanAttribute', id: string, name: string, dataType: AttributeDataType, comparators: Array<{ __typename?: 'AttributeComparator', id: string, name: string, nameShort: string, attributeFilter: AttributeFilterType }> };

type SegmentEditAttributeFragment_DateAttribute_Fragment = { __typename?: 'DateAttribute', id: string, name: string, dataType: AttributeDataType, minimumAllowableDate?: string | null, maximumAllowableDate?: string | null, comparators: Array<{ __typename?: 'AttributeComparator', id: string, name: string, nameShort: string, attributeFilter: AttributeFilterType }> };

type SegmentEditAttributeFragment_DatetimeAttribute_Fragment = { __typename?: 'DatetimeAttribute', id: string, name: string, dataType: AttributeDataType, minimumAllowableDttm?: string | null, maximumAllowableDttm?: string | null, comparators: Array<{ __typename?: 'AttributeComparator', id: string, name: string, nameShort: string, attributeFilter: AttributeFilterType }> };

type SegmentEditAttributeFragment_NumericAttribute_Fragment = { __typename?: 'NumericAttribute', id: string, name: string, dataType: AttributeDataType, minimumAllowableValue?: number | null, maximumAllowableValue?: number | null, comparators: Array<{ __typename?: 'AttributeComparator', id: string, name: string, nameShort: string, attributeFilter: AttributeFilterType }> };

type SegmentEditAttributeFragment_StringEnumAttribute_Fragment = { __typename?: 'StringEnumAttribute', id: string, name: string, dataType: AttributeDataType, enumeratedValues: Array<string>, comparators: Array<{ __typename?: 'AttributeComparator', id: string, name: string, nameShort: string, attributeFilter: AttributeFilterType }> };

type SegmentEditAttributeFragment_TextAttribute_Fragment = { __typename?: 'TextAttribute', id: string, name: string, dataType: AttributeDataType, comparators: Array<{ __typename?: 'AttributeComparator', id: string, name: string, nameShort: string, attributeFilter: AttributeFilterType }> };

export type SegmentEditAttributeFragmentFragment = SegmentEditAttributeFragment_BooleanAttribute_Fragment | SegmentEditAttributeFragment_DateAttribute_Fragment | SegmentEditAttributeFragment_DatetimeAttribute_Fragment | SegmentEditAttributeFragment_NumericAttribute_Fragment | SegmentEditAttributeFragment_StringEnumAttribute_Fragment | SegmentEditAttributeFragment_TextAttribute_Fragment;

export type BrandLogoFieldsFragment = { __typename?: 'User', uiCustomization: { __typename?: 'UiCustomization', customBrandBarImageUrl?: string | null } };

export type GetApplianceInventoryCtaUserApplianceInventoryQueryVariables = Exact<{ [key: string]: never; }>;


export type GetApplianceInventoryCtaUserApplianceInventoryQuery = { __typename?: 'Query', currentSession: { __typename?: 'Session', user?: { __typename?: 'User', applianceInventory?: { __typename?: 'UserApplianceInventory', id: string, userHasCompletedInventory: boolean } | null } | null } };

export type GetApplianceInventoryInitialCompletionQueryVariables = Exact<{ [key: string]: never; }>;


export type GetApplianceInventoryInitialCompletionQuery = { __typename?: 'Query', currentSession: { __typename?: 'Session', user?: { __typename?: 'User', applianceInventory?: { __typename?: 'UserApplianceInventory', id: string, userHasCompletedInventory: boolean, userWattsAwardedForCompletion?: number | null } | null } | null } };

export type GetCurrentDeviceLoadReportQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCurrentDeviceLoadReportQuery = { __typename?: 'Query', currentSession: { __typename?: 'Session', user?: { __typename?: 'User', currentDeviceLoadReport?: { __typename?: 'UserDeviceLoadReport', id: string, reportStart: string, reportEnd: string, highUsageDevices: Array<{ __typename?: 'DeviceEnergyUsageReport', id: string, consumptionKWh: number, device: { __typename?: 'Device', id: string, name?: string | null, displayName?: string | null } }>, lowUsageDevices: Array<{ __typename?: 'DeviceEnergyUsageReport', id: string, consumptionKWh: number, device: { __typename?: 'Device', id: string, name?: string | null, displayName?: string | null } }> } | null } | null } };

export type GetDeviceByIdQueryVariables = Exact<{
  deviceId: Scalars['ID'];
  page?: InputMaybe<Scalars['Int']>;
  perPage?: InputMaybe<Scalars['Int']>;
}>;


export type GetDeviceByIdQuery = { __typename?: 'Query', currentSession: { __typename?: 'Session', user?: { __typename?: 'User', device?: { __typename?: 'Device', id: string, deviceEventLogs: Array<{ __typename?: 'DeviceEventLog', id: string, turnOffState?: DeviceTurnOffState | null, turnOffDttm?: string | null, turnOnDttm?: string | null, turnOnState?: DeviceTurnOnState | null, priorState?: string | null, userEnergyEvent?: { __typename?: 'UserEnergyEvent', id: string, event: { __typename?: 'EnergyEvent', id: string } } | null }> } | null } | null } };

export type GetDeviceEnergyUsageYesterdayQueryVariables = Exact<{
  deviceId: Scalars['ID'];
}>;


export type GetDeviceEnergyUsageYesterdayQuery = { __typename?: 'Query', currentSession: { __typename?: 'Session', user?: { __typename?: 'User', device?: { __typename?: 'Device', id: string, devicePowerConsumptionYesterday?: Array<{ __typename?: 'DevicePowerConsumptionHourly', id: string, hourStartDttm: string, consumptionWattHours: number }> | null } | null } | null } };

export type GetDeviceEnergyUsageLastWeekQueryVariables = Exact<{
  deviceId: Scalars['ID'];
}>;


export type GetDeviceEnergyUsageLastWeekQuery = { __typename?: 'Query', currentSession: { __typename?: 'Session', user?: { __typename?: 'User', device?: { __typename?: 'Device', id: string, devicePowerConsumptionPreviousWeek?: Array<{ __typename?: 'DevicePowerConsumptionHourly', id: string, hourStartDttm: string, consumptionWattHours: number }> | null } | null } | null } };

export type GetDeviceEnergyUsageMonthlyQueryVariables = Exact<{
  deviceId: Scalars['ID'];
}>;


export type GetDeviceEnergyUsageMonthlyQuery = { __typename?: 'Query', currentSession: { __typename?: 'Session', user?: { __typename?: 'User', device?: { __typename?: 'Device', id: string, devicePowerConsumptionMonthly?: Array<{ __typename?: 'DevicePowerConsumptionHourly', id: string, hourStartDttm: string, consumptionWattHours: number }> | null } | null } | null } };

export type CurrentSessionDevicesPageQueryVariables = Exact<{ [key: string]: never; }>;


export type CurrentSessionDevicesPageQuery = { __typename?: 'Query', currentSession: { __typename?: 'Session', user?: { __typename?: 'User', usersFirstDeviceFreeDevice: { __typename?: 'UsersFirstDeviceFreeDeviceState', id: string, reward?: { __typename?: 'Reward', id: string, displayTitle: string, displaySubtitle: string, displayDescription: string, basePricePoints: number, displayImageUrl: string } | null } } | null } };

export type SetUserFeatureOverridesMutationVariables = Exact<{
  userId: Scalars['ID'];
  featureKeys: Array<Scalars['ID']> | Scalars['ID'];
  state?: InputMaybe<Scalars['Boolean']>;
}>;


export type SetUserFeatureOverridesMutation = { __typename?: 'Mutation', setFeatureOverride: Array<{ __typename?: 'Feature', _id: string, key: string, isEnabled: boolean, description?: string | null, userOverrideState?: OverrideState | null }> };

export type ResetFeaturesMutationVariables = Exact<{
  userId: Scalars['ID'];
}>;


export type ResetFeaturesMutation = { __typename?: 'Mutation', clearAllFeatureOverrides: Array<{ __typename?: 'Feature', _id: string, key: string, isEnabled: boolean, description?: string | null, userOverrideState?: OverrideState | null }> };

export type GetReferralLeaderboardDataDataQueryVariables = Exact<{
  leaderboardKey: Scalars['ID'];
}>;


export type GetReferralLeaderboardDataDataQuery = { __typename?: 'Query', viewer: { __typename?: 'User', leaderboard?: { __typename?: 'Leaderboard', id: string, name: string, type: LeaderboardType, statName: string, leaders: Array<{ __typename?: 'LeaderboardEntry', id: string, rank: number, name: string, statValue: number } | null> } | null } };

export type GetPal2SessionQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPal2SessionQuery = { __typename?: 'Query', currentSession: { __typename?: 'Session', hasPartnerAccountLinkingRedirect: boolean, user?: { __typename?: 'User', id: string, accountSetupStatus?: AccountSetupStatus | null } | null } };

export type SubmitRatePlanOptimizerFeedbackSurveyMutationVariables = Exact<{
  input: RatePlanOptimizerFeedbackSurveyInput;
}>;


export type SubmitRatePlanOptimizerFeedbackSurveyMutation = { __typename?: 'Mutation', RatePlanOptimizerFeedbackSurvey: { __typename?: 'RatePlanOptimizerFeedbackSurveyOp', submitRatePlanOptimizerFeedbackSurvey: { __typename?: 'FailureResult', errorCode?: string | null, errorMessage?: string | null } | { __typename?: 'RatePlanOptimizerFeedbackSurvey', surveyType: RatePlanOptimizerFeedbackSurveyType, passedToUtility: boolean, prompts: Array<string>, responses: Array<string> } } };

export type GetRatePlanOptimizerResultQueryVariables = Exact<{ [key: string]: never; }>;


export type GetRatePlanOptimizerResultQuery = { __typename?: 'Query', viewer: { __typename?: 'User', id: string, ratePlanOptimizerResult?: { __typename?: 'RatePlanOptimizerResult', estimatedAnnualRatePlanSavings: number, estimatedCurrentRatePlanAnnualCost: number, currentRatePlanCode: string, cheapestRatePlanCode: string } | null } };

export type RhrMarkSendOffCompleteMutationVariables = Exact<{
  programId: Scalars['ID'];
}>;


export type RhrMarkSendOffCompleteMutation = { __typename?: 'Mutation', GoogleRhr: { __typename?: 'GoogleRhrOp', markSendOffComplete: { __typename?: 'OhmResult', status: number, message: string } } };

export type RhrMarkSendOffDidThisAlreadyMutationVariables = Exact<{ [key: string]: never; }>;


export type RhrMarkSendOffDidThisAlreadyMutation = { __typename?: 'Mutation', GoogleRhr: { __typename?: 'GoogleRhrOp', markDidEnrollmentAlready: { __typename?: 'OhmResult', status: number, message: string } } };

export type CreateAttributeFilterSegmentMutationVariables = Exact<{
  input: NewAttributeFilterSegmentInput;
}>;


export type CreateAttributeFilterSegmentMutation = { __typename?: 'Mutation', SegmentationEngine: { __typename?: 'SegmentationEngineOp', createAttributeFilterSegment: { __typename?: 'AttributeFilterSegment', id: string, name: string, description: string, active: boolean, activelyEnrolling: boolean, attribute: { __typename?: 'BooleanAttribute', id: string, name: string, dataType: AttributeDataType, comparators: Array<{ __typename?: 'AttributeComparator', id: string, name: string, nameShort: string, attributeFilter: AttributeFilterType }> } | { __typename?: 'DateAttribute', id: string, name: string, dataType: AttributeDataType, minimumAllowableDate?: string | null, maximumAllowableDate?: string | null, comparators: Array<{ __typename?: 'AttributeComparator', id: string, name: string, nameShort: string, attributeFilter: AttributeFilterType }> } | { __typename?: 'DatetimeAttribute', id: string, name: string, dataType: AttributeDataType, minimumAllowableDttm?: string | null, maximumAllowableDttm?: string | null, comparators: Array<{ __typename?: 'AttributeComparator', id: string, name: string, nameShort: string, attributeFilter: AttributeFilterType }> } | { __typename?: 'NumericAttribute', id: string, name: string, dataType: AttributeDataType, minimumAllowableValue?: number | null, maximumAllowableValue?: number | null, comparators: Array<{ __typename?: 'AttributeComparator', id: string, name: string, nameShort: string, attributeFilter: AttributeFilterType }> } | { __typename?: 'StringEnumAttribute', id: string, name: string, dataType: AttributeDataType, enumeratedValues: Array<string>, comparators: Array<{ __typename?: 'AttributeComparator', id: string, name: string, nameShort: string, attributeFilter: AttributeFilterType }> } | { __typename?: 'TextAttribute', id: string, name: string, dataType: AttributeDataType, comparators: Array<{ __typename?: 'AttributeComparator', id: string, name: string, nameShort: string, attributeFilter: AttributeFilterType }> }, filter: { __typename?: 'BooleanAttributeFilter', id: string, booleanValue: boolean, comparator: { __typename?: 'FilterComparator', id: string, name: string, nameShort: string } } | { __typename?: 'DateRangeAttributeFilter', id: string, minDate: string, maxDate: string, comparator: { __typename?: 'FilterComparator', id: string, name: string, nameShort: string } } | { __typename?: 'DateSimpleAttributeFilter', id: string, dateValue: string, comparator: { __typename?: 'FilterComparator', id: string, name: string, nameShort: string } } | { __typename?: 'DatetimeRangeAttributeFilter', id: string, minDatetime: string, maxDatetime: string, comparator: { __typename?: 'FilterComparator', id: string, name: string, nameShort: string } } | { __typename?: 'DatetimeSimpleAttributeFilter', id: string, datetimeValue: string, comparator: { __typename?: 'FilterComparator', id: string, name: string, nameShort: string } } | { __typename?: 'EnumAttributeFilter', id: string, enumValues: Array<string | null>, comparator: { __typename?: 'FilterComparator', id: string, name: string, nameShort: string } } | { __typename?: 'NumericRangeAttributeFilter', id: string, minValue: number, maxValue: number, comparator: { __typename?: 'FilterComparator', id: string, name: string, nameShort: string } } | { __typename?: 'NumericSimpleAttributeFilter', id: string, numericValue: number, comparator: { __typename?: 'FilterComparator', id: string, name: string, nameShort: string } } | { __typename?: 'TextAttributeFilter', id: string, textValue: string, comparator: { __typename?: 'FilterComparator', id: string, name: string, nameShort: string } } } | { __typename?: 'FailureResult' } } };

export type UpdateAttributeFilterSegmentMutationVariables = Exact<{
  id: Scalars['ID'];
  input: UpdateAttributeFilterSegmentInput;
}>;


export type UpdateAttributeFilterSegmentMutation = { __typename?: 'Mutation', SegmentationEngine: { __typename?: 'SegmentationEngineOp', updateAttributeFilterSegment: { __typename?: 'AttributeFilterSegment', id: string, name: string, description: string, active: boolean, activelyEnrolling: boolean, attribute: { __typename?: 'BooleanAttribute', id: string, name: string, dataType: AttributeDataType, comparators: Array<{ __typename?: 'AttributeComparator', id: string, name: string, nameShort: string, attributeFilter: AttributeFilterType }> } | { __typename?: 'DateAttribute', id: string, name: string, dataType: AttributeDataType, minimumAllowableDate?: string | null, maximumAllowableDate?: string | null, comparators: Array<{ __typename?: 'AttributeComparator', id: string, name: string, nameShort: string, attributeFilter: AttributeFilterType }> } | { __typename?: 'DatetimeAttribute', id: string, name: string, dataType: AttributeDataType, minimumAllowableDttm?: string | null, maximumAllowableDttm?: string | null, comparators: Array<{ __typename?: 'AttributeComparator', id: string, name: string, nameShort: string, attributeFilter: AttributeFilterType }> } | { __typename?: 'NumericAttribute', id: string, name: string, dataType: AttributeDataType, minimumAllowableValue?: number | null, maximumAllowableValue?: number | null, comparators: Array<{ __typename?: 'AttributeComparator', id: string, name: string, nameShort: string, attributeFilter: AttributeFilterType }> } | { __typename?: 'StringEnumAttribute', id: string, name: string, dataType: AttributeDataType, enumeratedValues: Array<string>, comparators: Array<{ __typename?: 'AttributeComparator', id: string, name: string, nameShort: string, attributeFilter: AttributeFilterType }> } | { __typename?: 'TextAttribute', id: string, name: string, dataType: AttributeDataType, comparators: Array<{ __typename?: 'AttributeComparator', id: string, name: string, nameShort: string, attributeFilter: AttributeFilterType }> }, filter: { __typename?: 'BooleanAttributeFilter', id: string, booleanValue: boolean, comparator: { __typename?: 'FilterComparator', id: string, name: string, nameShort: string } } | { __typename?: 'DateRangeAttributeFilter', id: string, minDate: string, maxDate: string, comparator: { __typename?: 'FilterComparator', id: string, name: string, nameShort: string } } | { __typename?: 'DateSimpleAttributeFilter', id: string, dateValue: string, comparator: { __typename?: 'FilterComparator', id: string, name: string, nameShort: string } } | { __typename?: 'DatetimeRangeAttributeFilter', id: string, minDatetime: string, maxDatetime: string, comparator: { __typename?: 'FilterComparator', id: string, name: string, nameShort: string } } | { __typename?: 'DatetimeSimpleAttributeFilter', id: string, datetimeValue: string, comparator: { __typename?: 'FilterComparator', id: string, name: string, nameShort: string } } | { __typename?: 'EnumAttributeFilter', id: string, enumValues: Array<string | null>, comparator: { __typename?: 'FilterComparator', id: string, name: string, nameShort: string } } | { __typename?: 'NumericRangeAttributeFilter', id: string, minValue: number, maxValue: number, comparator: { __typename?: 'FilterComparator', id: string, name: string, nameShort: string } } | { __typename?: 'NumericSimpleAttributeFilter', id: string, numericValue: number, comparator: { __typename?: 'FilterComparator', id: string, name: string, nameShort: string } } | { __typename?: 'TextAttributeFilter', id: string, textValue: string, comparator: { __typename?: 'FilterComparator', id: string, name: string, nameShort: string } } } | { __typename?: 'FailureResult' } } };

export type CreateCompoundSegmentMutationVariables = Exact<{
  input: NewCompoundSegmentInput;
}>;


export type CreateCompoundSegmentMutation = { __typename?: 'Mutation', SegmentationEngine: { __typename?: 'SegmentationEngineOp', createCompoundSegment: { __typename?: 'CompoundSegment', id: string, name: string, description: string, active: boolean, activelyEnrolling: boolean, composition: Array<{ __typename?: 'SegmentGroup', id: string, name?: string | null, segmentSpecs: Array<{ __typename?: 'SegmentSpec', id: string, invert: boolean, segment: { __typename?: 'AttributeFilterSegment', id: string, name: string, description: string, active: boolean, activelyEnrolling: boolean, attribute: { __typename?: 'BooleanAttribute', id: string, name: string, dataType: AttributeDataType, comparators: Array<{ __typename?: 'AttributeComparator', id: string, name: string, nameShort: string, attributeFilter: AttributeFilterType }> } | { __typename?: 'DateAttribute', id: string, name: string, dataType: AttributeDataType, minimumAllowableDate?: string | null, maximumAllowableDate?: string | null, comparators: Array<{ __typename?: 'AttributeComparator', id: string, name: string, nameShort: string, attributeFilter: AttributeFilterType }> } | { __typename?: 'DatetimeAttribute', id: string, name: string, dataType: AttributeDataType, minimumAllowableDttm?: string | null, maximumAllowableDttm?: string | null, comparators: Array<{ __typename?: 'AttributeComparator', id: string, name: string, nameShort: string, attributeFilter: AttributeFilterType }> } | { __typename?: 'NumericAttribute', id: string, name: string, dataType: AttributeDataType, minimumAllowableValue?: number | null, maximumAllowableValue?: number | null, comparators: Array<{ __typename?: 'AttributeComparator', id: string, name: string, nameShort: string, attributeFilter: AttributeFilterType }> } | { __typename?: 'StringEnumAttribute', id: string, name: string, dataType: AttributeDataType, enumeratedValues: Array<string>, comparators: Array<{ __typename?: 'AttributeComparator', id: string, name: string, nameShort: string, attributeFilter: AttributeFilterType }> } | { __typename?: 'TextAttribute', id: string, name: string, dataType: AttributeDataType, comparators: Array<{ __typename?: 'AttributeComparator', id: string, name: string, nameShort: string, attributeFilter: AttributeFilterType }> }, filter: { __typename?: 'BooleanAttributeFilter', id: string, booleanValue: boolean, comparator: { __typename?: 'FilterComparator', id: string, name: string, nameShort: string } } | { __typename?: 'DateRangeAttributeFilter', id: string, minDate: string, maxDate: string, comparator: { __typename?: 'FilterComparator', id: string, name: string, nameShort: string } } | { __typename?: 'DateSimpleAttributeFilter', id: string, dateValue: string, comparator: { __typename?: 'FilterComparator', id: string, name: string, nameShort: string } } | { __typename?: 'DatetimeRangeAttributeFilter', id: string, minDatetime: string, maxDatetime: string, comparator: { __typename?: 'FilterComparator', id: string, name: string, nameShort: string } } | { __typename?: 'DatetimeSimpleAttributeFilter', id: string, datetimeValue: string, comparator: { __typename?: 'FilterComparator', id: string, name: string, nameShort: string } } | { __typename?: 'EnumAttributeFilter', id: string, enumValues: Array<string | null>, comparator: { __typename?: 'FilterComparator', id: string, name: string, nameShort: string } } | { __typename?: 'NumericRangeAttributeFilter', id: string, minValue: number, maxValue: number, comparator: { __typename?: 'FilterComparator', id: string, name: string, nameShort: string } } | { __typename?: 'NumericSimpleAttributeFilter', id: string, numericValue: number, comparator: { __typename?: 'FilterComparator', id: string, name: string, nameShort: string } } | { __typename?: 'TextAttributeFilter', id: string, textValue: string, comparator: { __typename?: 'FilterComparator', id: string, name: string, nameShort: string } } } | { __typename?: 'CodeDefinedSegment', id: string, name: string, description: string, active: boolean, activelyEnrolling: boolean } | { __typename?: 'CompoundSegment', id: string, name: string, description: string, active: boolean, activelyEnrolling: boolean, composition: Array<{ __typename?: 'SegmentGroup', id: string, segmentSpecs: Array<{ __typename?: 'SegmentSpec', id: string, invert: boolean, segment: { __typename?: 'AttributeFilterSegment', id: string, name: string, description: string, active: boolean, activelyEnrolling: boolean, attribute: { __typename?: 'BooleanAttribute', id: string, name: string, dataType: AttributeDataType, comparators: Array<{ __typename?: 'AttributeComparator', id: string, name: string, nameShort: string, attributeFilter: AttributeFilterType }> } | { __typename?: 'DateAttribute', id: string, name: string, dataType: AttributeDataType, minimumAllowableDate?: string | null, maximumAllowableDate?: string | null, comparators: Array<{ __typename?: 'AttributeComparator', id: string, name: string, nameShort: string, attributeFilter: AttributeFilterType }> } | { __typename?: 'DatetimeAttribute', id: string, name: string, dataType: AttributeDataType, minimumAllowableDttm?: string | null, maximumAllowableDttm?: string | null, comparators: Array<{ __typename?: 'AttributeComparator', id: string, name: string, nameShort: string, attributeFilter: AttributeFilterType }> } | { __typename?: 'NumericAttribute', id: string, name: string, dataType: AttributeDataType, minimumAllowableValue?: number | null, maximumAllowableValue?: number | null, comparators: Array<{ __typename?: 'AttributeComparator', id: string, name: string, nameShort: string, attributeFilter: AttributeFilterType }> } | { __typename?: 'StringEnumAttribute', id: string, name: string, dataType: AttributeDataType, enumeratedValues: Array<string>, comparators: Array<{ __typename?: 'AttributeComparator', id: string, name: string, nameShort: string, attributeFilter: AttributeFilterType }> } | { __typename?: 'TextAttribute', id: string, name: string, dataType: AttributeDataType, comparators: Array<{ __typename?: 'AttributeComparator', id: string, name: string, nameShort: string, attributeFilter: AttributeFilterType }> }, filter: { __typename?: 'BooleanAttributeFilter', id: string, booleanValue: boolean, comparator: { __typename?: 'FilterComparator', id: string, name: string, nameShort: string } } | { __typename?: 'DateRangeAttributeFilter', id: string, minDate: string, maxDate: string, comparator: { __typename?: 'FilterComparator', id: string, name: string, nameShort: string } } | { __typename?: 'DateSimpleAttributeFilter', id: string, dateValue: string, comparator: { __typename?: 'FilterComparator', id: string, name: string, nameShort: string } } | { __typename?: 'DatetimeRangeAttributeFilter', id: string, minDatetime: string, maxDatetime: string, comparator: { __typename?: 'FilterComparator', id: string, name: string, nameShort: string } } | { __typename?: 'DatetimeSimpleAttributeFilter', id: string, datetimeValue: string, comparator: { __typename?: 'FilterComparator', id: string, name: string, nameShort: string } } | { __typename?: 'EnumAttributeFilter', id: string, enumValues: Array<string | null>, comparator: { __typename?: 'FilterComparator', id: string, name: string, nameShort: string } } | { __typename?: 'NumericRangeAttributeFilter', id: string, minValue: number, maxValue: number, comparator: { __typename?: 'FilterComparator', id: string, name: string, nameShort: string } } | { __typename?: 'NumericSimpleAttributeFilter', id: string, numericValue: number, comparator: { __typename?: 'FilterComparator', id: string, name: string, nameShort: string } } | { __typename?: 'TextAttributeFilter', id: string, textValue: string, comparator: { __typename?: 'FilterComparator', id: string, name: string, nameShort: string } } } | { __typename?: 'CodeDefinedSegment', id: string, name: string, description: string, active: boolean, activelyEnrolling: boolean } | { __typename?: 'CompoundSegment', id: string, name: string, description: string, active: boolean, activelyEnrolling: boolean } }> }> } }> }> } | { __typename?: 'FailureResult' } } };

export type UpdateCompoundSegmentMutationVariables = Exact<{
  id: Scalars['ID'];
  input: UpdateCompoundSegmentInput;
}>;


export type UpdateCompoundSegmentMutation = { __typename?: 'Mutation', SegmentationEngine: { __typename?: 'SegmentationEngineOp', updateCompoundSegment: { __typename?: 'CompoundSegment', id: string, name: string, description: string, active: boolean, activelyEnrolling: boolean, composition: Array<{ __typename?: 'SegmentGroup', id: string, name?: string | null, segmentSpecs: Array<{ __typename?: 'SegmentSpec', id: string, invert: boolean, segment: { __typename?: 'AttributeFilterSegment', id: string, name: string, description: string, active: boolean, activelyEnrolling: boolean, attribute: { __typename?: 'BooleanAttribute', id: string, name: string, dataType: AttributeDataType, comparators: Array<{ __typename?: 'AttributeComparator', id: string, name: string, nameShort: string, attributeFilter: AttributeFilterType }> } | { __typename?: 'DateAttribute', id: string, name: string, dataType: AttributeDataType, minimumAllowableDate?: string | null, maximumAllowableDate?: string | null, comparators: Array<{ __typename?: 'AttributeComparator', id: string, name: string, nameShort: string, attributeFilter: AttributeFilterType }> } | { __typename?: 'DatetimeAttribute', id: string, name: string, dataType: AttributeDataType, minimumAllowableDttm?: string | null, maximumAllowableDttm?: string | null, comparators: Array<{ __typename?: 'AttributeComparator', id: string, name: string, nameShort: string, attributeFilter: AttributeFilterType }> } | { __typename?: 'NumericAttribute', id: string, name: string, dataType: AttributeDataType, minimumAllowableValue?: number | null, maximumAllowableValue?: number | null, comparators: Array<{ __typename?: 'AttributeComparator', id: string, name: string, nameShort: string, attributeFilter: AttributeFilterType }> } | { __typename?: 'StringEnumAttribute', id: string, name: string, dataType: AttributeDataType, enumeratedValues: Array<string>, comparators: Array<{ __typename?: 'AttributeComparator', id: string, name: string, nameShort: string, attributeFilter: AttributeFilterType }> } | { __typename?: 'TextAttribute', id: string, name: string, dataType: AttributeDataType, comparators: Array<{ __typename?: 'AttributeComparator', id: string, name: string, nameShort: string, attributeFilter: AttributeFilterType }> }, filter: { __typename?: 'BooleanAttributeFilter', id: string, booleanValue: boolean, comparator: { __typename?: 'FilterComparator', id: string, name: string, nameShort: string } } | { __typename?: 'DateRangeAttributeFilter', id: string, minDate: string, maxDate: string, comparator: { __typename?: 'FilterComparator', id: string, name: string, nameShort: string } } | { __typename?: 'DateSimpleAttributeFilter', id: string, dateValue: string, comparator: { __typename?: 'FilterComparator', id: string, name: string, nameShort: string } } | { __typename?: 'DatetimeRangeAttributeFilter', id: string, minDatetime: string, maxDatetime: string, comparator: { __typename?: 'FilterComparator', id: string, name: string, nameShort: string } } | { __typename?: 'DatetimeSimpleAttributeFilter', id: string, datetimeValue: string, comparator: { __typename?: 'FilterComparator', id: string, name: string, nameShort: string } } | { __typename?: 'EnumAttributeFilter', id: string, enumValues: Array<string | null>, comparator: { __typename?: 'FilterComparator', id: string, name: string, nameShort: string } } | { __typename?: 'NumericRangeAttributeFilter', id: string, minValue: number, maxValue: number, comparator: { __typename?: 'FilterComparator', id: string, name: string, nameShort: string } } | { __typename?: 'NumericSimpleAttributeFilter', id: string, numericValue: number, comparator: { __typename?: 'FilterComparator', id: string, name: string, nameShort: string } } | { __typename?: 'TextAttributeFilter', id: string, textValue: string, comparator: { __typename?: 'FilterComparator', id: string, name: string, nameShort: string } } } | { __typename?: 'CodeDefinedSegment', id: string, name: string, description: string, active: boolean, activelyEnrolling: boolean } | { __typename?: 'CompoundSegment', id: string, name: string, description: string, active: boolean, activelyEnrolling: boolean, composition: Array<{ __typename?: 'SegmentGroup', id: string, segmentSpecs: Array<{ __typename?: 'SegmentSpec', id: string, invert: boolean, segment: { __typename?: 'AttributeFilterSegment', id: string, name: string, description: string, active: boolean, activelyEnrolling: boolean, attribute: { __typename?: 'BooleanAttribute', id: string, name: string, dataType: AttributeDataType, comparators: Array<{ __typename?: 'AttributeComparator', id: string, name: string, nameShort: string, attributeFilter: AttributeFilterType }> } | { __typename?: 'DateAttribute', id: string, name: string, dataType: AttributeDataType, minimumAllowableDate?: string | null, maximumAllowableDate?: string | null, comparators: Array<{ __typename?: 'AttributeComparator', id: string, name: string, nameShort: string, attributeFilter: AttributeFilterType }> } | { __typename?: 'DatetimeAttribute', id: string, name: string, dataType: AttributeDataType, minimumAllowableDttm?: string | null, maximumAllowableDttm?: string | null, comparators: Array<{ __typename?: 'AttributeComparator', id: string, name: string, nameShort: string, attributeFilter: AttributeFilterType }> } | { __typename?: 'NumericAttribute', id: string, name: string, dataType: AttributeDataType, minimumAllowableValue?: number | null, maximumAllowableValue?: number | null, comparators: Array<{ __typename?: 'AttributeComparator', id: string, name: string, nameShort: string, attributeFilter: AttributeFilterType }> } | { __typename?: 'StringEnumAttribute', id: string, name: string, dataType: AttributeDataType, enumeratedValues: Array<string>, comparators: Array<{ __typename?: 'AttributeComparator', id: string, name: string, nameShort: string, attributeFilter: AttributeFilterType }> } | { __typename?: 'TextAttribute', id: string, name: string, dataType: AttributeDataType, comparators: Array<{ __typename?: 'AttributeComparator', id: string, name: string, nameShort: string, attributeFilter: AttributeFilterType }> }, filter: { __typename?: 'BooleanAttributeFilter', id: string, booleanValue: boolean, comparator: { __typename?: 'FilterComparator', id: string, name: string, nameShort: string } } | { __typename?: 'DateRangeAttributeFilter', id: string, minDate: string, maxDate: string, comparator: { __typename?: 'FilterComparator', id: string, name: string, nameShort: string } } | { __typename?: 'DateSimpleAttributeFilter', id: string, dateValue: string, comparator: { __typename?: 'FilterComparator', id: string, name: string, nameShort: string } } | { __typename?: 'DatetimeRangeAttributeFilter', id: string, minDatetime: string, maxDatetime: string, comparator: { __typename?: 'FilterComparator', id: string, name: string, nameShort: string } } | { __typename?: 'DatetimeSimpleAttributeFilter', id: string, datetimeValue: string, comparator: { __typename?: 'FilterComparator', id: string, name: string, nameShort: string } } | { __typename?: 'EnumAttributeFilter', id: string, enumValues: Array<string | null>, comparator: { __typename?: 'FilterComparator', id: string, name: string, nameShort: string } } | { __typename?: 'NumericRangeAttributeFilter', id: string, minValue: number, maxValue: number, comparator: { __typename?: 'FilterComparator', id: string, name: string, nameShort: string } } | { __typename?: 'NumericSimpleAttributeFilter', id: string, numericValue: number, comparator: { __typename?: 'FilterComparator', id: string, name: string, nameShort: string } } | { __typename?: 'TextAttributeFilter', id: string, textValue: string, comparator: { __typename?: 'FilterComparator', id: string, name: string, nameShort: string } } } | { __typename?: 'CodeDefinedSegment', id: string, name: string, description: string, active: boolean, activelyEnrolling: boolean } | { __typename?: 'CompoundSegment', id: string, name: string, description: string, active: boolean, activelyEnrolling: boolean } }> }> } }> }> } | { __typename?: 'FailureResult' } } };

export type GetAllSegmentTableDataQueryVariables = Exact<{
  attributeName?: InputMaybe<Scalars['String']>;
}>;


export type GetAllSegmentTableDataQuery = { __typename?: 'Query', segmentationEngine: { __typename?: 'SegmentationEngineQuery', segments: Array<{ __typename?: 'AttributeFilterSegment', id: string, name: string, description: string, active: boolean, activelyEnrolling: boolean, attribute: { __typename?: 'BooleanAttribute', id: string, name: string, dataType: AttributeDataType, comparators: Array<{ __typename?: 'AttributeComparator', id: string, name: string, nameShort: string, attributeFilter: AttributeFilterType }> } | { __typename?: 'DateAttribute', id: string, name: string, dataType: AttributeDataType, minimumAllowableDate?: string | null, maximumAllowableDate?: string | null, comparators: Array<{ __typename?: 'AttributeComparator', id: string, name: string, nameShort: string, attributeFilter: AttributeFilterType }> } | { __typename?: 'DatetimeAttribute', id: string, name: string, dataType: AttributeDataType, minimumAllowableDttm?: string | null, maximumAllowableDttm?: string | null, comparators: Array<{ __typename?: 'AttributeComparator', id: string, name: string, nameShort: string, attributeFilter: AttributeFilterType }> } | { __typename?: 'NumericAttribute', id: string, name: string, dataType: AttributeDataType, minimumAllowableValue?: number | null, maximumAllowableValue?: number | null, comparators: Array<{ __typename?: 'AttributeComparator', id: string, name: string, nameShort: string, attributeFilter: AttributeFilterType }> } | { __typename?: 'StringEnumAttribute', id: string, name: string, dataType: AttributeDataType, enumeratedValues: Array<string>, comparators: Array<{ __typename?: 'AttributeComparator', id: string, name: string, nameShort: string, attributeFilter: AttributeFilterType }> } | { __typename?: 'TextAttribute', id: string, name: string, dataType: AttributeDataType, comparators: Array<{ __typename?: 'AttributeComparator', id: string, name: string, nameShort: string, attributeFilter: AttributeFilterType }> }, filter: { __typename?: 'BooleanAttributeFilter', id: string, booleanValue: boolean, comparator: { __typename?: 'FilterComparator', id: string, name: string, nameShort: string } } | { __typename?: 'DateRangeAttributeFilter', id: string, minDate: string, maxDate: string, comparator: { __typename?: 'FilterComparator', id: string, name: string, nameShort: string } } | { __typename?: 'DateSimpleAttributeFilter', id: string, dateValue: string, comparator: { __typename?: 'FilterComparator', id: string, name: string, nameShort: string } } | { __typename?: 'DatetimeRangeAttributeFilter', id: string, minDatetime: string, maxDatetime: string, comparator: { __typename?: 'FilterComparator', id: string, name: string, nameShort: string } } | { __typename?: 'DatetimeSimpleAttributeFilter', id: string, datetimeValue: string, comparator: { __typename?: 'FilterComparator', id: string, name: string, nameShort: string } } | { __typename?: 'EnumAttributeFilter', id: string, enumValues: Array<string | null>, comparator: { __typename?: 'FilterComparator', id: string, name: string, nameShort: string } } | { __typename?: 'NumericRangeAttributeFilter', id: string, minValue: number, maxValue: number, comparator: { __typename?: 'FilterComparator', id: string, name: string, nameShort: string } } | { __typename?: 'NumericSimpleAttributeFilter', id: string, numericValue: number, comparator: { __typename?: 'FilterComparator', id: string, name: string, nameShort: string } } | { __typename?: 'TextAttributeFilter', id: string, textValue: string, comparator: { __typename?: 'FilterComparator', id: string, name: string, nameShort: string } } } | { __typename?: 'CodeDefinedSegment', id: string, name: string, description: string, active: boolean, activelyEnrolling: boolean } | { __typename?: 'CompoundSegment', id: string, name: string, description: string, active: boolean, activelyEnrolling: boolean, composition: Array<{ __typename?: 'SegmentGroup', id: string, name?: string | null, segmentSpecs: Array<{ __typename?: 'SegmentSpec', id: string, invert: boolean, segment: { __typename?: 'AttributeFilterSegment', id: string, name: string, description: string, active: boolean, activelyEnrolling: boolean, attribute: { __typename?: 'BooleanAttribute', id: string, name: string, dataType: AttributeDataType, comparators: Array<{ __typename?: 'AttributeComparator', id: string, name: string, nameShort: string, attributeFilter: AttributeFilterType }> } | { __typename?: 'DateAttribute', id: string, name: string, dataType: AttributeDataType, minimumAllowableDate?: string | null, maximumAllowableDate?: string | null, comparators: Array<{ __typename?: 'AttributeComparator', id: string, name: string, nameShort: string, attributeFilter: AttributeFilterType }> } | { __typename?: 'DatetimeAttribute', id: string, name: string, dataType: AttributeDataType, minimumAllowableDttm?: string | null, maximumAllowableDttm?: string | null, comparators: Array<{ __typename?: 'AttributeComparator', id: string, name: string, nameShort: string, attributeFilter: AttributeFilterType }> } | { __typename?: 'NumericAttribute', id: string, name: string, dataType: AttributeDataType, minimumAllowableValue?: number | null, maximumAllowableValue?: number | null, comparators: Array<{ __typename?: 'AttributeComparator', id: string, name: string, nameShort: string, attributeFilter: AttributeFilterType }> } | { __typename?: 'StringEnumAttribute', id: string, name: string, dataType: AttributeDataType, enumeratedValues: Array<string>, comparators: Array<{ __typename?: 'AttributeComparator', id: string, name: string, nameShort: string, attributeFilter: AttributeFilterType }> } | { __typename?: 'TextAttribute', id: string, name: string, dataType: AttributeDataType, comparators: Array<{ __typename?: 'AttributeComparator', id: string, name: string, nameShort: string, attributeFilter: AttributeFilterType }> }, filter: { __typename?: 'BooleanAttributeFilter', id: string, booleanValue: boolean, comparator: { __typename?: 'FilterComparator', id: string, name: string, nameShort: string } } | { __typename?: 'DateRangeAttributeFilter', id: string, minDate: string, maxDate: string, comparator: { __typename?: 'FilterComparator', id: string, name: string, nameShort: string } } | { __typename?: 'DateSimpleAttributeFilter', id: string, dateValue: string, comparator: { __typename?: 'FilterComparator', id: string, name: string, nameShort: string } } | { __typename?: 'DatetimeRangeAttributeFilter', id: string, minDatetime: string, maxDatetime: string, comparator: { __typename?: 'FilterComparator', id: string, name: string, nameShort: string } } | { __typename?: 'DatetimeSimpleAttributeFilter', id: string, datetimeValue: string, comparator: { __typename?: 'FilterComparator', id: string, name: string, nameShort: string } } | { __typename?: 'EnumAttributeFilter', id: string, enumValues: Array<string | null>, comparator: { __typename?: 'FilterComparator', id: string, name: string, nameShort: string } } | { __typename?: 'NumericRangeAttributeFilter', id: string, minValue: number, maxValue: number, comparator: { __typename?: 'FilterComparator', id: string, name: string, nameShort: string } } | { __typename?: 'NumericSimpleAttributeFilter', id: string, numericValue: number, comparator: { __typename?: 'FilterComparator', id: string, name: string, nameShort: string } } | { __typename?: 'TextAttributeFilter', id: string, textValue: string, comparator: { __typename?: 'FilterComparator', id: string, name: string, nameShort: string } } } | { __typename?: 'CodeDefinedSegment', id: string, name: string, description: string, active: boolean, activelyEnrolling: boolean } | { __typename?: 'CompoundSegment', id: string, name: string, description: string, active: boolean, activelyEnrolling: boolean, composition: Array<{ __typename?: 'SegmentGroup', id: string, segmentSpecs: Array<{ __typename?: 'SegmentSpec', id: string, invert: boolean, segment: { __typename?: 'AttributeFilterSegment', id: string, name: string, description: string, active: boolean, activelyEnrolling: boolean, attribute: { __typename?: 'BooleanAttribute', id: string, name: string, dataType: AttributeDataType, comparators: Array<{ __typename?: 'AttributeComparator', id: string, name: string, nameShort: string, attributeFilter: AttributeFilterType }> } | { __typename?: 'DateAttribute', id: string, name: string, dataType: AttributeDataType, minimumAllowableDate?: string | null, maximumAllowableDate?: string | null, comparators: Array<{ __typename?: 'AttributeComparator', id: string, name: string, nameShort: string, attributeFilter: AttributeFilterType }> } | { __typename?: 'DatetimeAttribute', id: string, name: string, dataType: AttributeDataType, minimumAllowableDttm?: string | null, maximumAllowableDttm?: string | null, comparators: Array<{ __typename?: 'AttributeComparator', id: string, name: string, nameShort: string, attributeFilter: AttributeFilterType }> } | { __typename?: 'NumericAttribute', id: string, name: string, dataType: AttributeDataType, minimumAllowableValue?: number | null, maximumAllowableValue?: number | null, comparators: Array<{ __typename?: 'AttributeComparator', id: string, name: string, nameShort: string, attributeFilter: AttributeFilterType }> } | { __typename?: 'StringEnumAttribute', id: string, name: string, dataType: AttributeDataType, enumeratedValues: Array<string>, comparators: Array<{ __typename?: 'AttributeComparator', id: string, name: string, nameShort: string, attributeFilter: AttributeFilterType }> } | { __typename?: 'TextAttribute', id: string, name: string, dataType: AttributeDataType, comparators: Array<{ __typename?: 'AttributeComparator', id: string, name: string, nameShort: string, attributeFilter: AttributeFilterType }> }, filter: { __typename?: 'BooleanAttributeFilter', id: string, booleanValue: boolean, comparator: { __typename?: 'FilterComparator', id: string, name: string, nameShort: string } } | { __typename?: 'DateRangeAttributeFilter', id: string, minDate: string, maxDate: string, comparator: { __typename?: 'FilterComparator', id: string, name: string, nameShort: string } } | { __typename?: 'DateSimpleAttributeFilter', id: string, dateValue: string, comparator: { __typename?: 'FilterComparator', id: string, name: string, nameShort: string } } | { __typename?: 'DatetimeRangeAttributeFilter', id: string, minDatetime: string, maxDatetime: string, comparator: { __typename?: 'FilterComparator', id: string, name: string, nameShort: string } } | { __typename?: 'DatetimeSimpleAttributeFilter', id: string, datetimeValue: string, comparator: { __typename?: 'FilterComparator', id: string, name: string, nameShort: string } } | { __typename?: 'EnumAttributeFilter', id: string, enumValues: Array<string | null>, comparator: { __typename?: 'FilterComparator', id: string, name: string, nameShort: string } } | { __typename?: 'NumericRangeAttributeFilter', id: string, minValue: number, maxValue: number, comparator: { __typename?: 'FilterComparator', id: string, name: string, nameShort: string } } | { __typename?: 'NumericSimpleAttributeFilter', id: string, numericValue: number, comparator: { __typename?: 'FilterComparator', id: string, name: string, nameShort: string } } | { __typename?: 'TextAttributeFilter', id: string, textValue: string, comparator: { __typename?: 'FilterComparator', id: string, name: string, nameShort: string } } } | { __typename?: 'CodeDefinedSegment', id: string, name: string, description: string, active: boolean, activelyEnrolling: boolean } | { __typename?: 'CompoundSegment', id: string, name: string, description: string, active: boolean, activelyEnrolling: boolean } }> }> } }> }> }> } };

export type GetSegmentEditAttributesDataQueryVariables = Exact<{
  attributeName?: InputMaybe<Scalars['String']>;
}>;


export type GetSegmentEditAttributesDataQuery = { __typename?: 'Query', segmentationEngine: { __typename?: 'SegmentationEngineQuery', attributes: Array<{ __typename?: 'BooleanAttribute', id: string, name: string, dataType: AttributeDataType, comparators: Array<{ __typename?: 'AttributeComparator', id: string, name: string, nameShort: string, attributeFilter: AttributeFilterType }> } | { __typename?: 'DateAttribute', id: string, name: string, dataType: AttributeDataType, minimumAllowableDate?: string | null, maximumAllowableDate?: string | null, comparators: Array<{ __typename?: 'AttributeComparator', id: string, name: string, nameShort: string, attributeFilter: AttributeFilterType }> } | { __typename?: 'DatetimeAttribute', id: string, name: string, dataType: AttributeDataType, minimumAllowableDttm?: string | null, maximumAllowableDttm?: string | null, comparators: Array<{ __typename?: 'AttributeComparator', id: string, name: string, nameShort: string, attributeFilter: AttributeFilterType }> } | { __typename?: 'NumericAttribute', id: string, name: string, dataType: AttributeDataType, minimumAllowableValue?: number | null, maximumAllowableValue?: number | null, comparators: Array<{ __typename?: 'AttributeComparator', id: string, name: string, nameShort: string, attributeFilter: AttributeFilterType }> } | { __typename?: 'StringEnumAttribute', id: string, name: string, dataType: AttributeDataType, enumeratedValues: Array<string>, comparators: Array<{ __typename?: 'AttributeComparator', id: string, name: string, nameShort: string, attributeFilter: AttributeFilterType }> } | { __typename?: 'TextAttribute', id: string, name: string, dataType: AttributeDataType, comparators: Array<{ __typename?: 'AttributeComparator', id: string, name: string, nameShort: string, attributeFilter: AttributeFilterType }> }> } };

export type UsersFirstDeviceClaimFreeDeviceMutationVariables = Exact<{ [key: string]: never; }>;


export type UsersFirstDeviceClaimFreeDeviceMutation = { __typename?: 'Mutation', UsersFirstDevice: { __typename?: 'UsersFirstDeviceOp', claimFreeDevice: UsersFirstDeviceClaimFreeDeviceResult } };

export type ViewerFirstLoadQueryVariables = Exact<{ [key: string]: never; }>;


export type ViewerFirstLoadQuery = { __typename?: 'Query', viewer: { __typename?: 'User', features: Array<{ __typename?: 'Feature', _id: string, key: string, isEnabled: boolean, description?: string | null, userOverrideState?: OverrideState | null }>, uiCustomization: { __typename?: 'UiCustomization', customBrandBarImageUrl?: string | null }, googleRhr?: { __typename?: 'UserGoogleRhrData', id: string, enrollmentAppUri: string, expectedPartnerName: string, expectedTermsOfServiceUri: string } | null }, currentSession: { __typename?: 'Session', hasPartnerAccountLinkingRedirect: boolean, user?: { __typename?: 'User', id: string, accountSetupStatus?: AccountSetupStatus | null } | null } };

export type Pal2SessionFragment = { __typename?: 'Session', hasPartnerAccountLinkingRedirect: boolean, user?: { __typename?: 'User', id: string, accountSetupStatus?: AccountSetupStatus | null } | null };

export const DeviceEnergyUsageFragmentFragmentDoc = gql`
    fragment DeviceEnergyUsageFragment on DevicePowerConsumptionHourly {
  id
  hourStartDttm
  consumptionWattHours
}
    `;
export const GoogleRhrSendOffDataFragmentDoc = gql`
    fragment GoogleRhrSendOffData on User {
  googleRhr {
    id
    enrollmentAppUri
    expectedPartnerName
    expectedTermsOfServiceUri
  }
}
    `;
export const ExperienceManagerFeatureFragmentFragmentDoc = gql`
    fragment experienceManagerFeatureFragment on Feature {
  _id
  key
  isEnabled
  description
  userOverrideState
}
    `;
export const App_DrUi_PceCtaDisplayFragmentFragmentDoc = gql`
    fragment App_DrUi_PceCtaDisplayFragment on CtaDisplay {
  label
  url
  level
}
    `;
export const App_DrUi_PceTextWithCtaDisplayContentFragmentFragmentDoc = gql`
    fragment App_DrUi_PceTextWithCtaDisplayContentFragment on PceTextWithCtaDisplay {
  id
  title
  subtitle
  icon
  content
  imageUrl
  subtext
  ctas {
    ...App_DrUi_PceCtaDisplayFragment
  }
}
    ${App_DrUi_PceCtaDisplayFragmentFragmentDoc}`;
export const App_DrUi_PceDisplayContentFragmentFragmentDoc = gql`
    fragment App_DrUi_PceDisplayContentFragment on PceDisplayContent {
  textWithCta {
    ...App_DrUi_PceTextWithCtaDisplayContentFragment
  }
}
    ${App_DrUi_PceTextWithCtaDisplayContentFragmentFragmentDoc}`;
export const App_DrUi_PceContentInstanceFragmentFragmentDoc = gql`
    fragment App_DrUi_PceContentInstanceFragment on PceContentInstance {
  id
  displayContent {
    ...App_DrUi_PceDisplayContentFragment
  }
}
    ${App_DrUi_PceDisplayContentFragmentFragmentDoc}`;
export const App_DrUi_PceContentPlacementFragmentFragmentDoc = gql`
    fragment App_DrUi_PceContentPlacementFragment on PceContentPlacement {
  id
  userInstances {
    ...App_DrUi_PceContentInstanceFragment
  }
}
    ${App_DrUi_PceContentInstanceFragmentFragmentDoc}`;
export const ReferralLeaderboardFragmentFragmentDoc = gql`
    fragment referralLeaderboardFragment on Leaderboard {
  id
  name
  type
  statName
  leaders {
    id
    rank
    name
    statValue
  }
}
    `;
export const UserUfdFreeDeviceFragmentFragmentDoc = gql`
    fragment UserUfdFreeDeviceFragment on User {
  usersFirstDeviceFreeDevice {
    id
    reward {
      id
      displayTitle
      displaySubtitle
      displayDescription
      basePricePoints
      displayImageUrl
    }
  }
}
    `;
export const AttributeComparatorFragmentFragmentDoc = gql`
    fragment attributeComparatorFragment on AttributeComparator {
  id
  name
  nameShort
  attributeFilter
}
    `;
export const AttributeFragmentFragmentDoc = gql`
    fragment attributeFragment on Attribute {
  ... on AttributeBase {
    id
    name
    dataType
    comparators {
      ...attributeComparatorFragment
    }
  }
  ... on StringEnumAttribute {
    id
    name
    dataType
    comparators {
      ...attributeComparatorFragment
    }
    enumeratedValues
  }
  ... on BooleanAttribute {
    id
    name
    dataType
    comparators {
      ...attributeComparatorFragment
    }
  }
  ... on NumericAttribute {
    id
    name
    dataType
    comparators {
      ...attributeComparatorFragment
    }
    minimumAllowableValue
    maximumAllowableValue
  }
  ... on TextAttribute {
    id
    name
    dataType
    comparators {
      ...attributeComparatorFragment
    }
  }
  ... on DateAttribute {
    id
    name
    dataType
    comparators {
      ...attributeComparatorFragment
    }
    minimumAllowableDate
    maximumAllowableDate
  }
  ... on DatetimeAttribute {
    id
    name
    dataType
    comparators {
      ...attributeComparatorFragment
    }
    minimumAllowableDttm
    maximumAllowableDttm
  }
}
    ${AttributeComparatorFragmentFragmentDoc}`;
export const FilterComparatorFragmentFragmentDoc = gql`
    fragment filterComparatorFragment on FilterComparator {
  id
  name
  nameShort
}
    `;
export const AttributeFilterSegmentFragmentFragmentDoc = gql`
    fragment attributeFilterSegmentFragment on AttributeFilterSegment {
  id
  name
  description
  active
  activelyEnrolling
  attribute {
    ...attributeFragment
  }
  filter {
    ... on BooleanAttributeFilter {
      id
      comparator {
        ...filterComparatorFragment
      }
      booleanValue
    }
    ... on NumericSimpleAttributeFilter {
      id
      comparator {
        ...filterComparatorFragment
      }
      numericValue
    }
    ... on NumericRangeAttributeFilter {
      id
      comparator {
        ...filterComparatorFragment
      }
      minValue
      maxValue
    }
    ... on DateSimpleAttributeFilter {
      id
      comparator {
        ...filterComparatorFragment
      }
      dateValue
    }
    ... on DateRangeAttributeFilter {
      id
      comparator {
        ...filterComparatorFragment
      }
      minDate
      maxDate
    }
    ... on DatetimeSimpleAttributeFilter {
      id
      comparator {
        ...filterComparatorFragment
      }
      datetimeValue
    }
    ... on DatetimeRangeAttributeFilter {
      id
      comparator {
        ...filterComparatorFragment
      }
      minDatetime
      maxDatetime
    }
    ... on EnumAttributeFilter {
      id
      comparator {
        ...filterComparatorFragment
      }
      enumValues
    }
    ... on TextAttributeFilter {
      id
      comparator {
        ...filterComparatorFragment
      }
      textValue
    }
  }
}
    ${AttributeFragmentFragmentDoc}
${FilterComparatorFragmentFragmentDoc}`;
export const CodeDefinedSegmentFragmentFragmentDoc = gql`
    fragment codeDefinedSegmentFragment on CodeDefinedSegment {
  id
  name
  description
  active
  activelyEnrolling
}
    `;
export const CompoundSegmentFragmentFragmentDoc = gql`
    fragment compoundSegmentFragment on CompoundSegment {
  id
  name
  description
  active
  activelyEnrolling
  composition {
    id
    name
    segmentSpecs {
      id
      invert
      segment {
        ... on SegmentBase {
          id
        }
        ... on AttributeFilterSegment {
          ...attributeFilterSegmentFragment
        }
        ... on CodeDefinedSegment {
          ...codeDefinedSegmentFragment
        }
        ... on CompoundSegment {
          id
          name
          description
          active
          activelyEnrolling
          composition {
            id
            segmentSpecs {
              id
              invert
              segment {
                ... on SegmentBase {
                  id
                }
                ... on AttributeFilterSegment {
                  ...attributeFilterSegmentFragment
                }
                ... on CodeDefinedSegment {
                  ...codeDefinedSegmentFragment
                }
                ... on CompoundSegment {
                  id
                  name
                  description
                  active
                  activelyEnrolling
                }
              }
            }
          }
        }
      }
    }
  }
}
    ${AttributeFilterSegmentFragmentFragmentDoc}
${CodeDefinedSegmentFragmentFragmentDoc}`;
export const SegmentEditAttributeComparatorFragmentFragmentDoc = gql`
    fragment segmentEditAttributeComparatorFragment on AttributeComparator {
  id
  name
  nameShort
  attributeFilter
}
    `;
export const SegmentEditAttributeFragmentFragmentDoc = gql`
    fragment segmentEditAttributeFragment on Attribute {
  ... on AttributeBase {
    id
    name
    dataType
    comparators {
      ...segmentEditAttributeComparatorFragment
    }
  }
  ... on StringEnumAttribute {
    enumeratedValues
  }
  ... on NumericAttribute {
    minimumAllowableValue
    maximumAllowableValue
  }
  ... on DateAttribute {
    minimumAllowableDate
    maximumAllowableDate
  }
  ... on DatetimeAttribute {
    id
    name
    dataType
    comparators {
      ...segmentEditAttributeComparatorFragment
    }
    minimumAllowableDttm
    maximumAllowableDttm
  }
}
    ${SegmentEditAttributeComparatorFragmentFragmentDoc}`;
export const BrandLogoFieldsFragmentDoc = gql`
    fragment brandLogoFields on User {
  uiCustomization {
    customBrandBarImageUrl
  }
}
    `;
export const Pal2SessionFragmentDoc = gql`
    fragment PAL2Session on Session {
  hasPartnerAccountLinkingRedirect
  user {
    id
    accountSetupStatus
  }
}
    `;
export const App_DrUi_PcePlacementsDocument = gql`
    query App_DrUi_PcePlacements($placements: [PcePlacement!]) {
  currentSession {
    user {
      placements(placements: $placements) {
        ...App_DrUi_PceContentPlacementFragment
      }
    }
  }
}
    ${App_DrUi_PceContentPlacementFragmentFragmentDoc}`;

/**
 * __useApp_DrUi_PcePlacementsQuery__
 *
 * To run a query within a React component, call `useApp_DrUi_PcePlacementsQuery` and pass it any options that fit your needs.
 * When your component renders, `useApp_DrUi_PcePlacementsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useApp_DrUi_PcePlacementsQuery({
 *   variables: {
 *      placements: // value for 'placements'
 *   },
 * });
 */
export function useApp_DrUi_PcePlacementsQuery(baseOptions?: Apollo.QueryHookOptions<App_DrUi_PcePlacementsQuery, App_DrUi_PcePlacementsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<App_DrUi_PcePlacementsQuery, App_DrUi_PcePlacementsQueryVariables>(App_DrUi_PcePlacementsDocument, options);
      }
export function useApp_DrUi_PcePlacementsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<App_DrUi_PcePlacementsQuery, App_DrUi_PcePlacementsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<App_DrUi_PcePlacementsQuery, App_DrUi_PcePlacementsQueryVariables>(App_DrUi_PcePlacementsDocument, options);
        }
export type App_DrUi_PcePlacementsQueryHookResult = ReturnType<typeof useApp_DrUi_PcePlacementsQuery>;
export type App_DrUi_PcePlacementsLazyQueryHookResult = ReturnType<typeof useApp_DrUi_PcePlacementsLazyQuery>;
export type App_DrUi_PcePlacementsQueryResult = Apollo.QueryResult<App_DrUi_PcePlacementsQuery, App_DrUi_PcePlacementsQueryVariables>;
export const GetApplianceInventoryCtaUserApplianceInventoryDocument = gql`
    query getApplianceInventoryCtaUserApplianceInventory {
  currentSession {
    user {
      applianceInventory {
        id
        userHasCompletedInventory
      }
    }
  }
}
    `;

/**
 * __useGetApplianceInventoryCtaUserApplianceInventoryQuery__
 *
 * To run a query within a React component, call `useGetApplianceInventoryCtaUserApplianceInventoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetApplianceInventoryCtaUserApplianceInventoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetApplianceInventoryCtaUserApplianceInventoryQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetApplianceInventoryCtaUserApplianceInventoryQuery(baseOptions?: Apollo.QueryHookOptions<GetApplianceInventoryCtaUserApplianceInventoryQuery, GetApplianceInventoryCtaUserApplianceInventoryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetApplianceInventoryCtaUserApplianceInventoryQuery, GetApplianceInventoryCtaUserApplianceInventoryQueryVariables>(GetApplianceInventoryCtaUserApplianceInventoryDocument, options);
      }
export function useGetApplianceInventoryCtaUserApplianceInventoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetApplianceInventoryCtaUserApplianceInventoryQuery, GetApplianceInventoryCtaUserApplianceInventoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetApplianceInventoryCtaUserApplianceInventoryQuery, GetApplianceInventoryCtaUserApplianceInventoryQueryVariables>(GetApplianceInventoryCtaUserApplianceInventoryDocument, options);
        }
export type GetApplianceInventoryCtaUserApplianceInventoryQueryHookResult = ReturnType<typeof useGetApplianceInventoryCtaUserApplianceInventoryQuery>;
export type GetApplianceInventoryCtaUserApplianceInventoryLazyQueryHookResult = ReturnType<typeof useGetApplianceInventoryCtaUserApplianceInventoryLazyQuery>;
export type GetApplianceInventoryCtaUserApplianceInventoryQueryResult = Apollo.QueryResult<GetApplianceInventoryCtaUserApplianceInventoryQuery, GetApplianceInventoryCtaUserApplianceInventoryQueryVariables>;
export const GetApplianceInventoryInitialCompletionDocument = gql`
    query getApplianceInventoryInitialCompletion {
  currentSession {
    user {
      applianceInventory {
        id
        userHasCompletedInventory
        userWattsAwardedForCompletion
      }
    }
  }
}
    `;

/**
 * __useGetApplianceInventoryInitialCompletionQuery__
 *
 * To run a query within a React component, call `useGetApplianceInventoryInitialCompletionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetApplianceInventoryInitialCompletionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetApplianceInventoryInitialCompletionQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetApplianceInventoryInitialCompletionQuery(baseOptions?: Apollo.QueryHookOptions<GetApplianceInventoryInitialCompletionQuery, GetApplianceInventoryInitialCompletionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetApplianceInventoryInitialCompletionQuery, GetApplianceInventoryInitialCompletionQueryVariables>(GetApplianceInventoryInitialCompletionDocument, options);
      }
export function useGetApplianceInventoryInitialCompletionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetApplianceInventoryInitialCompletionQuery, GetApplianceInventoryInitialCompletionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetApplianceInventoryInitialCompletionQuery, GetApplianceInventoryInitialCompletionQueryVariables>(GetApplianceInventoryInitialCompletionDocument, options);
        }
export type GetApplianceInventoryInitialCompletionQueryHookResult = ReturnType<typeof useGetApplianceInventoryInitialCompletionQuery>;
export type GetApplianceInventoryInitialCompletionLazyQueryHookResult = ReturnType<typeof useGetApplianceInventoryInitialCompletionLazyQuery>;
export type GetApplianceInventoryInitialCompletionQueryResult = Apollo.QueryResult<GetApplianceInventoryInitialCompletionQuery, GetApplianceInventoryInitialCompletionQueryVariables>;
export const GetCurrentDeviceLoadReportDocument = gql`
    query getCurrentDeviceLoadReport {
  currentSession {
    user {
      currentDeviceLoadReport {
        id
        reportStart
        reportEnd
        highUsageDevices {
          id
          consumptionKWh
          device {
            id
            name
            displayName
          }
        }
        lowUsageDevices {
          id
          consumptionKWh
          device {
            id
            name
            displayName
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetCurrentDeviceLoadReportQuery__
 *
 * To run a query within a React component, call `useGetCurrentDeviceLoadReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCurrentDeviceLoadReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCurrentDeviceLoadReportQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCurrentDeviceLoadReportQuery(baseOptions?: Apollo.QueryHookOptions<GetCurrentDeviceLoadReportQuery, GetCurrentDeviceLoadReportQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCurrentDeviceLoadReportQuery, GetCurrentDeviceLoadReportQueryVariables>(GetCurrentDeviceLoadReportDocument, options);
      }
export function useGetCurrentDeviceLoadReportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCurrentDeviceLoadReportQuery, GetCurrentDeviceLoadReportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCurrentDeviceLoadReportQuery, GetCurrentDeviceLoadReportQueryVariables>(GetCurrentDeviceLoadReportDocument, options);
        }
export type GetCurrentDeviceLoadReportQueryHookResult = ReturnType<typeof useGetCurrentDeviceLoadReportQuery>;
export type GetCurrentDeviceLoadReportLazyQueryHookResult = ReturnType<typeof useGetCurrentDeviceLoadReportLazyQuery>;
export type GetCurrentDeviceLoadReportQueryResult = Apollo.QueryResult<GetCurrentDeviceLoadReportQuery, GetCurrentDeviceLoadReportQueryVariables>;
export const GetDeviceByIdDocument = gql`
    query getDeviceById($deviceId: ID!, $page: Int, $perPage: Int) {
  currentSession {
    user {
      device(deviceId: $deviceId) {
        id
        deviceEventLogs(page: $page, perPage: $perPage) {
          id
          turnOffState
          turnOffDttm
          turnOnDttm
          turnOnState
          priorState
          userEnergyEvent {
            id
            event {
              id
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetDeviceByIdQuery__
 *
 * To run a query within a React component, call `useGetDeviceByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDeviceByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDeviceByIdQuery({
 *   variables: {
 *      deviceId: // value for 'deviceId'
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *   },
 * });
 */
export function useGetDeviceByIdQuery(baseOptions: Apollo.QueryHookOptions<GetDeviceByIdQuery, GetDeviceByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDeviceByIdQuery, GetDeviceByIdQueryVariables>(GetDeviceByIdDocument, options);
      }
export function useGetDeviceByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDeviceByIdQuery, GetDeviceByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDeviceByIdQuery, GetDeviceByIdQueryVariables>(GetDeviceByIdDocument, options);
        }
export type GetDeviceByIdQueryHookResult = ReturnType<typeof useGetDeviceByIdQuery>;
export type GetDeviceByIdLazyQueryHookResult = ReturnType<typeof useGetDeviceByIdLazyQuery>;
export type GetDeviceByIdQueryResult = Apollo.QueryResult<GetDeviceByIdQuery, GetDeviceByIdQueryVariables>;
export const GetDeviceEnergyUsageYesterdayDocument = gql`
    query getDeviceEnergyUsageYesterday($deviceId: ID!) {
  currentSession {
    user {
      device(deviceId: $deviceId) {
        id
        devicePowerConsumptionYesterday {
          ...DeviceEnergyUsageFragment
        }
      }
    }
  }
}
    ${DeviceEnergyUsageFragmentFragmentDoc}`;

/**
 * __useGetDeviceEnergyUsageYesterdayQuery__
 *
 * To run a query within a React component, call `useGetDeviceEnergyUsageYesterdayQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDeviceEnergyUsageYesterdayQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDeviceEnergyUsageYesterdayQuery({
 *   variables: {
 *      deviceId: // value for 'deviceId'
 *   },
 * });
 */
export function useGetDeviceEnergyUsageYesterdayQuery(baseOptions: Apollo.QueryHookOptions<GetDeviceEnergyUsageYesterdayQuery, GetDeviceEnergyUsageYesterdayQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDeviceEnergyUsageYesterdayQuery, GetDeviceEnergyUsageYesterdayQueryVariables>(GetDeviceEnergyUsageYesterdayDocument, options);
      }
export function useGetDeviceEnergyUsageYesterdayLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDeviceEnergyUsageYesterdayQuery, GetDeviceEnergyUsageYesterdayQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDeviceEnergyUsageYesterdayQuery, GetDeviceEnergyUsageYesterdayQueryVariables>(GetDeviceEnergyUsageYesterdayDocument, options);
        }
export type GetDeviceEnergyUsageYesterdayQueryHookResult = ReturnType<typeof useGetDeviceEnergyUsageYesterdayQuery>;
export type GetDeviceEnergyUsageYesterdayLazyQueryHookResult = ReturnType<typeof useGetDeviceEnergyUsageYesterdayLazyQuery>;
export type GetDeviceEnergyUsageYesterdayQueryResult = Apollo.QueryResult<GetDeviceEnergyUsageYesterdayQuery, GetDeviceEnergyUsageYesterdayQueryVariables>;
export const GetDeviceEnergyUsageLastWeekDocument = gql`
    query getDeviceEnergyUsageLastWeek($deviceId: ID!) {
  currentSession {
    user {
      device(deviceId: $deviceId) {
        id
        devicePowerConsumptionPreviousWeek {
          ...DeviceEnergyUsageFragment
        }
      }
    }
  }
}
    ${DeviceEnergyUsageFragmentFragmentDoc}`;

/**
 * __useGetDeviceEnergyUsageLastWeekQuery__
 *
 * To run a query within a React component, call `useGetDeviceEnergyUsageLastWeekQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDeviceEnergyUsageLastWeekQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDeviceEnergyUsageLastWeekQuery({
 *   variables: {
 *      deviceId: // value for 'deviceId'
 *   },
 * });
 */
export function useGetDeviceEnergyUsageLastWeekQuery(baseOptions: Apollo.QueryHookOptions<GetDeviceEnergyUsageLastWeekQuery, GetDeviceEnergyUsageLastWeekQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDeviceEnergyUsageLastWeekQuery, GetDeviceEnergyUsageLastWeekQueryVariables>(GetDeviceEnergyUsageLastWeekDocument, options);
      }
export function useGetDeviceEnergyUsageLastWeekLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDeviceEnergyUsageLastWeekQuery, GetDeviceEnergyUsageLastWeekQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDeviceEnergyUsageLastWeekQuery, GetDeviceEnergyUsageLastWeekQueryVariables>(GetDeviceEnergyUsageLastWeekDocument, options);
        }
export type GetDeviceEnergyUsageLastWeekQueryHookResult = ReturnType<typeof useGetDeviceEnergyUsageLastWeekQuery>;
export type GetDeviceEnergyUsageLastWeekLazyQueryHookResult = ReturnType<typeof useGetDeviceEnergyUsageLastWeekLazyQuery>;
export type GetDeviceEnergyUsageLastWeekQueryResult = Apollo.QueryResult<GetDeviceEnergyUsageLastWeekQuery, GetDeviceEnergyUsageLastWeekQueryVariables>;
export const GetDeviceEnergyUsageMonthlyDocument = gql`
    query getDeviceEnergyUsageMonthly($deviceId: ID!) {
  currentSession {
    user {
      device(deviceId: $deviceId) {
        id
        devicePowerConsumptionMonthly {
          ...DeviceEnergyUsageFragment
        }
      }
    }
  }
}
    ${DeviceEnergyUsageFragmentFragmentDoc}`;

/**
 * __useGetDeviceEnergyUsageMonthlyQuery__
 *
 * To run a query within a React component, call `useGetDeviceEnergyUsageMonthlyQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDeviceEnergyUsageMonthlyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDeviceEnergyUsageMonthlyQuery({
 *   variables: {
 *      deviceId: // value for 'deviceId'
 *   },
 * });
 */
export function useGetDeviceEnergyUsageMonthlyQuery(baseOptions: Apollo.QueryHookOptions<GetDeviceEnergyUsageMonthlyQuery, GetDeviceEnergyUsageMonthlyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDeviceEnergyUsageMonthlyQuery, GetDeviceEnergyUsageMonthlyQueryVariables>(GetDeviceEnergyUsageMonthlyDocument, options);
      }
export function useGetDeviceEnergyUsageMonthlyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDeviceEnergyUsageMonthlyQuery, GetDeviceEnergyUsageMonthlyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDeviceEnergyUsageMonthlyQuery, GetDeviceEnergyUsageMonthlyQueryVariables>(GetDeviceEnergyUsageMonthlyDocument, options);
        }
export type GetDeviceEnergyUsageMonthlyQueryHookResult = ReturnType<typeof useGetDeviceEnergyUsageMonthlyQuery>;
export type GetDeviceEnergyUsageMonthlyLazyQueryHookResult = ReturnType<typeof useGetDeviceEnergyUsageMonthlyLazyQuery>;
export type GetDeviceEnergyUsageMonthlyQueryResult = Apollo.QueryResult<GetDeviceEnergyUsageMonthlyQuery, GetDeviceEnergyUsageMonthlyQueryVariables>;
export const CurrentSessionDevicesPageDocument = gql`
    query currentSessionDevicesPage {
  currentSession {
    user {
      ...UserUfdFreeDeviceFragment
    }
  }
}
    ${UserUfdFreeDeviceFragmentFragmentDoc}`;

/**
 * __useCurrentSessionDevicesPageQuery__
 *
 * To run a query within a React component, call `useCurrentSessionDevicesPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useCurrentSessionDevicesPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCurrentSessionDevicesPageQuery({
 *   variables: {
 *   },
 * });
 */
export function useCurrentSessionDevicesPageQuery(baseOptions?: Apollo.QueryHookOptions<CurrentSessionDevicesPageQuery, CurrentSessionDevicesPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CurrentSessionDevicesPageQuery, CurrentSessionDevicesPageQueryVariables>(CurrentSessionDevicesPageDocument, options);
      }
export function useCurrentSessionDevicesPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CurrentSessionDevicesPageQuery, CurrentSessionDevicesPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CurrentSessionDevicesPageQuery, CurrentSessionDevicesPageQueryVariables>(CurrentSessionDevicesPageDocument, options);
        }
export type CurrentSessionDevicesPageQueryHookResult = ReturnType<typeof useCurrentSessionDevicesPageQuery>;
export type CurrentSessionDevicesPageLazyQueryHookResult = ReturnType<typeof useCurrentSessionDevicesPageLazyQuery>;
export type CurrentSessionDevicesPageQueryResult = Apollo.QueryResult<CurrentSessionDevicesPageQuery, CurrentSessionDevicesPageQueryVariables>;
export const SetUserFeatureOverridesDocument = gql`
    mutation setUserFeatureOverrides($userId: ID!, $featureKeys: [ID!]!, $state: Boolean) {
  setFeatureOverride(userId: $userId, featureKeys: $featureKeys, state: $state) {
    ...experienceManagerFeatureFragment
  }
}
    ${ExperienceManagerFeatureFragmentFragmentDoc}`;
export type SetUserFeatureOverridesMutationFn = Apollo.MutationFunction<SetUserFeatureOverridesMutation, SetUserFeatureOverridesMutationVariables>;

/**
 * __useSetUserFeatureOverridesMutation__
 *
 * To run a mutation, you first call `useSetUserFeatureOverridesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetUserFeatureOverridesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setUserFeatureOverridesMutation, { data, loading, error }] = useSetUserFeatureOverridesMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      featureKeys: // value for 'featureKeys'
 *      state: // value for 'state'
 *   },
 * });
 */
export function useSetUserFeatureOverridesMutation(baseOptions?: Apollo.MutationHookOptions<SetUserFeatureOverridesMutation, SetUserFeatureOverridesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetUserFeatureOverridesMutation, SetUserFeatureOverridesMutationVariables>(SetUserFeatureOverridesDocument, options);
      }
export type SetUserFeatureOverridesMutationHookResult = ReturnType<typeof useSetUserFeatureOverridesMutation>;
export type SetUserFeatureOverridesMutationResult = Apollo.MutationResult<SetUserFeatureOverridesMutation>;
export type SetUserFeatureOverridesMutationOptions = Apollo.BaseMutationOptions<SetUserFeatureOverridesMutation, SetUserFeatureOverridesMutationVariables>;
export const ResetFeaturesDocument = gql`
    mutation ResetFeatures($userId: ID!) {
  clearAllFeatureOverrides(userId: $userId) {
    ...experienceManagerFeatureFragment
  }
}
    ${ExperienceManagerFeatureFragmentFragmentDoc}`;
export type ResetFeaturesMutationFn = Apollo.MutationFunction<ResetFeaturesMutation, ResetFeaturesMutationVariables>;

/**
 * __useResetFeaturesMutation__
 *
 * To run a mutation, you first call `useResetFeaturesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResetFeaturesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resetFeaturesMutation, { data, loading, error }] = useResetFeaturesMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useResetFeaturesMutation(baseOptions?: Apollo.MutationHookOptions<ResetFeaturesMutation, ResetFeaturesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResetFeaturesMutation, ResetFeaturesMutationVariables>(ResetFeaturesDocument, options);
      }
export type ResetFeaturesMutationHookResult = ReturnType<typeof useResetFeaturesMutation>;
export type ResetFeaturesMutationResult = Apollo.MutationResult<ResetFeaturesMutation>;
export type ResetFeaturesMutationOptions = Apollo.BaseMutationOptions<ResetFeaturesMutation, ResetFeaturesMutationVariables>;
export const GetReferralLeaderboardDataDataDocument = gql`
    query getReferralLeaderboardDataData($leaderboardKey: ID!) {
  viewer {
    leaderboard(leaderboardKey: $leaderboardKey) {
      ...referralLeaderboardFragment
    }
  }
}
    ${ReferralLeaderboardFragmentFragmentDoc}`;

/**
 * __useGetReferralLeaderboardDataDataQuery__
 *
 * To run a query within a React component, call `useGetReferralLeaderboardDataDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReferralLeaderboardDataDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReferralLeaderboardDataDataQuery({
 *   variables: {
 *      leaderboardKey: // value for 'leaderboardKey'
 *   },
 * });
 */
export function useGetReferralLeaderboardDataDataQuery(baseOptions: Apollo.QueryHookOptions<GetReferralLeaderboardDataDataQuery, GetReferralLeaderboardDataDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetReferralLeaderboardDataDataQuery, GetReferralLeaderboardDataDataQueryVariables>(GetReferralLeaderboardDataDataDocument, options);
      }
export function useGetReferralLeaderboardDataDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetReferralLeaderboardDataDataQuery, GetReferralLeaderboardDataDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetReferralLeaderboardDataDataQuery, GetReferralLeaderboardDataDataQueryVariables>(GetReferralLeaderboardDataDataDocument, options);
        }
export type GetReferralLeaderboardDataDataQueryHookResult = ReturnType<typeof useGetReferralLeaderboardDataDataQuery>;
export type GetReferralLeaderboardDataDataLazyQueryHookResult = ReturnType<typeof useGetReferralLeaderboardDataDataLazyQuery>;
export type GetReferralLeaderboardDataDataQueryResult = Apollo.QueryResult<GetReferralLeaderboardDataDataQuery, GetReferralLeaderboardDataDataQueryVariables>;
export const GetPal2SessionDocument = gql`
    query getPal2Session {
  currentSession {
    ...PAL2Session
  }
}
    ${Pal2SessionFragmentDoc}`;

/**
 * __useGetPal2SessionQuery__
 *
 * To run a query within a React component, call `useGetPal2SessionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPal2SessionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPal2SessionQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetPal2SessionQuery(baseOptions?: Apollo.QueryHookOptions<GetPal2SessionQuery, GetPal2SessionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPal2SessionQuery, GetPal2SessionQueryVariables>(GetPal2SessionDocument, options);
      }
export function useGetPal2SessionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPal2SessionQuery, GetPal2SessionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPal2SessionQuery, GetPal2SessionQueryVariables>(GetPal2SessionDocument, options);
        }
export type GetPal2SessionQueryHookResult = ReturnType<typeof useGetPal2SessionQuery>;
export type GetPal2SessionLazyQueryHookResult = ReturnType<typeof useGetPal2SessionLazyQuery>;
export type GetPal2SessionQueryResult = Apollo.QueryResult<GetPal2SessionQuery, GetPal2SessionQueryVariables>;
export const SubmitRatePlanOptimizerFeedbackSurveyDocument = gql`
    mutation SubmitRatePlanOptimizerFeedbackSurvey($input: RatePlanOptimizerFeedbackSurveyInput!) {
  RatePlanOptimizerFeedbackSurvey {
    submitRatePlanOptimizerFeedbackSurvey(input: $input) {
      ... on RatePlanOptimizerFeedbackSurvey {
        surveyType
        passedToUtility
        prompts
        responses
      }
      ... on FailureResult {
        errorCode
        errorMessage
      }
    }
  }
}
    `;
export type SubmitRatePlanOptimizerFeedbackSurveyMutationFn = Apollo.MutationFunction<SubmitRatePlanOptimizerFeedbackSurveyMutation, SubmitRatePlanOptimizerFeedbackSurveyMutationVariables>;

/**
 * __useSubmitRatePlanOptimizerFeedbackSurveyMutation__
 *
 * To run a mutation, you first call `useSubmitRatePlanOptimizerFeedbackSurveyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitRatePlanOptimizerFeedbackSurveyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitRatePlanOptimizerFeedbackSurveyMutation, { data, loading, error }] = useSubmitRatePlanOptimizerFeedbackSurveyMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSubmitRatePlanOptimizerFeedbackSurveyMutation(baseOptions?: Apollo.MutationHookOptions<SubmitRatePlanOptimizerFeedbackSurveyMutation, SubmitRatePlanOptimizerFeedbackSurveyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SubmitRatePlanOptimizerFeedbackSurveyMutation, SubmitRatePlanOptimizerFeedbackSurveyMutationVariables>(SubmitRatePlanOptimizerFeedbackSurveyDocument, options);
      }
export type SubmitRatePlanOptimizerFeedbackSurveyMutationHookResult = ReturnType<typeof useSubmitRatePlanOptimizerFeedbackSurveyMutation>;
export type SubmitRatePlanOptimizerFeedbackSurveyMutationResult = Apollo.MutationResult<SubmitRatePlanOptimizerFeedbackSurveyMutation>;
export type SubmitRatePlanOptimizerFeedbackSurveyMutationOptions = Apollo.BaseMutationOptions<SubmitRatePlanOptimizerFeedbackSurveyMutation, SubmitRatePlanOptimizerFeedbackSurveyMutationVariables>;
export const GetRatePlanOptimizerResultDocument = gql`
    query getRatePlanOptimizerResult {
  viewer {
    id
    ratePlanOptimizerResult {
      estimatedAnnualRatePlanSavings
      estimatedCurrentRatePlanAnnualCost
      currentRatePlanCode
      cheapestRatePlanCode
    }
  }
}
    `;

/**
 * __useGetRatePlanOptimizerResultQuery__
 *
 * To run a query within a React component, call `useGetRatePlanOptimizerResultQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRatePlanOptimizerResultQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRatePlanOptimizerResultQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetRatePlanOptimizerResultQuery(baseOptions?: Apollo.QueryHookOptions<GetRatePlanOptimizerResultQuery, GetRatePlanOptimizerResultQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRatePlanOptimizerResultQuery, GetRatePlanOptimizerResultQueryVariables>(GetRatePlanOptimizerResultDocument, options);
      }
export function useGetRatePlanOptimizerResultLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRatePlanOptimizerResultQuery, GetRatePlanOptimizerResultQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRatePlanOptimizerResultQuery, GetRatePlanOptimizerResultQueryVariables>(GetRatePlanOptimizerResultDocument, options);
        }
export type GetRatePlanOptimizerResultQueryHookResult = ReturnType<typeof useGetRatePlanOptimizerResultQuery>;
export type GetRatePlanOptimizerResultLazyQueryHookResult = ReturnType<typeof useGetRatePlanOptimizerResultLazyQuery>;
export type GetRatePlanOptimizerResultQueryResult = Apollo.QueryResult<GetRatePlanOptimizerResultQuery, GetRatePlanOptimizerResultQueryVariables>;
export const RhrMarkSendOffCompleteDocument = gql`
    mutation rhrMarkSendOffComplete($programId: ID!) {
  GoogleRhr {
    markSendOffComplete(programId: $programId) {
      status
      message
    }
  }
}
    `;
export type RhrMarkSendOffCompleteMutationFn = Apollo.MutationFunction<RhrMarkSendOffCompleteMutation, RhrMarkSendOffCompleteMutationVariables>;

/**
 * __useRhrMarkSendOffCompleteMutation__
 *
 * To run a mutation, you first call `useRhrMarkSendOffCompleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRhrMarkSendOffCompleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [rhrMarkSendOffCompleteMutation, { data, loading, error }] = useRhrMarkSendOffCompleteMutation({
 *   variables: {
 *      programId: // value for 'programId'
 *   },
 * });
 */
export function useRhrMarkSendOffCompleteMutation(baseOptions?: Apollo.MutationHookOptions<RhrMarkSendOffCompleteMutation, RhrMarkSendOffCompleteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RhrMarkSendOffCompleteMutation, RhrMarkSendOffCompleteMutationVariables>(RhrMarkSendOffCompleteDocument, options);
      }
export type RhrMarkSendOffCompleteMutationHookResult = ReturnType<typeof useRhrMarkSendOffCompleteMutation>;
export type RhrMarkSendOffCompleteMutationResult = Apollo.MutationResult<RhrMarkSendOffCompleteMutation>;
export type RhrMarkSendOffCompleteMutationOptions = Apollo.BaseMutationOptions<RhrMarkSendOffCompleteMutation, RhrMarkSendOffCompleteMutationVariables>;
export const RhrMarkSendOffDidThisAlreadyDocument = gql`
    mutation rhrMarkSendOffDidThisAlready {
  GoogleRhr {
    markDidEnrollmentAlready {
      status
      message
    }
  }
}
    `;
export type RhrMarkSendOffDidThisAlreadyMutationFn = Apollo.MutationFunction<RhrMarkSendOffDidThisAlreadyMutation, RhrMarkSendOffDidThisAlreadyMutationVariables>;

/**
 * __useRhrMarkSendOffDidThisAlreadyMutation__
 *
 * To run a mutation, you first call `useRhrMarkSendOffDidThisAlreadyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRhrMarkSendOffDidThisAlreadyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [rhrMarkSendOffDidThisAlreadyMutation, { data, loading, error }] = useRhrMarkSendOffDidThisAlreadyMutation({
 *   variables: {
 *   },
 * });
 */
export function useRhrMarkSendOffDidThisAlreadyMutation(baseOptions?: Apollo.MutationHookOptions<RhrMarkSendOffDidThisAlreadyMutation, RhrMarkSendOffDidThisAlreadyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RhrMarkSendOffDidThisAlreadyMutation, RhrMarkSendOffDidThisAlreadyMutationVariables>(RhrMarkSendOffDidThisAlreadyDocument, options);
      }
export type RhrMarkSendOffDidThisAlreadyMutationHookResult = ReturnType<typeof useRhrMarkSendOffDidThisAlreadyMutation>;
export type RhrMarkSendOffDidThisAlreadyMutationResult = Apollo.MutationResult<RhrMarkSendOffDidThisAlreadyMutation>;
export type RhrMarkSendOffDidThisAlreadyMutationOptions = Apollo.BaseMutationOptions<RhrMarkSendOffDidThisAlreadyMutation, RhrMarkSendOffDidThisAlreadyMutationVariables>;
export const CreateAttributeFilterSegmentDocument = gql`
    mutation createAttributeFilterSegment($input: NewAttributeFilterSegmentInput!) {
  SegmentationEngine {
    createAttributeFilterSegment(input: $input) {
      ...attributeFilterSegmentFragment
    }
  }
}
    ${AttributeFilterSegmentFragmentFragmentDoc}`;
export type CreateAttributeFilterSegmentMutationFn = Apollo.MutationFunction<CreateAttributeFilterSegmentMutation, CreateAttributeFilterSegmentMutationVariables>;

/**
 * __useCreateAttributeFilterSegmentMutation__
 *
 * To run a mutation, you first call `useCreateAttributeFilterSegmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAttributeFilterSegmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAttributeFilterSegmentMutation, { data, loading, error }] = useCreateAttributeFilterSegmentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateAttributeFilterSegmentMutation(baseOptions?: Apollo.MutationHookOptions<CreateAttributeFilterSegmentMutation, CreateAttributeFilterSegmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAttributeFilterSegmentMutation, CreateAttributeFilterSegmentMutationVariables>(CreateAttributeFilterSegmentDocument, options);
      }
export type CreateAttributeFilterSegmentMutationHookResult = ReturnType<typeof useCreateAttributeFilterSegmentMutation>;
export type CreateAttributeFilterSegmentMutationResult = Apollo.MutationResult<CreateAttributeFilterSegmentMutation>;
export type CreateAttributeFilterSegmentMutationOptions = Apollo.BaseMutationOptions<CreateAttributeFilterSegmentMutation, CreateAttributeFilterSegmentMutationVariables>;
export const UpdateAttributeFilterSegmentDocument = gql`
    mutation updateAttributeFilterSegment($id: ID!, $input: UpdateAttributeFilterSegmentInput!) {
  SegmentationEngine {
    updateAttributeFilterSegment(id: $id, input: $input) {
      ...attributeFilterSegmentFragment
    }
  }
}
    ${AttributeFilterSegmentFragmentFragmentDoc}`;
export type UpdateAttributeFilterSegmentMutationFn = Apollo.MutationFunction<UpdateAttributeFilterSegmentMutation, UpdateAttributeFilterSegmentMutationVariables>;

/**
 * __useUpdateAttributeFilterSegmentMutation__
 *
 * To run a mutation, you first call `useUpdateAttributeFilterSegmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAttributeFilterSegmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAttributeFilterSegmentMutation, { data, loading, error }] = useUpdateAttributeFilterSegmentMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateAttributeFilterSegmentMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAttributeFilterSegmentMutation, UpdateAttributeFilterSegmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAttributeFilterSegmentMutation, UpdateAttributeFilterSegmentMutationVariables>(UpdateAttributeFilterSegmentDocument, options);
      }
export type UpdateAttributeFilterSegmentMutationHookResult = ReturnType<typeof useUpdateAttributeFilterSegmentMutation>;
export type UpdateAttributeFilterSegmentMutationResult = Apollo.MutationResult<UpdateAttributeFilterSegmentMutation>;
export type UpdateAttributeFilterSegmentMutationOptions = Apollo.BaseMutationOptions<UpdateAttributeFilterSegmentMutation, UpdateAttributeFilterSegmentMutationVariables>;
export const CreateCompoundSegmentDocument = gql`
    mutation createCompoundSegment($input: NewCompoundSegmentInput!) {
  SegmentationEngine {
    createCompoundSegment(input: $input) {
      ...compoundSegmentFragment
    }
  }
}
    ${CompoundSegmentFragmentFragmentDoc}`;
export type CreateCompoundSegmentMutationFn = Apollo.MutationFunction<CreateCompoundSegmentMutation, CreateCompoundSegmentMutationVariables>;

/**
 * __useCreateCompoundSegmentMutation__
 *
 * To run a mutation, you first call `useCreateCompoundSegmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCompoundSegmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCompoundSegmentMutation, { data, loading, error }] = useCreateCompoundSegmentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateCompoundSegmentMutation(baseOptions?: Apollo.MutationHookOptions<CreateCompoundSegmentMutation, CreateCompoundSegmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCompoundSegmentMutation, CreateCompoundSegmentMutationVariables>(CreateCompoundSegmentDocument, options);
      }
export type CreateCompoundSegmentMutationHookResult = ReturnType<typeof useCreateCompoundSegmentMutation>;
export type CreateCompoundSegmentMutationResult = Apollo.MutationResult<CreateCompoundSegmentMutation>;
export type CreateCompoundSegmentMutationOptions = Apollo.BaseMutationOptions<CreateCompoundSegmentMutation, CreateCompoundSegmentMutationVariables>;
export const UpdateCompoundSegmentDocument = gql`
    mutation updateCompoundSegment($id: ID!, $input: UpdateCompoundSegmentInput!) {
  SegmentationEngine {
    updateCompoundSegment(id: $id, input: $input) {
      ...compoundSegmentFragment
    }
  }
}
    ${CompoundSegmentFragmentFragmentDoc}`;
export type UpdateCompoundSegmentMutationFn = Apollo.MutationFunction<UpdateCompoundSegmentMutation, UpdateCompoundSegmentMutationVariables>;

/**
 * __useUpdateCompoundSegmentMutation__
 *
 * To run a mutation, you first call `useUpdateCompoundSegmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCompoundSegmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCompoundSegmentMutation, { data, loading, error }] = useUpdateCompoundSegmentMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCompoundSegmentMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCompoundSegmentMutation, UpdateCompoundSegmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCompoundSegmentMutation, UpdateCompoundSegmentMutationVariables>(UpdateCompoundSegmentDocument, options);
      }
export type UpdateCompoundSegmentMutationHookResult = ReturnType<typeof useUpdateCompoundSegmentMutation>;
export type UpdateCompoundSegmentMutationResult = Apollo.MutationResult<UpdateCompoundSegmentMutation>;
export type UpdateCompoundSegmentMutationOptions = Apollo.BaseMutationOptions<UpdateCompoundSegmentMutation, UpdateCompoundSegmentMutationVariables>;
export const GetAllSegmentTableDataDocument = gql`
    query getAllSegmentTableData($attributeName: String) {
  segmentationEngine {
    segments(attributeName: $attributeName) {
      ... on CodeDefinedSegment {
        ...codeDefinedSegmentFragment
      }
      ... on AttributeFilterSegment {
        ...attributeFilterSegmentFragment
      }
      ... on CompoundSegment {
        ...compoundSegmentFragment
      }
    }
  }
}
    ${CodeDefinedSegmentFragmentFragmentDoc}
${AttributeFilterSegmentFragmentFragmentDoc}
${CompoundSegmentFragmentFragmentDoc}`;

/**
 * __useGetAllSegmentTableDataQuery__
 *
 * To run a query within a React component, call `useGetAllSegmentTableDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllSegmentTableDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllSegmentTableDataQuery({
 *   variables: {
 *      attributeName: // value for 'attributeName'
 *   },
 * });
 */
export function useGetAllSegmentTableDataQuery(baseOptions?: Apollo.QueryHookOptions<GetAllSegmentTableDataQuery, GetAllSegmentTableDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllSegmentTableDataQuery, GetAllSegmentTableDataQueryVariables>(GetAllSegmentTableDataDocument, options);
      }
export function useGetAllSegmentTableDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllSegmentTableDataQuery, GetAllSegmentTableDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllSegmentTableDataQuery, GetAllSegmentTableDataQueryVariables>(GetAllSegmentTableDataDocument, options);
        }
export type GetAllSegmentTableDataQueryHookResult = ReturnType<typeof useGetAllSegmentTableDataQuery>;
export type GetAllSegmentTableDataLazyQueryHookResult = ReturnType<typeof useGetAllSegmentTableDataLazyQuery>;
export type GetAllSegmentTableDataQueryResult = Apollo.QueryResult<GetAllSegmentTableDataQuery, GetAllSegmentTableDataQueryVariables>;
export const GetSegmentEditAttributesDataDocument = gql`
    query getSegmentEditAttributesData($attributeName: String) {
  segmentationEngine {
    attributes(name: $attributeName) {
      ...segmentEditAttributeFragment
    }
  }
}
    ${SegmentEditAttributeFragmentFragmentDoc}`;

/**
 * __useGetSegmentEditAttributesDataQuery__
 *
 * To run a query within a React component, call `useGetSegmentEditAttributesDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSegmentEditAttributesDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSegmentEditAttributesDataQuery({
 *   variables: {
 *      attributeName: // value for 'attributeName'
 *   },
 * });
 */
export function useGetSegmentEditAttributesDataQuery(baseOptions?: Apollo.QueryHookOptions<GetSegmentEditAttributesDataQuery, GetSegmentEditAttributesDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSegmentEditAttributesDataQuery, GetSegmentEditAttributesDataQueryVariables>(GetSegmentEditAttributesDataDocument, options);
      }
export function useGetSegmentEditAttributesDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSegmentEditAttributesDataQuery, GetSegmentEditAttributesDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSegmentEditAttributesDataQuery, GetSegmentEditAttributesDataQueryVariables>(GetSegmentEditAttributesDataDocument, options);
        }
export type GetSegmentEditAttributesDataQueryHookResult = ReturnType<typeof useGetSegmentEditAttributesDataQuery>;
export type GetSegmentEditAttributesDataLazyQueryHookResult = ReturnType<typeof useGetSegmentEditAttributesDataLazyQuery>;
export type GetSegmentEditAttributesDataQueryResult = Apollo.QueryResult<GetSegmentEditAttributesDataQuery, GetSegmentEditAttributesDataQueryVariables>;
export const UsersFirstDeviceClaimFreeDeviceDocument = gql`
    mutation UsersFirstDeviceClaimFreeDevice {
  UsersFirstDevice {
    claimFreeDevice
  }
}
    `;
export type UsersFirstDeviceClaimFreeDeviceMutationFn = Apollo.MutationFunction<UsersFirstDeviceClaimFreeDeviceMutation, UsersFirstDeviceClaimFreeDeviceMutationVariables>;

/**
 * __useUsersFirstDeviceClaimFreeDeviceMutation__
 *
 * To run a mutation, you first call `useUsersFirstDeviceClaimFreeDeviceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUsersFirstDeviceClaimFreeDeviceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [usersFirstDeviceClaimFreeDeviceMutation, { data, loading, error }] = useUsersFirstDeviceClaimFreeDeviceMutation({
 *   variables: {
 *   },
 * });
 */
export function useUsersFirstDeviceClaimFreeDeviceMutation(baseOptions?: Apollo.MutationHookOptions<UsersFirstDeviceClaimFreeDeviceMutation, UsersFirstDeviceClaimFreeDeviceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UsersFirstDeviceClaimFreeDeviceMutation, UsersFirstDeviceClaimFreeDeviceMutationVariables>(UsersFirstDeviceClaimFreeDeviceDocument, options);
      }
export type UsersFirstDeviceClaimFreeDeviceMutationHookResult = ReturnType<typeof useUsersFirstDeviceClaimFreeDeviceMutation>;
export type UsersFirstDeviceClaimFreeDeviceMutationResult = Apollo.MutationResult<UsersFirstDeviceClaimFreeDeviceMutation>;
export type UsersFirstDeviceClaimFreeDeviceMutationOptions = Apollo.BaseMutationOptions<UsersFirstDeviceClaimFreeDeviceMutation, UsersFirstDeviceClaimFreeDeviceMutationVariables>;
export const ViewerFirstLoadDocument = gql`
    query viewerFirstLoad {
  viewer {
    ...brandLogoFields
    features {
      ...experienceManagerFeatureFragment
    }
    ...GoogleRhrSendOffData
  }
  currentSession {
    ...PAL2Session
  }
}
    ${BrandLogoFieldsFragmentDoc}
${ExperienceManagerFeatureFragmentFragmentDoc}
${GoogleRhrSendOffDataFragmentDoc}
${Pal2SessionFragmentDoc}`;

/**
 * __useViewerFirstLoadQuery__
 *
 * To run a query within a React component, call `useViewerFirstLoadQuery` and pass it any options that fit your needs.
 * When your component renders, `useViewerFirstLoadQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useViewerFirstLoadQuery({
 *   variables: {
 *   },
 * });
 */
export function useViewerFirstLoadQuery(baseOptions?: Apollo.QueryHookOptions<ViewerFirstLoadQuery, ViewerFirstLoadQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ViewerFirstLoadQuery, ViewerFirstLoadQueryVariables>(ViewerFirstLoadDocument, options);
      }
export function useViewerFirstLoadLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ViewerFirstLoadQuery, ViewerFirstLoadQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ViewerFirstLoadQuery, ViewerFirstLoadQueryVariables>(ViewerFirstLoadDocument, options);
        }
export type ViewerFirstLoadQueryHookResult = ReturnType<typeof useViewerFirstLoadQuery>;
export type ViewerFirstLoadLazyQueryHookResult = ReturnType<typeof useViewerFirstLoadLazyQuery>;
export type ViewerFirstLoadQueryResult = Apollo.QueryResult<ViewerFirstLoadQuery, ViewerFirstLoadQueryVariables>;